<template>
  <v-container class="scroll-container" fluid>
    <!-- currentStops:{{ currentService.shipment_stop }}
    {{ currentService.shipment_stop ? currentService.shipment_stop.length : 0 }}
    customer address:{{
      shipment && shipment.customer ? shipment.customer.address : ""
    }} -->

    <!-- currrentSchema:{{ currentSchema }} -->

    <v-dialog v-model="showImageDialog" :width="dialogWidth">
      <v-card>
        <v-img :src="selectedImage" max-height="80vh" contain></v-img>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="showImageDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog"
      :key="dialogKey"
      :width="!$vuetify.breakpoint.smAndDown ? dialogWidth : undefined"
      transition="dialog-bottom-transition"
    >
      <v-alert type="info" v-if="loadingCalculation">
        {{ loadingText }}
      </v-alert>
      <v-card
        class="block elevation-3 d-flex flex-column justify-center align-center"
        style="height: 90vh; position:relative "
      >
        <!-- CONTENT -->

        <v-container class="elevation-5" style="position:relative; flex: 1; overflow-y: auto; overflow-x:hidden">
          <!-- SIDE PANEL -->
          <!-- <v-navigation-drawer v-model="sidePanelOpen" absolute right width="320" temporary>
            <div class="pa-3">
              <div class="side-panel">
                <slot v-if="panelFactory">
                  <component :is="panelFactory" />
                </slot>
              </div>
            </div>
          </v-navigation-drawer>
          <v-btn small @click="sidePanelOpen = true">
            Open panel
          </v-btn> -->
          <div v-if="dialog" class="pa-2 ">
            <v-toolbar flat v-if="formControls && formControls.length">
              <v-btn
                v-for="(c, i) in formControls"
                :key="i"
                small
                class="ml-0"
                :ref="c[`id`]"
                :id="c[`id`]"
                v-bind="c[`v-bind`]"
                ><v-icon>{{ c.icon }}</v-icon
                >{{ c.value }}</v-btn
              >
            </v-toolbar>
            <v-form ref="form">
              <v-form-component
                v-if="modelReady && !letterReady && !letters && !customerEstimate"
                ref="formComponent"
                :parentModel="shipment"
                :key="formKey"
                :model="currentModel"
                :vModel="currentModel"
                :schema="currentSchema"
                :mainTabs="currentSchema.mainTabs"
                :noCache="currentSchema.noCache"
                :data_object="{
                  model: model,
                  schema: schema,
                  _id: shipment._id
                }"
              ></v-form-component>
            </v-form>

            <div class="elevation-3 justify-center align-center" v-if="customerEstimate">
              <v-btn color="success" class="ma-2" @click="calculate()">Calculate Estimate</v-btn>
              <h3>Total Estimate: {{ totalEstimate }}</h3>
            </div>

            <v-here-map
              v-if="mapReady"
              :key="mapKey"
              :hideToolbar="false"
              :mapHeight="mapHeight - 420"
              :mapWidth="mapWidth"
              :mapData="mapData"
              ref="hereMap"
            ></v-here-map>
            <div class="ma-2" v-if="currentService && currentService.driving_time && mapReady">
              Driving Time: {{ decimalToTime(currentService.driving_time) }} Hr <br />
              Driving Distance: {{ decimalToTime(currentService.mileage) }} Mi<br />
              Travel Time from Dep: {{ decimalToTime(currentService.travel_time) }} Hr <br />
              Driving Distance from Dep: {{ decimalToTime(currentService.travel_distance) }} Mi<br />
              Travel Time to Dep: {{ decimalToTime(currentService.travel_time_back) }} Hr <br />
              Driving Distance to Dep: {{ decimalToTime(currentService.travel_distance_back) }} Mi<br />
            </div>
            <v-row v-if="letters" dense>
              <v-col v-for="(item, i) in letterList" :key="i" cols="12" sm="6" md="4">
                <v-card class="pa-3  elevation-3 h-100">
                  <v-list-item
                    @click="
                      letterContainer({
                        item: { text: item.itemText, value: item.itemValue, category: item.category }
                      })
                    "
                  >
                    <v-list-item-icon>
                      <v-icon color="primary">mdi-email-arrow-right</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title v-text="item.itemText"></v-list-item-title>
                      <b>{{ item.subject }}</b>
                    </v-list-item-content>
                  </v-list-item>
                </v-card>
              </v-col>
            </v-row>
          </div>
        </v-container>

        <!-- FOOTER ACTIONS STUCK TO BOTTOM -->
        <v-card-actions class="elevation-3 shipment-actions">
          <!-- mapReady:{{ mapReady }} hideSubmit:{{ hideSubmit }} -->

          <v-spacer></v-spacer>
          <v-btn
            v-if="shipmentId && !newShipment && !mapReady && !hideSubmit"
            right
            small
            :text="false"
            :loading="loading"
            @click="submit(null, true)"
            color="success"
            class="save-button ma-2"
          >
            <v-icon class="ma-2">{{ saveButtonIcon }}</v-icon>
            {{ saveButtonCaption }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            class="close-btn"
            @click="
              dialog = 0;
              letterReady = false;
            "
            text
            right
          >
            <v-icon
              @click="
                dialog = 0;
                letterReady = false;
              "
            >
              mdi-close-circle </v-icon
            >Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_" transition="dialog-bottom-transition">
      <v-container
        ><v-icon small class="close-btn" @click="dialog = 0">mdi-close</v-icon>
        <div v-if="dialog" :width="dialogWidth" class="pa-2">
          <v-form-component
            v-if="modelReady && !letterReady"
            :parentModel="shipment"
            :key="formKey"
            :model="currentModel"
            :vModel="currentModel"
            :schema="currentSchema"
            :data_object="{
              model: model,
              schema: schema,
              _id: shipment._id
            }"
          ></v-form-component>

          <v-here-map
            v-if="mapReady"
            :key="mapKey"
            :hideToolbar="false"
            :mapHeight="mapHeight - 420"
            :mapWidth="mapWidth"
            :mapData="mapData"
            ref="hereMap"
          ></v-here-map>
        </div>
      </v-container>
    </v-dialog>
    <div v-if="!$vuetify.breakpoint.lgAndUp">
      <h4
        class="mobile-title"
        v-if="companySelected && shipment && shipment.shipment_detail && shipment.shipment_detail.company"
      >
        {{ shipment && shipment.shipment_detail.company.company_name }}
      </h4>

      <div
        class="pa-2 mobile-title"
        :style="{
          backgroundColor: getStatusColor(),
          color: $root.ajustColor(getStatusColor())
        }"
      >
        <span
          v-if="!$root.customerId && currentService && currentService.service_type && currentService.service_date"
          class="pa-2 "
        >
          {{
            currentService
              ? capitalize(currentService.service_type) + " " + currentService.service_date ||
                currentService.service_date
              : ""
          }}
        </span>

        &nbsp;
        <!-- <v-spacer></v-spacer> -->
        <span class="pa-2">
          {{ shipment && shipment.shipment_detail ? shipment.shipment_detail.status : "" }}
        </span>

        <!-- {{ serviceType }}
        {{ mileage ? mileage + " miles" : "" }} -->
      </div>
    </div>

    <v-toolbar style="position: sticky; top: 0" flat v-if="!$root.customerId">
      <div v-if="$vuetify.breakpoint.lgAndUp">
        <h4
          class="ml-4"
          v-if="companySelected && shipment && shipment.shipment_detail && shipment.shipment_detail.company"
        >
          {{ shipment.shipment_detail.company.company_name }}
        </h4>
        <v-spacer></v-spacer>
        <h4 class="pa-2 shipment-title" v-if="shipmentId">
          <v-icon class="ma-2">{{ getMoveTypeIcon() }}</v-icon>
          <span class="mr-2">Shipment #: {{ shipmentId }}</span>
          <!-- <span v-if="!$root.customerId && !newShipment" class="pa-2 "> -->
          <!-- {{ shipment.shipment_detail.move_type }}
          </span> -->
          <span v-if="currentService">
            {{ capitalize(currentService.service_type || "") }}
          </span>

          <!-- <v-icon small class="ml-2">mdi-calendar-range</v-icon>

          <span v-if="!$root.customerId && !newShipment" class="pt-2 mr-2 ">
            {{ serviceDate }}
          </span> -->
          <v-dialog v-if="!newShipment" v-model="statusDialog" persistent width="600">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                text
                small
                :style="{
                  color: getStatusColor()
                }"
                v-bind="attrs"
                v-on="on"
                ><v-icon class="">mdi-progress-check</v-icon>
                <span class="pa-2">
                  {{ shipment && shipment.shipment_detail ? shipment.shipment_detail.status : "" }}
                </span>
              </v-btn>
            </template>

            <v-card>
              <v-card-title class="text-h5 grey lighten-2">
                Change Shipment Status
              </v-card-title>
              <v-card-text>
                <v-row dense>
                  <v-col v-for="item in sortedStatuses" :key="item.status" cols="6">
                    <v-btn text @click="applyStatus(item)" class="justify-start ma-2">
                      <div
                        :style="{
                          backgroundColor: item.color,
                          width: '12px',
                          height: '12px',
                          borderRadius: '50%',
                          marginRight: '8px'
                        }"
                      ></div>
                      {{ capitalize(item.status) }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>

              <!-- <v-combobox
                label="Status"
                outlined
                dense
                item-text="status"
                item-value="status"
                :items="sortedStatuses"
                v-if="shipment && shipment.shipment_detail"
                v-model="shipment.shipment_detail.status"
              >
                <template v-slot:item="data">
                  <div class="d-flex align-center">
                    <div
                      :style="{
                        backgroundColor: data.item.color,
                        width: '12px',
                        height: '12px',
                        borderRadius: '50%',
                      }"
                      class="mr-2"
                    ></div>
                    <span>{{ data.item.status }}</span>
                  </div>
                </template>
                </v-combobox
              > -->

              <v-divider></v-divider>

              <v-card-actions>
                <v-alert
                  dismissible
                  dense
                  timeout="3000"
                  type="error"
                  v-if="statusError"
                  v-html="statusError"
                ></v-alert>
                <v-spacer></v-spacer>

                <v-btn
                  v-if="!statusError"
                  color="primary"
                  text
                  @click="
                    submit();
                    statusDialog = false;
                  "
                >
                  <v-icon class="ma-2">mdi-check</v-icon>
                  Apply Status
                </v-btn>
                <v-divider></v-divider>
                <v-btn text @click="statusDialog = false">
                  <v-icon class="ma-2">mdi-cancel</v-icon>
                  Cancel
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- {{ serviceType }}
        {{ mileage ? mileage + " miles" : "" }} -->
        </h4>
        <v-spacer></v-spacer>
      </div>
      <div class="ml-auto" v-if="!newShipment">
        <v-tabs class="dense-tabs" v-if="shipmentId" v-show="!allReadOnly" v-model="currentTab">
          <v-tab v-for="(item, i) in toolBarControls" @click="showPanel(item)" :key="i"
            ><v-icon :small="!$vuetify.breakpoint.lgAndUp" class="ma-2">{{ "mdi-" + item.icon }}</v-icon
            ><span v-if="$vuetify.breakpoint.lgAndUp">{{ item.text }}</span></v-tab
          >
          <!-- <v-tab>
            <v-menu-button
              v-if="lettersReady"
              v-show="!allReadOnly"
              id="letters"
              :displayTable="true"
              :hasSearch="true"
              :key="letterKey"
              searchLabel="Search Letters"
              v-bind="letterMenuBtn"
            ></v-menu-button>
          </v-tab> -->
        </v-tabs>
      </div>
      <v-spacer />
      <a v-if="assistantLink" target="_new" class="mt-4" :href="assistantLink">AI Customer Assistant</a>
      <v-spacer />
      <v-switch
        v-if="!shipment.use_wizard && !$root.customerId && !$root.roles.includes('foreman')"
        class="mt-6"
        label="Use Wizard"
        v-model="shipment.use_wizard"
      ></v-switch>
      <v-btn text @click="refreshData()" v-if="!newShipment" small>
        <v-icon class="mt-n3 ma-lg-2" :small="!$vuetify.breakpoint.lgAndUp">mdi-reload</v-icon
        ><span v-if="$vuetify.breakpoint.lgAndUp">Refresh Data</span></v-btn
      >
    </v-toolbar>
    <div :class="{ blurred: loading }" style=" position: relative">
      <v-alert dismissible dense timeout="3000" type="warning" v-if="openShipment" v-html="openShipment"></v-alert>
      <v-alert
        dismissible
        dense
        timeout="3000"
        type="warning"
        v-if="noConnection && no_internet"
        v-html="noConnection"
      ></v-alert>
      <v-dialog v-model="itemDialog" persistent :width="dialogWidth">
        <v-card>
          <v-card-title class="text-h5"> Confirm Item Handling </v-card-title>
          <v-card-text>{{ handlingPrompt }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" text @click="applyHandling"> Yes </v-btn>
            <v-btn
              color="danger"
              text
              @click="
                itemDialog = false;
                currentItemHandlingId = null;
              "
            >
              No
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="letterReady" max-width="80%">
        <v-document ref="doc" v-if="letterReady" v-bind="letterBind" :key="docKey"></v-document>
      </v-dialog>
      <v-dialog
        :is="$vuetify.breakpoint.lgAndUp ? 'v-movable-dialog' : 'v-dialog'"
        ref="moveDialog"
        class="video-dialog"
        v-model="showVisualInventory"
        :close="closeVisualInventory"
        title="Visual Inventory"
        v-if="showVisualInventory"
      >
        <!-- Your custom content here -->
        <!-- {{  shipment.inventory }} -->
        <!-- currentService: {{ currentService }} -->
        <!-- service_date:{{ currentService.service_date }}
        from:{{ currentService.shipment_stop[0].full_address }}
        to:{{ currentService.shipment_stop[1].full_address }} -->
        <!-- currentModel:{{ currentModel }} -->

        <VInventoryVideoUploader
          :shipmentInventory="shipment.inventory"
          :service_date="currentService.service_date"
          :from="currentService.shipment_stop[0].full_address"
          :room="currentRoom"
          :shipmentId="shipmentId"
          :to="currentService.shipment_stop[1].full_address"
          v-model="showVisualInventory"
          v-if="$root.customerId || onsiteEstimate"
        ></VInventoryVideoUploader>

        <visual-inventory
          v-else
          :customer="shipment.customer.contact.first_name + ' ' + shipment.customer.contact.last_name"
          :client_id="shipment.customer.calltools_contact_id"
          :email="shipment.customer.contact.email"
          :customerPhone="
            shipment.customer.contact.phones.mobile ? shipment.customer.contact.phones.mobile.phone_number : ''
          "
          :company="getCompanyName()"
          :companyId="company.company_id"
          :company_id="company._id"
          :comp="true"
          :sendMail="$root.sendMail"
          :sendSMS="$root.sendSMS"
          :uploadVideo="uploadVideo"
          :serverUrl="serverURL"
        ></visual-inventory>
      </v-dialog>
      <!-- :style="{ height: mainPanelWidth() }" -->
      <div ref="mainPanel" :style="{ height: mainPanelHeight() }" class="main-panel">
        <!-- company:{{ company }} -->
        <!-- shipmentDetail:{{ shipmentDetail }} -->
        <!-- shipment:{{ shipment }} -->

        <v-form-component
          v-if="shipment && !shipmentId && (!companySelected || !selectedMoveType)"
          :model="shipmentDetail"
          :schema="companySchema"
        ></v-form-component>
        <!-- <v-form-component
          v-if="!selectedMoveType && !shipmentId"
          :model="selectedMoveType"
          :schema="companySchema"
        ></v-form-component> -->
        <!-- companySelected:{{companySelected}}
        selectedMoveType:{{selectedMoveType}}-->
        <!-- shipmentDetail.shipment_detail:{{ shipmentDetail.shipment_detail }} -->
        <!-- shipmentDetail.shipment_detail.:{{
          shipmentDetail.shipment_detail
        }}
        companySelected:{{ companySelected }} -->
        <!-- shipmentDetail:{{ shipmentDetail }} -->
        <v-btn
          color="info"
          small
          v-if="
            newShipment &&
              shipmentDetail &&
              shipmentDetail.shipment_detail &&
              shipmentDetail.shipment_detail.move_type &&
              shipmentDetail.shipment_detail.company &&
              !wizardStarted
          "
          @click="selectCompany"
          >Continue
        </v-btn>

        <v-shipment-wizard
          v-if="(config && newShipment && wizardStarted) || (!newShipment && shipment.use_wizard)"
          :key="shipmentWizardKey"
          ref="shipmentWizard"
        ></v-shipment-wizard>
        <v-diagram
          v-if="moveDiagramData && companySelected && shipmentId && !newShipment && !shipment.use_wizard"
          :openBlock="openBlock"
          :addCoJob="addCoJob"
          :showMap="showMap"
          :scheduleOnsite="scheduleOnsite"
          :data="moveDiagramData"
          :model="shipment"
          :submit="submit"
          :key="diagramKey"
        ></v-diagram>

        <v-row v-if="!useDiagram">
          <v-col>
            <v-expansion-panels
              flat
              dense
              v-if="companySelected && shownSteps && shownSteps.length"
              v-model="panelIndex"
              @change="panelChange(panelIndex)"
            >
              <v-expansion-panel dense :disabled="panelDisabled(i)" v-for="(item, i) in shownSteps" :key="i">
                <v-expansion-panel-header
                  :hide-actions="panelIndex != i"
                  v-show="panelIndex === -1 || !panelIndex || panelIndex === i"
                >
                  <v-row>
                    <v-col>
                      <v-btn class="justify-start pl-0" text :color="panelIndex === i ? 'info' : ''">
                        <div
                          class="d-flex ma-lg-2 ml-n2 align-center justify-center rounded-circle white--text"
                          :style="iconSize"
                          :class="getIconColor(item)"
                        >
                          <v-icon :small="!$vuetify.breakpoint.lgAndUp" color="white" class="ma-2">{{
                            "mdi-" + item.icon
                          }}</v-icon>
                        </div>
                        <span class="info-title ma-2" v-if="panelIndex === i" v-html="item.title"></span>
                        <span class="item-title" v-if="panelIndex != i" v-html="item.title"></span>
                      </v-btn>
                      <div v-if="panelIndex != i" class="float-container">
                        <div class="pl-1 info-label text-info" v-html="item.info || '(not set)'"></div>
                      </div>
                    </v-col>
                  </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="elevation-3 pa-3">
                  <div class="pa-2">
                    <!-- {{ currentSchema }} -->
                    <!-- {{ currentModel }} -->
                    <!-- schemaProperties:{{ schemaProperties }} -->

                    <v-form ref="form">
                      <v-form-component
                        v-if="modelReady"
                        :key="formKey"
                        :parentModel="shipment"
                        :schema="currentSchema"
                        :model="currentModel"
                        :vModel="currentModel"
                      ></v-form-component>
                      <!-- item.additionalControl:{{ item.additionalControl }} -->
                      <!-- <div
                :key="addControlKey"
                v-if="modelReady && item.additionalControl"
              > -->
                      <!-- item.additionalModel {{ item.additionalModel }} -->
                      <v-form-component
                        v-if="
                          modelReady &&
                            ((item.additionalControl && readOnly) ||
                              (item.additionalControl && item.additionalControl.add_option_object))
                        "
                        :model="item.additionalModel"
                        :vModel="item.additionalModel"
                        :schema="item.additionalControl"
                        :key="addControlKey"
                      ></v-form-component>
                      <!-- </div> -->

                      <!-- <div v-if="item.additionalSchema">

                <v-form-component
                  :vModel="item.model"
                  :model="item.model"
                  :schema="item.additionalSchema"
                  :parentModel="shipment"
                ></v-form-component>


                <div v-if="item.additionalControl">
                  <v-form-component
                    :model="item.additionalControl"
                    :schema="item.additionalControl"
                  ></v-form-component>
                </div>
              </div> -->
                    </v-form>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>

          <!-- <v-col :cols="mapCols" v-if="mapReady" class="ma-2">
            <v-here-map
              :key="mapKey"
              :hideToolbar="false"
              :mapHeight="mapHeight - 350"
              :mapWidth="mapWidth"
              :mapData="mapData"
              ref="hereMap"
            ></v-here-map
          ></v-col> -->
        </v-row>

        <!-- <v-app-bar bottom app dense>
          <v-col class="text-center" cols="12">
            <v-alert class="ma-2" dismissible dense timeout="3000" v-if="errorMessage" type="error">
              {{ errorMessage }}
            </v-alert>

            <v-row flat v-if="companySelected && (panelIndex || panelIndex == 0) && panelIndex != -1">
              <v-col>
                <v-btn
                  v-if="shipmentId && !newShipment && !mapReady && !hideSubmit"
                  right
                  small
                  :text="false"
                  :loading="loading"
                  @click="submit(null, true)"
                  color="success"
                  class="save-button ma-2"
                >
                  <v-icon class="ma-2">{{ saveButtonIcon }}</v-icon>
                  {{ saveButtonCaption }}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-app-bar> -->
      </div>
      <!-- Sliding Panel -->
      <!-- <transition name="fade-transition"> -->

      <!-- <v-dialog
        elevation-5
        transition="dialog-bottom-transition"
        v-model="dialog"
        class="panel mr-4"
      >
        <v-divider></v-divider>
        <v-container class="panel-form"
          ><v-icon small class="close-btn" @click="dialog = 0"
            >mdi-close</v-icon
          >
          <div v-if="dialog" :width="dialogWidth" class="pa-2">
            <v-form-component
              v-if="modelReady && !letterReady"
              :parentModel="shipment"
              :key="formKey"
              :model="currentModel"
              :vModel="currentModel"
              :schema="currentSchema"
              :data_object="{
                model: model,
                schema: schema,
                _id: shipment._id,
              }"
            ></v-form-component>

            <v-here-map
              v-if="mapReady"
              :key="mapKey"
              :hideToolbar="false"
              :mapHeight="mapHeight - 420"
              :mapWidth="mapWidth"
              :mapData="mapData"
              ref="hereMap"
            ></v-here-map>
          </div>
        </v-container>
      </v-dialog> -->
      <!-- </transition> -->
    </div>
  </v-container>
</template>

<script>
/* eslint-disable vue/no-unused-components */

import axios from "axios";
import * as fun from "../plugins/common";
export default {
  name: "Shipment",
  components: {
    VDocument: () => import("../components/Document.vue"),
    VMenuButton: () => import("../components/MenuButton.vue"),
    VFormComponent: () => import("../components/FormComponent.vue"),
    VMovePlan: () => import("../components/MovePlan.vue"),
    VCombo: () => import("../components/ComboBox.vue"),
    VShipmentMenuItems: () => import("../components/ShipmentMenuItems.vue"),
    VisualInventory: () => import("../components/VisualInventory.vue"),
    VLabelButton: () => import("../components/LabelButton.vue"),
    VLoader: () => import("../components//UI/Loader.vue"),
    VTakePhoto: () => import("../components/TakePhoto.vue"),
    VMovableDialog: () => import("../components/MovableDialog.vue"),
    VFormCard: () => import("../components/FormCard.vue"),
    VHereMap: () => import("../components/HereMap.vue"),
    VInventoryVideoUploader: () => import("../components/InventoryVideoUploader.vue"),
    VDiagram: () => import("../components/Diagram.vue"),
    VShipmentWizard: () => import("../components/ShipmentWizard.vue"),
    VStreetView: () => import("../components/StreetView.vue")
  },
  props: {},
  data() {
    return {
      dialogtest: false,
      schemaProperties: null,
      openShipment: "",
      mapCols: null,
      dialogWidth: 0,
      lettersReady: false,
      allReadOnly: false,
      shipmentObject: null,
      mapData: [],
      unparsedAddresses: [],
      mapHeight: 0,
      foreman: false,
      mapWidth: 0,
      files: [],
      statusError: "",
      loadingElements: [document.getElementsByClassName("row")[0]],
      loadingText: "Calculating charges...",
      loading: false,
      loadingCalculation: false,
      mapReady: false,
      allLocations: [],
      currentTab: null,
      letterReady: false,
      letterBind: null,
      letterList: [],
      letters: false,
      currentRoom: "",
      wizardStarted: false,
      formControls: [],
      selectedCompany: {
        shipment_detail: {}
      },
      selectedMoveType: null,
      defaultDialog: {
        text: "CRM",
        icon: "mdi-face-agent",
        hideIfForeman: true,
        hidden: this.$root.customerId
      },
      sidePanelOpen: false,
      panelFactory: null,
      addControlKey: 0,
      companyName: "",
      multiCompany: true,
      companySelected: false,
      companySchema: null,
      moveTypeSchema: null,
      companyModel: null,
      serviceType: "",
      panelHeader: "",
      serviceIndex: 0,
      mileage: "",
      handlingPrompt: "",
      hideSubmit: false,
      inventoryTable: null,
      shipmentId: "",
      saveButtonIcon: "mdi-check",
      saveButtonCaption: "Submit",
      shipment: {},
      additionalModel: {},
      additionalStructure: {},
      itemDialog: false,
      schemaReady: false,
      panelIndex: -1,
      formKey: 0,
      diagramKey: 0,
      modelReady: false,
      noValidate: false,
      company: null,
      showImageDialog: false,
      selectedImage: null,
      numItems: 0,
      currentStopType: "",
      statusDialog: false,
      showVisualInventory: false,
      mainService: null,
      currentService: null,
      dialog: false,
      menuItem: null,
      eventAssigned: false,
      readOnly: false,
      formContainer: {},
      originalModel: null,
      modifiedRecords: [],
      moreData: null,
      dialogKey: 0,
      totalEstimate: 0,
      balance: 0,
      onsiteEstimate: false,
      warehouseAddresses: [],
      shownSteps: [],
      moveDiagramData: null,
      panelOpen: true, // Panel open by default
      panelType: "notes", // Default panel content
      config: null,
      useDiagram: true,
      shipmentWizardKey: 0,
      currentCRMItemId: "",
      shipmentDetail: {},
      allStops: [],
      defaultTypeOfMove: "",
      lastCalculationBy: "",
      aiChatData: [],
      noConnection: "",
      no_internet: false,
      crmTypes: [
        {
          caption: "Actions",
          name: "type",
          value: "action",
          color: "blue",
          hiddenHeaders: ["status"]
        },
        {
          caption: "Notes",
          name: "type",
          value: "note",
          color: "black",
          hiddenHeaders: ["action", "action_date_time", "status"],
          renameHeaders: [
            {
              description: "Note"
            }
          ]
        },
        {
          caption: "History",
          name: "type",
          value: "history",
          color: "red",
          hiddenHeaders: ["action", "action_date_time", "status"]
        },
        {
          caption: "Status Changed",
          name: "type",
          value: "status",
          color: "green",
          hiddenHeaders: ["action", "action_date_time"]
        }
      ],
      wizardSteps: [
        {
          icon: "account-outline",
          id: "customer",
          obj: "customer",
          objectName: "customer",
          schema: {
            contact: {
              password: { hidden: true },
              note: { hidden: true }
            },
            comments: { hidden: true },
            link: { hidden: true },
            address: { hidden: true },
            credit_card: { hidden: true }
          },
          title: "Customer",
          hidden: this.$root.customerId,
          foremanReadOnly: true
        },
        // {
        //   icon: "account-details",
        //   id: "order_detail",
        //   obj: "order_detail",
        //   objectName: "shipment",
        //   title: "Order Detail",
        //   onlyFields: ["shipment_number"],

        // },
        {
          icon: "home-export-outline",
          id: "pickup",
          obj: "pickup",
          objectName: "address",
          title: "Pickup",
          foremanReadOnly: true
        },
        {
          icon: "home-import-outline",
          id: "dropoff",
          obj: "dropoff",
          objectName: "address",
          title: "Dropoff",
          foremanReadOnly: true
        },
        {
          id: "job",
          icon: "truck",
          obj: "job",
          tab: 1,
          objectName: "shipment_service",
          title: "Jobs Schedule",
          foremanReadOnly: true,
          totalLetters: 0,
          onlyFields: [
            "service_type",
            "service_date",
            "latest_pickup_time",
            "pickup_date_range",
            "delivery_date_range",
            "special_instructions",
            "status",
            "booked",
            // "driving_time",
            // "mileage",
            // "itinerary",

            "shipment_stop",
            "num_men",
            "job_hrs",
            "t_time"

            // "suggested_cojobs",
          ]
        },
        // {
        //   id: "additional_services",
        //   icon: "human-dolly",
        //   obj: "additional_services",
        //   objectName: "additional_services",
        //   title: "Additional Services",

        //   // onlyFields: [
        //   //   "service_date",
        //   //   "pickup_date_range",
        //   //   "delivery_date_range",
        //   //   // "suggested_cojobs",
        //   // ],
        // },
        {
          icon: "sofa-outline",
          id: "inventory",
          obj: "inventory",
          objectName: "inventory",
          title: "Inventory"
          // schema: {
          //   service_date: {
          //     hideInTable: true,
          //   },
          // },
        },
        {
          icon: "human-dolly",
          id: "resources",
          obj: "resources",

          objectName: "shipment_service",
          title: "Resources Requested",
          onlyFields: ["resources"],
          hidden: this.$root.customerId,
          hideIfForeman: true
        },
        {
          icon: "calendar-edit",
          id: "onsite_estimate",
          obj: "onsite_estimate",
          objectName: "onsite_estimate",

          tab: 0,
          title: "Onsite Estimates",
          hidden: this.$root.customerId,
          hideIfForeman: true
        },
        {
          icon: "archive-lock",
          id: "storage",
          obj: "storage",
          objectName: "storage",

          tab: 0,
          title: "Storage",
          hidden: this.$root.customerId,
          hideIfForeman: true,
          onlyFields: ["storage_id", "moved_in_date", "warehouse"]
        },
        {
          icon: "calculator-variant-outline",
          id: "estimate",
          obj: "estimate",
          objectName: "shipment_service",

          tab: 0,
          title: "Estimated Charges",
          hidden: this.$root.customerId,
          hideIfForeman: true,
          onlyFields: [
            "estimate_charges",
            "flat_rate",
            "is_flat_rate",
            "rate",
            "charge_by",
            "calculate_by",
            "total_estimate"
          ]
        },
        {
          icon: "details",
          id: "details",
          obj: "details",
          objectName: "shipment_service",
          title: "Job Details",
          hidden: this.$root.customerId,
          onlyFields: ["special_instructions", "status", "service_type", "shipment_stop"]
          // schema: {
          //   service_date: {
          //     hideInTable: true,
          //   },
          // },
        },
        // {
        //   icon: "email-multiple-outline",
        //   id: "letters",
        //   obj: "shipment_service",
        //   objectName: "shipment_service",
        //   title: "Letters and  Documents",
        // },
        {
          icon: "cash-multiple",
          id: "payment",
          obj: "payment",
          hidden: this.$root.customerId,
          hideIfForeman: true,
          objectName: "payment",
          title: "Payment"
        },
        {
          icon: "cash-minus",
          id: "expense",
          obj: "expense",
          hidden: this.$root.customerId,
          hideIfForeman: true,
          objectName: "expense",
          title: "Expense"
        },
        {
          icon: "calendar-multiple-check",
          id: "booking",
          obj: "booking",
          hidden: this.$root.customerId,
          hideIfForeman: true,
          objectName: "shipment_service",
          onlyFields: [
            "service_date",
            // "service_type",
            "booked",
            "booked_by",
            "booked_date"
          ],
          title: "Booking"
        },
        {
          icon: "truck-delivery",
          id: "itinerary",
          obj: "itinerary",
          // hidden: true,
          objectName: "itinerary",
          hideIfForeman: true,
          hidden: this.$root.customerId,
          // onlyFields: ["booked", "booked_by", "booked_date"],
          title: "Itinerary"
        },
        {
          icon: "store-clock",
          id: "crew_employee",
          obj: "crew_employee",
          objectName: "crew_employee",
          hidden: true,
          // schema: {
          //   contact: {
          //     password: { hidden: true },
          //     note: { hidden: true },
          //   },
          //   comments: { hidden: true },
          //   link: { hidden: true },
          //   address: { hidden: true },
          //   credit_card: { hidden: true },
          // },
          title: "Employee Hours"
        }
      ],
      //      <v-btn text>Letters and Documents</v-btn>
      // <v-btn text>CRM</v-btn>
      // <v-btn text>Attachments</v-btn>
      toolBarControls: [
        // { text: "Letters and Documents", icon: "mdi-email-multiple-outline" },
        // { text: "CRM", icon: "face-agent", hideIfForeman: true },
        // { text: "Attachments", icon: "attachment" },
        // { text: "Order Detail", icon: "account-details", hideIfForeman: true },
        // { text: "Map", icon: "map", hideIfForeman: false },
      ],
      letterKey: 0,
      letterMenuBtn: null,
      fixedModel: null,
      defaultModelClone: null,
      customerSchema: null,
      activate: false,
      fullscreen: false,
      defaultModel: {
        use_wizard: true,
        customer: {
          type_of_customer: "residential",
          contact: {
            phones: {
              mobile: {
                phone_type: "mobile"
              }
            }
          },
          address: []
        },
        inventory: [],
        num_items: 0,
        // shipment_detail: {
        //   company: "1d023118cc43086f105ee3ac",
        // },
        stops: [],
        payment: [],
        shipment_detail: {
          status: "new"
        },
        estimate: {
          "non-binding": {
            shipment_service: [
              {
                // service_type: "long_distance_moving",
              }
            ]
          }
        },
        attachments: {}
      },
      schema: {},
      currentObject: "",
      obj_name: "shipment",
      newShipment: false,
      calculated: false,
      currentBlock: null,
      currentUser: {},
      groupageName: "",
      saving: false,
      onDemandComponentDefaultValues: null,
      onDemandComponentDefaultValuesChanged: false,
      onDemandComponentUpdateSchema: {
        properties: {
          shipments: {
            "v-bind": {
              linkClick: this.linkClick,
              link: {
                field: "shipment_id",
                name: "shipment"
              },
              fields_included: ["shipment_id", "customer_name", "service_date", "address", "volume", "weight"]
            }
          }
        }
      }
    };
  },
  activated() {
    //
    if (!this.activate) {
      if (!this.$router.currentRoute.params.id) {
        // this.init();
        this.shipmentId = null;
        this.assignEvents();
        // this.$router.go(0);
        this.$router.replace({
          path: this.$route.path,
          query: this.$route.query
        });
      } else {
        if (!this.shipment.customer._id) {
          this.panelIndex = -1;
          this.refreshData();
        }
        //
      }
    }

    // console.log(this.shipmentId);
    if (this.$refs.hereMap) {
      this.$refs.hereMap.initMap();
    }
  },
  created() {
    // this.assignEvents();
  },
  mounted() {
    window.__vue__ = this;
    this.no_internet = this.$root.no_internet;
    window.openImage = this.openImage.bind(this);
    if (this.$root.customerId && this.$route.params.id == "0") {
      console.log(this.$root.customerId);
      const url = "get_data";
      const data = {
        object_name: "customer",
        qry: {
          _id: this.$root.customerId.$oid
        }
      };
      axios
        .post(this.serverURL + "/" + url, data, {
          withCredentials: true
        })
        .then(response => {
          this.defaultModel.customer = response.data.model[0];
          this.mount();
        });

      //
    } else {
      this.mount();
    }
  },
  beforeDestroy() {},
  methods: {
    openPanel(factory) {
      this.panelFactory = factory;
      this.sidePanelOpen = true;
    },
    linkClick: function(item) {
      if (!item.customer_name) {
        item.customer_name = item.first_name + " " + item.last_name;
      }
      if (item.event) {
        item.shipment_id = item.event.shipment_id;
        item.customer_name = item.event.name.replace(item.shipment_id, "").trim();
      }
      this.$root.addResentTab(item);
    },
    openImage(src) {
      this.selectedImage = src;
      this.showImageDialog = true;
    },
    applyStatus(item) {
      this.statusAllowed(item.status);

      if (!this.statusError) {
        this.shipment.shipment_detail.status = item.status;
        this.shipment.shipment_detail.status_date_changed = new Date();
      }
    },
    statusAllowed(status) {
      // return `${status}  not allowed`;
      this.statusError = "";
      var crmTasks = this.shipment.crm.filter(c => {
        return c.task_id;
      });
      crmTasks.forEach(t => {
        var task = this.additionalModel.task.find(s => {
          return s._id == t.task_id;
        });
        if (task && task.lead_status_restricted && !t.completed) {
          if (task.lead_status_restricted.includes(status)) {
            this.statusError = `${task.task_description} in order to apply status ${status}`;
          }

          console.log(task);
        }
      });
      return;
    },
    mainPanelHeight() {
      // this.$nextTick(() => {
      // if (this.$refs.mainPanel) {
      //   return this.$refs.mainPanel.getBoundingClientRect().height + "px";
      // }
      return "72vh";
      // });
    },
    mount() {
      var that = this;
      this.loading = true;
      // window.onAddressChange = this.onAddressChange;
      // this.currentUser = {
      //   _id: this.$root.user_id,
      //   email: this.$root.user_email
      // };

      this.activate = true;
      if (this.$vuetify.breakpoint.lgAndUp) {
        this.currentTab = 0;
      } else {
        this.currentTab = 4;
      }

      if (this.$root.roles.includes("foreman")) {
        this.foreman = true;
      }
      if (this.foreman) {
        this.toolBarControls = this.toolBarControls.filter(t => {
          return !t.hideIfForeman;
        });
      }
      // this.loadWizard();
      this.mapHeight = window.innerHeight - 80;
      if (!this.$vuetify.breakpoint.lgAndUp) {
        this.mapWidth = window.innerWidth - 10;
        this.dialogWidth = window.innerWidth - 10;
      } else {
        this.dialogWidth = screen.width * 0.65;
        this.mapWidth = window.innerWidth * 0.65;
      }

      // this.mapReady = true;
      this.assignEvents();
      this.eventAssigned = true;

      this.init();
      this.refreshData();
      if (!this.defaultModelClone) {
        this.defaultModelClone = fun.clone(this.defaultModel);
      }
    },
    refreshBlock() {
      this.dialog = false;
      this.openBlock(this.currentBlock);
    },
    openBlock(block, parent, noDialog) {
      if (block.noForemanEdit && this.$root.roles.includes("foreman")) {
        return;
      }
      if (this.currentBlock?.parent == block) {
        this.currentBlock.parent = null;
        return;
      }
      if (block.objectName == "storage") {
        var storage_id = this.shipment.storage?._id;
        if (!storage_id || storage_id == "0") {
          storage_id = "0-" + this.shipment._id;
        }
        var item = {
          icon: "mdi-lock",
          text: "Storage " + storage_id,
          storage_id: storage_id,

          link: "/storage/" + storage_id,

          permitted: true
        };
        this.$root.addResentTab(item);
        return;
      }
      this.currentBlock = block;
      this.currentBlock.parent = parent;
      this.customerEstimate = false;
      this.mapReady = false;
      if (block.id == "letters") {
        this.dialog = true;
        this.letters = true;
        return;
      }
      this.letters = false;
      var wizardStep = this.getWizardStep(block.id?.split("_")[0]);
      if (!wizardStep) {
        return;
      }
      // console.log(wizardStep);
      wizardStep.id = block.id;
      wizardStep.index = null;
      wizardStep.title = block.title;
      wizardStep._id = block._id;
      wizardStep.objName = block.objName;
      if (block.recordId) {
        wizardStep.recordId = block.recordId;
      }
      if (parent) {
        wizardStep.parent = parent;
      }
      if (block.add) {
        wizardStep.add = true;
      }
      if (block.isWizard) {
        wizardStep.isWizard = true;
      }

      this.loadModel(wizardStep);

      if (!noDialog) {
        this.dialog = true;
        this.dialogKey = !this.dialogKey;
      } else {
        return {
          currentModel: this.currentModel,
          currentSchema: this.currentSchema
        };
      }
    },
    checkPermissions() {
      var permittedActions = this.$root.store.permittedActions;
      // var filterJobs = false;
      // var noBooked = false;
      // var filterCompany = false;
      var that = this;
      if (permittedActions) {
        permittedActions.forEach(a => {
          // console.log(a);
          if (a.read_only_unassigned && that.$root.user_email != that.shipment.shipment_detail.sales_person.email) {
            this.allReadOnly = true;
          }
        });
      }
      if (this.allReadOnly) {
        this.getWizardStep("details").onlyFields = ["special_instructions", "status", "service_type"];
      }
    },
    uploadVideo(data) {
      var that = this;
      data.append("object_name", "shipment");
      data.append("record_id", this.shipment.shipment_id);
      data.append("dropbox", true);
      data.append("portal", "portal_" + this.$store.state.auth.portal.portal_id);

      axios.post(this.serverURL + "/upload_file", data);
      that.successMessage = "Video has been sent to dropbox. It make take few minites to finish uploading";
    },
    calculateSize(obj, path) {
      // Function to safely access a nested property
      const getNestedProperty = (obj, pathArray) => {
        return pathArray.reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), obj);
      };

      try {
        // Ensure the path is an array
        const pathArray = typeof path === "string" ? path.split(".") : path;

        // Get the target object
        const targetObject = getNestedProperty(obj, pathArray);

        if (targetObject === undefined) {
          return "Property does not exist";
        }

        // Calculate the size of the object
        const objectSizeInBytes = Buffer.byteLength(JSON.stringify(targetObject), "utf-8");
        const objectSizeInKB = objectSizeInBytes / 1024;
        console.log(targetObject, objectSizeInKB.toFixed(2));
        // return {
        //   bytes: objectSizeInBytes,
        //   kilobytes: objectSizeInKB.toFixed(2),
        // };
      } catch (error) {
        console.error("Error calculating size:", error);
        return "Error occurred";
      }
    },
    getBiggestObject(response) {
      const jsonData = response.data;
      const jsonString = JSON.stringify(response.data.model[0]);

      // Calculate the size of the string in bytes
      const dataSizeInBytes = Buffer.byteLength(jsonString, "utf-8"); // Size in bytes

      // Convert bytes to kilobytes
      const dataSizeInKB = dataSizeInBytes / 1024;

      // console.log(`Model size: ${dataSizeInKB.toFixed(2)} KB`);

      // // Function to get the size of an object
      // const getObjectSize = (obj) =>
      //   Buffer.byteLength(JSON.stringify(obj), "utf-8");

      // let largestObject = null;
      // let largestSize = 0;

      // // Safe way to check if a property exists on an object
      // const hasOwnProperty = (obj, prop) =>
      //   Object.prototype.hasOwnProperty.call(obj, prop);

      // // Iterate through the top-level keys of the JSON object
      // for (const key in jsonData) {
      //   if (hasOwnProperty(jsonData, key)) {
      //     const value = jsonData[key];

      //     // Check if the value is an object or array
      //     if (typeof value === "object" && value !== null) {
      //       const currentSize = getObjectSize(value);
      //       if (currentSize > largestSize) {
      //         largestSize = currentSize;
      //         largestObject = { key, data: value };
      //       }
      //     }
      //   }
      // }

      // console.log(`Largest object/array key: ${largestObject.key}`);
      // console.log(`Size: ${(largestSize / 1024).toFixed(2)} KB`);
      // console.log("Largest object/array:", largestObject.data);
    },
    editCRMAction(item) {
      this.openBlock({
        id: "crm",
        title: item.description,
        recordId: item._id
      });
    },
    getCRMAction(item) {
      console.log(item);
      if (item.upload) {
        this.openBlock({
          id: "attachments",
          title: item.description
        });
        this.currentCRMItemId = item._id;
        //
      } else {
        if (item.type == "reminder") {
          this.$root.$confirm.open(`Complete ${item.type}?`, item.description).then(confirm => {
            if (confirm) {
              this.shipment.crm.find(c => {
                return c._id == item._id;
              }).completed = true;
              this.submit();
            }
          });
        }
      }
    },

    getCustomProperties(block) {
      try {
        var objName = block.objectName;
        var schema = this.getSchema(block);
        // console.log(schema);
        var customProperties = fun.getObjectsKeysAndPath(schema, "portal_id", this.$root.portal_id);
        var curModel = this.getModel(block);
        // console.log(customProperties);
        // if (Array.isArray(curModel[objName]) && curModel[objName].length) {
        switch (block.objectName) {
          case "address":
            curModel = curModel[objName].find(m => {
              return m.value == block.id;
            });
            break;
          // case "shipment_service":
          //   curModel = curModel[objName].find(m => {
          //     return m.value == block.id;
          //   });
          //   break;
          default:
            if (block.obj == "itinerary") {
              curModel = curModel[block.obj];
            } else {
              if (Array.isArray(curModel)) {
                curModel = curModel[0];
              } else {
                curModel = curModel[objName];
              }
            }
        }

        // curModel = curModel[objName][0];
        // } else {
        //   curModel = curModel[block.obj || objName][0];
        // }
        if (Array.isArray(curModel)) {
          curModel = curModel[0];
        }
        customProperties = [...new Set(customProperties)];
        customProperties.forEach(p => {
          var curProperty = fun.getObjectByKey(schema[objName].properties, p);

          if (curProperty && !curProperty.removed && !curProperty.hidden && !curProperty.hideInBlock) {
            var title = curProperty?.title || fun.capitalize(p);
            var value = fun.getObjectByKey(curModel, p) || curModel[p];
            if (curProperty["x-display"] == "v-switch") {
              if (value == "true") {
                value = "Yes";
              }
              if (!value || value == "false") {
                value = "No";
              }
            }

            if (
              value &&
              !block.details.some(d => {
                return d.title == title;
              })
            ) {
              if (block?.objectName != "inventory") {
                block.details.push({
                  title: title,
                  value: value
                });
              }
            }
          }
        });
        return block.details;
      } catch (error) {
        // console.log(error)
        // console.log(block)
        return block.details;
      }
    },
    buildDiagramFromShipmentFromConfig() {
      const config = this.config;

      const rows = [];
      const connections = [];
      const shipment = this.shipment;
      const shipmentStops = this.shipmentStops();

      if (shipmentStops.length > 2) {
        //move rows down
        Object.keys(config.components).forEach(c => {
          if (c != "customer") {
            config.components[c].row += 1;
          }
        });
      }

      const getValue = (path, fallback = "Missing") => {
        try {
          return path.split(".").reduce((obj, key) => (obj ? obj[key] : undefined), shipment) ?? fallback;
        } catch {
          return fallback;
        }
      };
      const that = this;
      const buildBlock = (id, def) => {
        let block = {
          id,
          title: def.title || fun.capitalize(id),
          icon: def.icon || "mdi-alert",
          color: def.color || "#ccc",
          details: [],
          objectName: def.objectName,
          component: def.component,
          noCustomer: def.noCustomer,
          move_type: def.move_type,
          noForemanEdit: def.noForemanEdit,
          hideIfForeman: def.hideIfForeman,
          hide: def.hide
        };
        var rowIdx = null;
        try {
          this.getCustomProperties(block);
        } catch (e) {
          // console.log(e);
          //
        }

        switch (id) {
          case "customer": {
            const contact = shipment.customer?.contact || {};
            var customerName = shipment.customer?.company
              ? shipment.customer.company
              : `${contact.first_name} ${contact.last_name}`;

            let phones = [];

            block.details = [
              {
                title: "Name",
                icon: "mdi-badge-account-horizontal-outline",
                value: customerName,
                // color: "green",
                main: true
              }
            ];
            Object.keys(contact.phones).forEach(p => {
              block.details.push({
                title: "Phone",
                icon: "mdi-phone",
                // color: "orange",
                value: contact.phones[p].phone_number + " (" + contact.phones[p].phone_type + ")"
              });
            });
            (contact.email || "").split(",").forEach(e => {
              block.details.push({ title: "Email", icon: "mdi-email", value: e });
            });

            block.containers = def.containers;
            break;
          }

          case "shipment_detail":
            {
              block.details = [
                {
                  // icon: "mdi-account-clock",
                  title: "Order Date Time",
                  value: shipment?.shipment_detail?.order_date_time
                },
                {
                  title: "Created By",
                  value: this.getSalesPerson()
                },
                // {
                //   title: "Order Date/Time",
                //   value: shipment?.shipment_detail?.order_date_time
                // },
                { title: "Source", value: shipment?.customer?.source || "Missing" }
              ];
              if (shipment?.shipment_detail?.customer_comments) {
                block.details.push({
                  title: "Customer Comments",
                  value: shipment.shipment_detail.customer_comments,
                  color: "red"
                });
              }
            }

            break;
          case "shipment_info": {
            const status = this.additionalModel.international_shipment_status?.find(t => {
              return t.status == this.shipment.shipment_info?.status;
            });
            if (status) {
              def.color = status.color;
            }
            try {
              block.details = [
                {
                  title: "Shipment Name",
                  value: that.moreData?.v_international_shipment_with_jobs[0]?.shipment_name || "Missing"
                },
                {
                  title: "Import/Export",
                  value: that.moreData?.v_international_shipment_with_jobs[0]?.export_import || "Missing"
                }
                // {
                //   title: "Type of Shipment",

                //   value: this.shipment.shipment_info?.type_of_shipment || "Missing"
                // }
                // //freight_forwarder
                // {
                //   title: "Freight Forwarder",

                //   value:
                //     this.shipment.shipment_info?.freight_forwarder?.company ||
                //     "Missing",
                // },
                // //agent_at_destination
                // {
                //   title: "Agent at Destination",

                //   value:
                //     this.shipment.shipment_info?.agent_at_destination?.company ||
                //     "Missing",
                // },
              ];
            } catch (e) {
              //
            }
            const count = that.shipment.shipment_info?.tasks_completed?.length ?? 0;

            const requiredCount =
              that.shipment.shipment_info?.tasks_required?.filter(v => typeof v === "string").length ?? 0;
            if (!requiredCount || requiredCount < that.additionalModel.international_shipment_task?.length) {
              const pending = that.additionalModel.international_shipment_task?.length - requiredCount;
              block.details.push({
                icon: "mdi-alert",
                color: "orange",
                value: ` ${pending} Documents Missing`
              });
              this.shipment.shipment_info.document_status = `${pending} Documents Missing`;
            } else {
              block.details.push({
                icon: "mdi-check-circle",
                color: "green",
                value: "Documents Completed"
              });
            }

            break;
          }

          case "crm": {
            shipment.crm?.sort((a, b) => new Date(b.time_stamp) - new Date(a.time_stamp));
            const crmEntry = Array.isArray(shipment?.crm) ? shipment.crm[0] : null;
            const colors = that.schema.properties.properties.crm["v-bind"].colors;
            const color = colors.find(c => {
              return c?.type == crmEntry?.type;
            });

            if (crmEntry?.description) {
              block.details = [
                // {
                //   title: "Last Action",
                //   value: `${crmEntry.type}: ${crmEntry.description}`
                // },

                {
                  icon: eval(color?.icon) || "mdi-account-clock",
                  // color: color?.color || "",
                  value: `${crmEntry?.type}: ${crmEntry?.description
                    .replaceAll("\n\n", "<br/>")
                    .replaceAll("\n", "<br/>")} <br/>${crmEntry?.time_stamp}<br/> ${crmEntry?.user?.email ||
                    crmEntry?.user ||
                    ""}`
                }
              ];
            }

            break;
          }

          // case "pickup":
          // case "dropoff": {
          //   // this.createServiceStops()
          //   // block.details = stops.map((s) => ({
          //   //   title: `#${s.stop_number}`,
          //   //   value: s.full_address || "Missing",
          //   // }));

          //   break;
          // }

          case "job": {
            const services = shipment.estimate?.["non-binding"]?.shipment_service || [];

            const rowIdx = def.row - 1;
            rows[rowIdx] = rows[rowIdx] || [];

            services.forEach((s, index) => {
              const serviceType = this.additionalModel.service_type.find(t => {
                return t.service_type == s.service_type;
              });
              if (serviceType) {
                // def.color = serviceType.color;
              }
              var title = fun.capitalize(s.service_type || `Job ${index + 1}`);
              var serviceDate = s.service_date || "Missing";
              // title += " &#128197 " + serviceDate.toString();
              if (s.booked) {
                title += " - BOOKED";
              }
              // if (s.status) {
              //   title += "&rightarrow; " + s.status;
              // }

              block = {
                id: `job_${index}`,
                title: title,
                icon: s.booked ? "mdi-truck-check" : def.icon || "mdi-briefcase",
                color: s.booked ? "green" : "black",
                objectName: def.objectName,

                noForemanEdit: def.noForemanEdit,
                details: [
                  {
                    title: "Service Date",
                    main: false,
                    icon: "mdi-calendar-clock",
                    // color: serviceDate.toLowerCase() == "missing" ? warningColor : "black",
                    // color: "orange",
                    value: serviceDate
                  }

                  // {
                  //   title: "Status",
                  //   icon: "mdi-check-circle",
                  //   value: s.booked
                  // }
                  // {
                  //   title: "Driving Time",
                  //   value: s.driving_time
                  // }
                  // {
                  //   title: "  ",
                  //   value: s.booked ? "BOOKED" : "",
                  // },
                ],
                containers: { detail: [], bottom: [], controls: [] }
              };
              if (s.service_type && s.service_type.toLowerCase().includes("local")) {
                block.details.push({
                  title: "Latest Pickup Time",
                  main: false,
                  icon: "mdi-clock-end",
                  // color: "orange",
                  value: s.latest_pickup_time
                });
              }
              const ldServies = ["long", "international"];
              // ldServies.forEach(serv => {
              //   if (s.service_type && s.service_type.toLowerCase().includes(serv)) {
              //     block.details.push({
              //       title: "Pickup Date Range",
              //       value: s.pickup_date_range || "Missing"
              //     });
              //     block.details.push({
              //       title: "Delivery Date Range",
              //       value: s.delivery_date_range || "Missing"
              //     });
              //   } else {
              //     block.details.push({});
              //     block.details.push({});
              //   }
              // });
              this.getCustomProperties(block);

              // --- STOPS ---
              // const stopsDef = config.components.job?.containers?.bottom?.find(c => c.id === "shipment_stop");
              // if (stopsDef) {
              //   block.containers.detail.push({
              //     ...stopsDef,
              //     details: [
              //       // {
              //       //   title: "Total",
              //       //   value: s.total_estimate || "Missing"
              //       // }
              //       // { title: "Currency", value: shipment.currency || "USD" },
              //       // {
              //       //   title: "Type",
              //       //   value: shipment.estimate?.type || "Non-binding",
              //       // },
              //     ]
              //   });
              // }
              block.containers.top = [];
              var stops = this.createServiceStops(def, block.containers.top, s.shipment_stop);

              // --- ESTIMATE ---
              const estimateDef = config.components.job?.containers?.bottom?.find(c => c.id === "estimate");
              if (estimateDef) {
                block.containers.detail.push({
                  ...estimateDef,
                  newLine: true,
                  details: [
                    {
                      title: "Total",
                      icon: "mdi-currency-usd",
                      main: true,
                      value: `Charges - ${s.is_flat_rate ? "Flat Rate" : "Total"}: ${s.total_estimate} `
                    }
                    // { title: "Flat Rate?", value: s.is_flat_rate }
                    // {
                    //   title: "Type",
                    //   value: shipment.estimate?.type || "Non-binding"
                    // }
                  ]
                });
              }

              // --- RESOURCES ---
              const resourcesDef = config.components.job?.containers?.bottom?.find(c => c.id === "resources");
              if (resourcesDef && !this.$root.customerId && !this.$root.roles.includes("foreman")) {
                let res = [];
                const resourceDetails = (s.resources || [])
                  .filter(r => r.qty) // Only include if r.qty is truthy (non-zero, not null, not undefined)
                  .forEach(r => {
                    res.push(`${r.qty} ${r.resource_type}`);
                  });
                // .map(r => ({
                //   title: r.resource_type,

                //   value: `${r.qty}`
                // }));
                let detail = {
                  main: true,
                  value: `Resources - ${res.join(", ")}`
                };
                // if (s.resources?.length) {
                block.containers.detail.push({
                  ...resourcesDef,

                  details: [detail]
                });
                // }
              }

              // --- CREW ---
              const crewDef = config.components.job?.containers?.bottom?.find(c => c.id === "day_crew");

              if (
                crewDef &&
                !this.$root.customerId &&
                !this.$root.roles.includes("foreman") &&
                s.itinerary &&
                s.itinerary.length
              ) {
                var crewDetails = [];
                var totalAssigned = s.itinerary[0]?.day_crew?.crew_employee?.length || 0;
                // s.itinerary.forEach(it => {
                // if (it.day_crew && it.day_crew.crew_employee) {
                //   totalAssigned = it.day_crew?.crew_employee?.length;
                // try {
                //   it.day_crew?.crew_employee?.forEach(e => {
                //     crewDetails.push({
                //       main: true,
                //       title: e.employee_role,
                //       value: e.employee?.full_name || "None Assigned"
                //     });
                //   });
                // } catch (error) {
                //   //
                // }
                // }
                // });
                crewDetails.push({
                  main: true,
                  title: "Crew",
                  value: `Crew - ${totalAssigned} assigned`
                });
                if (crewDef && !that.$root.customerId && !that.$root.roles.includes("foreman"))
                  block.containers.detail.push({
                    ...crewDef,
                    details: crewDetails.length ? crewDetails : []
                  });
                //---PAYROLL---
                const payrollDef = config.components.job?.containers?.bottom?.find(c => c.id === "payroll");

                var totalPayroll = s.payroll?.reduce((sum, p) => sum + parseFloat(p.subtotal || 0), 0);
                if (totalPayroll && !isNaN(totalPayroll)) {
                  payrollDef.details[0] = {
                    title: "Payroll Total",
                    icon: "mdi-currency-usd",
                    main: true,
                    value: `Payroll Total : ${totalPayroll.toFixed(2)} `
                  };
                }

                block.containers.detail.push(payrollDef);

                // const crewDetails = (s.resources || [])
                //   .filter((r) => r.qty) // Only include if r.qty is truthy (non-zero, not null, not undefined)
                //   .map((r) => ({
                //     title: r.resource_type,
                //     value: `${r.qty}`,
                //   }));
              }
              //---RESOURCES---
              // const resourceDef = config.components.job?.containers?.bottom?.find(c => c.id === "resources");
              // var resourceDetails = [];
              // s.resources?.forEach(r => {
              //   resourceDetails.push({ title: "", value: "" });
              // });

              // if (
              //   resourceDef &&
              //   !that.$root.customerId &&
              //   !that.$root.roles.includes("foreman") &&
              //   resourceDetails.length
              // )
              //   block.containers.detail.push({
              //     ...resourceDef,
              //     details: resourceDef.length ? resourceDetails : []
              //   });

              // block.containers.detail.push(resourceDef);
              // block.hide = !s.resources?.length;
              // --- ITINERARY ---
              const itineraryDef = config.components.job?.containers?.bottom?.find(c => c.id === "itinerary");
              var addItinerary = null;

              if (itineraryDef && !this.$root.customerId && !this.$root.roles.includes("foreman")) {
                const serviceType = this.additionalModel.service_type.find(t => {
                  return t.service_type == s.service_type;
                });
                if (serviceType && serviceType.has_itinerary && !this.$root.customerId) {
                  s.itinerary?.forEach((entry, i) => {
                    if (entry.step && entry.step != "d2d") {
                      const types = (entry.step || "").split("2");
                      const icon = fun.getItineraryIcon(types[0]);
                      const icon2 = fun.getItineraryIcon(types[1]);

                      var dynamicIcon = `mdi mdi-${icon},mdi mdi-${icon2}`;

                      // mdi-chevron-right,
                      var details = [];
                      if (entry.etd) {
                        details.push({ title: "ETD", value: entry.etd || "Missing" });
                      }
                      if (entry.agent?.company) {
                        details.push({
                          title: "Agent",
                          value: entry.agent?.company || "Missing"
                        });
                      }

                      var color = "";
                      var dark = false;
                      if (i < s.itinerary?.length - 1) {
                        connections.push({
                          from: `itinerary_${index}_${i}`,
                          to: `itinerary_${index}_${i + 1}`,
                          direction: "right"
                        });
                      }

                      switch (entry.step) {
                        case "p2p":
                          var shipmentIcon = entry.shipment_info?.export_import || "export";
                          dynamicIcon = `mdi mdi-${icon},mdi mdi-${shipmentIcon}`;
                          if (!entry.shipment_info) {
                            entry.shipment_info = {};
                          }
                          dark = shipmentIcon == "import";
                          color = "blue";
                          details.push({
                            title: "Type",
                            value: entry.shipment_info?.type_of_shipment || "Missing"
                          });
                          details.push({
                            title: "Container Size",
                            value: entry.shipment_info?.container_size || "Missing"
                          });
                          break;

                        default:
                          if (entry.pickup_status) {
                            details.push({
                              title: "Pickup Status",
                              value: entry.pickup_status || "Missing"
                            });
                          }

                          if (entry.delivery_status) {
                            details.push({
                              title: "Delivery Status",
                              value: entry.delivery_status || "Missing"
                            });
                          }
                          if (entry.warehouse) {
                            details.push({
                              title: "Warehouse",
                              value: entry.warehouse?.warehouse_name || "Missing"
                            });
                          }

                          break;
                      }
                      let itineraryBlock = {
                        id: `itinerary_${index}_${i}`,
                        title: `Itinerary Step ${entry.step}`,
                        dynamicIcon: dynamicIcon.split(","),
                        dark: dark,
                        obj: "itinerary",
                        color: color || itineraryDef.color,
                        objectName: def.objectName,
                        details
                      };

                      itineraryBlock.details == this.getCustomProperties(itineraryBlock);

                      // this.getBlockCustomProperties(itineraryBlock)

                      block.containers.top.push(itineraryBlock);
                    }
                  });
                  if (!s.itinerary) {
                    s.itinerary = [];
                  }
                  block.containers.top.push({
                    id: `itinerary_${index}_${s.itinerary?.length}`,
                    title: "Add Itinerary Step",
                    objectName: def.objectName,
                    dynamicIcon: ["mdi-arrow-decision-outline"],
                    add: true
                  });
                }
              }
              // block.containers.controls.push({
              //   type: "v-switch",
              //   "v-bind": {

              //     label: "Booked",
              //     model: "booked",
              //   },
              // });

              rows[rowIdx].push(block);
            });

            break;
          }

          case "inventory": {
            block.details = [
              { title: "Items", main: true, value: `Inventory: ${shipment.num_items || 0} Items` },
              { title: "Material Volume", value: shipment.material_volume },
              { title: "Total Volume", value: shipment.volume }
            ];
            break;
          }

          case "estimate": {
            block.details = [
              {
                title: "Total",
                value: this.getTotalEstimate?.() || shipment.estimate_total || "Missing"
              }
              // { title: "Currency", value: shipment.currency || "USD" },
              // {
              //   title: "Type",
              //   value: shipment.estimate?.type || "Non-binding",
              // },
            ];
            break;
          }
          case "letters": {
            block.details = [
              {
                title: "Total Available",
                value: this.totalLetters
              }
            ];
            if (this.$root.roles.includes("foreman")) {
              block.title = "Documents";
            }

            break;
          }
          case "onsite_estimate": {
            block.hide = !this.shipment.onsite_estimate?.length;
            var onsiteEstimate =
              this.shipment.onsite_estimate && this.shipment.onsite_estimate.length
                ? this.shipment.onsite_estimate[0]
                : null;

            block.details = [];
            if (onsiteEstimate?.date_time) {
              block.details.push({
                icon: onsiteEstimate?.virtual ? "mdi-video-account" : "mdi-account-clock",
                value: `${fun.formatDate(onsiteEstimate?.date_time, false, true, true, null, null, null, true)} by ${
                  onsiteEstimate?.estimator?.full_name
                }`
              });
            }

            //   title: "Estimate Date",
            //   value: onsiteEstimate ? onsiteEstimate.date_time : "None"
            // },

            // {
            //   title: "Estimator",
            //   value: onsiteEstimate && onsiteEstimate.estimator ? onsiteEstimate.estimator.full_name : "None"
            // }
            break;
          }
          case "payment": {
            const payments = shipment.payment || [];
            const total = payments.reduce((sum, p) => sum + parseFloat(p.amount || 0), 0);
            this.shipment.total_payment = total;
            block.hide = !total;
            block.details = [
              { title: "Total Paid", value: `$${total.toFixed(2)}` },
              { title: "Balance", value: `$${this.shipment.balance || this.shipemnt.total_estimate}` }
            ];
            break;
          }
          case "expense": {
            const expense = shipment.expense || [];
            const total = expense.reduce((sum, p) => sum + parseFloat(p.amount || 0), 0);
            block.hide = !total;
            block.details = [
              { title: "Total Expense", value: `$${total.toFixed(2)}` }
              // { title: "Count", value: `${payments.length} record(s)` },
            ];
            break;
          }
          case "booking": {
            const allServices = shipment.estimate?.["non-binding"]?.shipment_service || [];
            let bookingStatus = "Not Booked";
            block.hide = true;
            let color = "black";
            if (allServices.length === 1) {
              bookingStatus = allServices[0].booked ? "Booked" : "Not Booked";
              if (bookingStatus == "Booked") {
                color = "green";
              }
            } else {
              const bookedJobs = allServices.filter(s => s.booked).length;
              if (bookedJobs === allServices.length) {
                bookingStatus = "All Booked";
                color = "green";
              } else if (bookedJobs > 0) {
                bookingStatus = `Booked ${bookedJobs} of ${allServices.length}`;
                color = "orange";
              }
            }

            block.details = [{ title: "Status", color: color, main: true, value: "Booking: " + bookingStatus }];
            break;
          }
          case "attachments":
            block.hide = !that.files.length;
            block.details = [{ title: "Attached Files", value: that.files.length }];
            break;
          case "storage":
            block.hide = !this.shipment.storage?._id;
            break;

          default: {
            block.details = [{ title: "", value: "(not implemented)" }];
          }
        }

        try {
          var curRow = rows[rowIdx].find(r => {
            return r.id == block.id;
          });
          if (curRow) {
            curRow.details.push(...block.details);
          }
        } catch (error) {
          //
        }
        // this.getBlockCustomProperties(block)
        block.details = this.getCustomProperties(block);

        return block;
      };

      // Build rows from config
      // const skipIds = new Set(["estimate", "resources", "itinerary"]);
      // config.components = config.components.filter((def) => {
      //   return (
      //     (def.move_type &&
      //       def.move_type.includes(that.shipment.shipment_detail.move_type)) ||
      //     !def.move_type
      //   );
      // });

      //config.components.job.containers.bottom

      try {
        config.components.job.containers.bottom.forEach(c => {
          if (c.parent) {
            console.log(c.parent);
            c.parent = null;
          }
        });
      } catch (error) {
        //
      }
      Object.entries(fun.clone(config.components)).forEach(([id, def]) => {
        // if (skipIds.has(id)) return;
        if ((this.$root.customerId && def.noCustomer) || (this.$root.roles.includes("foreman") && def.hideIfForeman))
          return;
        const rowIdx = def.row - 1;
        const colIdx = def.col - 1;
        rows[rowIdx] = rows[rowIdx] || [];
        const arrays = ["job", "pickup", "dropoff"];
        // if (def.move_type) {
        //   console.log(def.move_type);
        // }
        const moveTypeIncluded =
          (def.move_type && def.move_type.includes(that.shipment.shipment_detail.move_type)) || !def.move_type;
        if (moveTypeIncluded) {
          if (!arrays.includes(id)) {
            rows[rowIdx][colIdx] = buildBlock(id, def);
          } else {
            buildBlock(id, def);
          }
        } else {
          delete config.components[id];
        }
      });

      // Connections from config
      if (Array.isArray(config.connections)) {
        config.connections.forEach(link => {
          connections.push({
            from: link.from,
            to: link.to,
            direction: link.direction || "right"
          });
        });
      }

      // Optional: auto-connect shipment stops
      const sortedStops = (shipmentStops || [])
        .slice()
        .sort((a, b) => Number(a.stop_number || 0) - Number(b.stop_number || 0));
      for (let i = 0; i < sortedStops.length - 1; i++) {
        connections.push({
          from: `${sortedStops[i].value}`,
          to: `${sortedStops[i + 1].value}`,
          direction: "right"
        });
      }
      var sideBar = {};
      var notes = this.shipment.crm;
      // notes.sort((a, b) => {
      //   const dateA = new Date(a.action_date_time);
      //   const dateB = new Date(b.action_date_time);
      //   return dateB - dateA; // descending
      // });

      sideBar.notes = notes;
      rows.forEach(e => {
        e.forEach(r => {
          if (r.details) {
            r.details = fun.uniqueArray(r.details);
          }
        });
      });

      this.moveDiagramData = { rows, connections, sideBar };
    },

    refreshData(feedback) {
      var that = this;
      this.noConnection = false;
      var url = "";
      var data = {};
      if (
        this.shipmentId &&
        this.$router.currentRoute.params.id.toString().split("_")[0] != this.shipmentId.toString().split("_")[0] &&
        this.$router.currentRoute.params.id.toString().split("_")[0] != "0"
      ) {
        this.shipmentId = this.$router.currentRoute.params.id;
      }

      if (this.shipmentId) {
        this.shipment_id = parseInt(this.shipmentId.toString().split("_")[0]);
        data.qry = {
          shipment_id: parseInt(this.shipmentId)
        };
      }

      url = "get_data";
      data.object_name = "shipment";
      // data.schema_name = "shipment";

      var addData = {
        additional_data: [
          {
            obj_name: "v_open_shipments",
            schema_name: "open_shipment",
            qry: { shipment_id: this.shipmentId }
          },
          {
            obj_name: "company",
            qry: { $or: [{ active: true }, { active: { $exists: false } }] }
          },
          {
            obj_name: "charge_list"
          },
          {
            obj_name: "material_list"
          },
          {
            obj_name: "service_type"
          },
          {
            obj_name: "vehicle_type"
          },
          {
            obj_name: "employee_role"
          },
          {
            obj_name: "resource_type"
          },
          {
            obj_name: "labor_type"
          },
          {
            obj_name: "charge_category"
          },
          {
            obj_name: "delivery_status"
          },
          {
            obj_name: "international_shipment_status"
          },
          { obj_name: "international_shipment_task" },
          {
            obj_name: "room"
          },
          {
            obj_name: "task"
          },
          // {
          //   obj_name: "employee",

          //   qry: {
          //     _id: this.$root.user_id,
          //   },
          // },
          {
            obj_name: "employee",

            qry: {
              category: "office_employee"
            }
          },

          {
            obj_name: "warehouse"
          },
          {
            obj_name: "v_sent_letters",

            qry: {
              shipment_id: parseInt(this.shipment_id)
            }
          },
          {
            obj_name: "zone",

            fields: ["_id", "zone_name", "states", "counties", "cities", "movetype", "company", "type"]
          },
          {
            obj_name: "agent",
            // qry: {
            //   type: "tariff_zone",
            // },
            fields: ["_id", "contact", "zones", "has_own_tariff"]
          },
          {
            obj_name: "stage"
          },
          {
            obj_name: "rate_list",
            data_name: "labor_rates",
            qry: {
              charge_type: "transportation_hourly_based"
            }
          },
          {
            obj_name: "lead_status"
          }
        ],
        additional_structure: [
          {
            obj_name: "moving_diagram"
          },
          {
            obj_name: "shipment_info"
          },
          {
            obj_name: "storage"
          }
        ]
      };

      data = {
        ...data,
        ...addData
      };
      // }
      // } else {
      //   url = "get_schema";
      //   data.obj_name = "shipment";
      //   this.panelIndex = 0;
      // }
      if (this.shipmentId) {
        data.get_more = [
          {
            object_name: "v_international_shipment_with_jobs",
            qry_fn:
              "{'_id':json.loads(return_data).get('model')[0].get('shipment_info').get('international_shipment')}",
            fields: ["shipment_name", "shipments", "export_import", "shipping_agent"]
            // id_fields: ["customer"],
          },
          {
            object_name: "ai_chat",
            qry_fn: "{'order_id':str(json.loads(return_data).get('model')[0].get('_id'))}",
            fields: ["message", "session"]
            // id_fields: ["customer"],
          }
        ];
      }
      console.time("Axios Request"); // Start the timer

      axios
        .post(this.serverURL + "/" + url, data, {
          withCredentials: true
        })
        .then(response => {
          this.activate = false;
          this.loading = false;

          this.getBiggestObject(response);
          // this.calculateSize(response.data.model[0], [
          //   "estimate",
          //   "non-binding",
          //   "shipment_service",
          //   0,
          //   "route",
          //   "shape",
          // ]);

          this.additionalModel = response.data.additional_model;
          this.additionalStructure = response.data.additional_structure;
          try {
            that.currentUser = that.additionalModel.employee.filter(e => {
              return e._id == that.$root.user_id;
            })[0];
          } catch (error) {
            //
          }

          this.openShipment = "";
          if (this.additionalModel.v_open_shipments.length) {
            var opened = this.additionalModel.v_open_shipments[0];

            if (opened.action == "open" && opened.user && opened.user != this.$root.store.userData.email) {
              var user = this.$root.store.userData.first_name + " " + this.$root.store.userData.last_name;
              this.openShipment =
                "This shipment is currently open by " +
                user +
                " (" +
                this.$root.store.userData.email +
                ").  Any changes you will make may be overwritten";
            }
            // console.log(this.openShipment);
          }

          that.moreData = response.data.more_data;

          that.schema.properties = response.data.schema;
          localStorage.setItem("schema", JSON.stringify(response.data.schema));

          that.additionalModel = response.data.additional_model;
          try {
            if (response.data.more_data?.international_shipment) {
              that.groupageName = response.data.more_data?.international_shipment[0]?.shipment_name;
            }
          } catch (error) {
            //
          }

          try {
            if (response.data.more_data?.ai_chat) {
              // console.log(response.data.more_data.ai_chat);
              this.aiChatData = response.data.more_data.ai_chat;
            }
          } catch (error) {
            //
          }
          if (that.shipmentId) {
            this.wizardStarted = true;
            try {
              if (that.$router.currentRoute.params.id.toString().split("_")[1]) {
                var currentServiceId = that.$router.currentRoute.params.id.toString().split("_")[1];
                that.shipment.estimate["non-binding"].shipment_service.forEach((s, i) => {
                  if (s._id == currentServiceId) {
                    that.serviceIndex = i;
                    that.currentService = s;
                  }
                });
              }
            } catch {
              //
            }
            this.shipment = response.data.model[0];
            if (that.aiChatData && this.shipment) {
              this.shipment.crm =
                this.shipment.crm?.filter(c => {
                  return c.type != "ai_chat";
                }) || [];
              var chatLength = that.aiChatData.length;
              that.aiChatData.forEach((a, i) => {
                var timeStamp = new Date(new Date(a.session).getTime() + 1000 * i);

                this.shipment.crm.push({
                  type: "ai_chat",
                  time_stamp:
                    fun.formatDate(timeStamp, false, true) + ":" + String(timeStamp.getSeconds()).padStart(2, "0"),
                  description: `${a.message?.role}: ${a.message?.content}`
                });
              });
            }

            if (this.shipment && !this.shipment.inventory) {
              this.shipment.inventory = [];
            }
            if ((this.shipment && !this.shipment.crm) || (this.shipment && !this.shipment.crm.length)) {
              var crm = {
                type: "status",
                description: "Estimate Created",
                status: "new",

                time_stamp: that.shipment.shipment_detail ? that.shipment.shipment_detail.order_date_time : ""
              };
              this.shipment.crm = [crm];
            }
            if (this.shipment && !this.shipment.onsite_estimate) {
              this.shipment.onsite_estimate = [];
            }
            this.currentService = this.shipment?.estimate["non-binding"].shipment_service[this.serviceIndex];
            try {
              if (!this.shipment.shipment_detail?.move_type) {
                var serviceType = this.currentService.service_type;
                if (serviceType.toLowerCase().includes("local")) {
                  this.shipment.shipment_detail.move_type = "local";
                }
                if (serviceType.toLowerCase().includes("short")) {
                  this.shipment.shipment_detail.move_type = "short_haul";
                }
                if (serviceType.toLowerCase().includes("long")) {
                  this.shipment.shipment_detail.move_type = "interstate";
                }
                if (serviceType.toLowerCase().includes("international")) {
                  this.shipment.shipment_detail.move_type = "international";
                }
              }
            } catch (error) {
              //
            }

            // console.log("route", this.currentService.route);
            this.populateDefaultAddresses();
            this.loadWizard();
            this.createStops();
            this.getCompanyName();
            this.checkPermissions();
            this.fixAddresses();

            // if (this.$vuetify.breakpoint.lgAndUp && !this.$root.customerId) {
            //   this.showPanel(this.defaultDialog);
            // }

            if (this.shipment.customer && !this.shipment.customer.type_of_customer) {
              this.shipment.customer.type_of_customer = "residential";
            }

            this.defaultModel = this.shipment;
            if (!this.defaultModel.payment) {
              this.defaultModel.payment = [];
            }

            this.assignCustomerName();
            this.companySelected = true;
            // this.fixAddresses();
            // this.newShipment = false;
            // this.expandPanel({ objectName: "customer" });
            this.updateTitles();
            this.mainService = this.shipment.estimate["non-binding"].shipment_service[0];

            // this.populateLettersMenu(this.shipment.document);
            if (this.shipment.shipment_detail.company) {
              this.getLetters(this.shipment.shipment_detail.company._id);
            }
          } else {
            // that.schema.properties = response.data;

            this.schemaReady = true;
            console.log(response.data);
            this.defaultTypeOfMove = this.additionalModel.company[0]?.default_settings?.default_type_of_move;
            try {
              if (this.defaultTypeOfMove.toLowerCase().includes("local")) {
                this.defaultTypeOfMove = "local";
              }
              if (this.defaultTypeOfMove.toLowerCase().includes("short")) {
                this.defaultTypeOfMove = "short_haul";
              }
              if (this.defaultTypeOfMove.toLowerCase().includes("long")) {
                this.defaultTypeOfMove = "interstate";
              }
              if (this.defaultTypeOfMove.toLowerCase().includes("international")) {
                this.defaultTypeOfMove = "international";
              }
            } catch (error) {
              //
            }

            // if (!this.shipmentId) {
            that.shipmentDetail = {
              shipment_detail: {}
            };
            that.shipment.shipment_detail = that.shipmentDetail.shipment_detail;
            // that.shipmentDetail.shipment_detail.move_type = this.defaultTypeOfMove;
            that.companySchema = {
              shipment_detail: {
                properties: {
                  move_type: that.schema.properties.properties.shipment_detail.properties.move_type,
                  company: that.schema.properties.properties.shipment_detail.properties.company,
                  status: "new"
                }
              }
            };
            if (this.multiCompany && !this.companySelected) {
              that.companySchema.shipment_detail.company =
                that.schema.properties.properties.shipment_detail.properties.company;
            }
            //         "getItems": false,
            // "capitalizeText": true,d

            // that.company = {
            //   properties: company,
            // };
            var companyVBind = that.companySchema.shipment_detail.properties.company["v-bind"];
            companyVBind.getItems = false;
            companyVBind.capitalizeText = true;
            companyVBind.qry = { active: true };
            that.companySchema.shipment_detail.properties.company["x-display"] = "v-radio-list";
            // companyVBind.defaultIndex = null;
            that.companySchema.shipment_detail.properties.company.title = "Select Company";
            if (!that.multiCompany) {
              that.companySchema.shipment_detail.properties.company.hidden = true;
            }
            that.companySchema.shipment_detail.properties.move_type["x-display"] = "v-radio-list";

            var moveTypes = [];
            // this.additionalModel.company[0];
            that.selectedCompany.shipment_detail.move_type = this.defaultTypeOfMove || "local";
            that.companySchema.shipment_detail.properties.move_type["v-bind"].items.forEach(i => {
              moveTypes.push({
                text: i,
                value: i,
                icon: this.getMoveTypeIcon(i)
              });
            });
            that.companySchema.shipment_detail.properties.move_type["v-bind"].items = moveTypes;
            // that.shipment.shipment_detail.move_type = this.defaultTypeOfMove;
            // companyVBind.defaultIndex = null;
            that.companySchema.shipment_detail.properties.move_type.title = "Select Move Type";
            if (!this.shipment) {
              this.shipment = fun.clone(this.defaulModelClone) || this.defaultModel;
            }
            this.panelIndex = 0;
            if (this.$root.customerId) {
              this.populateDefaultAddresses();
              this.expandPanel(this.wizardSteps[1]);
            } else {
              this.expandPanel(this.wizardSteps[0]);
            }

            // if (!that.panelIndex) {

            // } else {
            //   this.expandPanel(this.wizardSteps[that.panelIndex]);
            // }

            this.companyModel = this.getModel({
              objectName: "shipment_detail"
            });
            this.newShipment = true;
          }
          // }
          this.config = response.data.additional_structure.moving_diagram;
          // if (this.shipmentId) {
          var fileData = {
            object_name: "shipment",
            record_id: this.shipment._id
          };
          axios
            .post(this.serverURL + "/get_files", fileData, {
              withCredentials: true
            })
            .then(response => {
              this.files = response.data;
              this.buildDiagramFromShipmentFromConfig();
            });

          // }
          if (this.shipment.use_wizard) {
            this.newShipment = true;
          }
          if (!that.currentService.service_type) {
            that.currentService.service_type = that.getDefaultServiceType(
              that.shipment.shipment_detail.move_type
            )?.service_type;
          }

          this.modelReady = true;

          if (feedback) {
            feedback();
          }
        });
    },
    decimalToTime(t) {
      return fun.decimalToTime(t);
    },
    getBlockCustomProperties(block) {
      let objectName = block.obj || block.objectName;
      try {
        let schema = this.getSchema({ obj: objectName });
        // console.log(schema);
        let customProperties = fun.getObjectsKeysAndPath(schema, "portal_id", this.$root.portal_id);
        if (customProperties?.length) {
          let model = this.getModel(block);
          if (model[objectName]) {
            model = model[objectName];
          }
          if (Array.isArray(model)) {
            model = model[0];
          }
          const uniquePropertis = [...new Set(customProperties)];
          uniquePropertis.forEach(p => {
            if (model[p]) {
              const newDetail = {
                title: fun.capitalize(p),
                value: model[p],
                color: "black"
              };
              if (!block.details.some(item => item.title === newDetail.title)) {
                block.details.push(newDetail);
              }
            }
          });
        }
      } catch (error) {
        //
      }
    },
    getSalesPerson() {
      try {
        const sp = this.additionalModel.employee.find(e => {
          return (
            e._id == this.shipment.shipment_detail.sales_person ||
            e._id == this.shipment.shipment_detail.sales_person._id
          );
        });
        return sp.full_name;
      } catch (error) {
        return "";
      }
    },
    populateDefaultAddresses() {
      if (!this.warehouseAddresses || !this.warehouseAddresses.length) {
        this.warehouseAddresses = [];
        this.additionalModel.warehouse.forEach(w => {
          this.warehouseAddresses.push(w);
        });
        // fun.clone(this.additionalModel.warehouse);
        var company = this.additionalModel.company[0];
        try {
          this.additionalModel.company.find(c => {
            return c._id == this.shipment.shipment_detail.company._id;
          });
        } catch (error) {
          //
        }

        if (company) {
          this.warehouseAddresses.push({
            _id: company._id,
            warehouse_name: company.company_name,
            address: company.address ? company.address.address : ""
          });
        }

        this.warehouseAddresses.forEach(w => {
          try {
            // console.log(w);
            w.full_address = w.address.address;
            w.location = { address: w.address };
            // w.use_existing = true;

            w.existing_address = {
              address_id: w._id,
              value: w.address.address,
              text: w.warehouse_name + " " + w.address.address
            };
            delete w.address;
          } catch (error) {
            //
          }
        });
      }
      this.getAllLocations();
    },
    loadWizard() {
      var w = this.getWizardStep("crew_employee");

      if (
        this.currentService &&
        this.currentService.itinerary &&
        this.currentService.itinerary[0] &&
        this.currentService.itinerary[0].day_crew
      ) {
        w.hidden = false;
      } else {
        w.hidden = true;
      }

      this.shownSteps = this.wizardSteps.filter(w => {
        return (!w.hidden && !w.hideIfForeman && this.foreman) || (!this.foreman && !w.hidden);
      });
    },
    closeVisualInventory() {
      this.showVisualInventory = false;
    },
    onSwitchChange() {
      this.submit(this.mount());
    },
    getCompanyName() {
      if (this.shipment.shipment_detail.company) {
        this.company = this.additionalModel.company.filter(c => {
          return c._id == this.shipment.shipment_detail.company || c._id == this.shipment.shipment_detail.company._id;
        })[0];

        try {
          this.shipment.shipment_detail.company.logo_url = this.company.logo_url;
        } catch (error) {
          //
        }

        if (this.company) {
          return this.company.company_name;
        }
      } else {
        if (!this.company) {
          this.company = {
            _id: this.additionalModel.company[0]._id,
            companyName: this.additionalModel.company[0].company_name
          };
          return this.company.companyName;
        }
      }
    },
    createStops() {
      var that = this;
      this.shipment.stops = [];
      try {
        this.shipment.estimate["non-binding"].shipment_service.forEach(s => {
          s.shipment_stop.forEach(st => {
            if (
              !that.shipment.stops.some(
                existing => existing.full_address === st.full_address && existing.location?.apt === st.location?.apt
              )
            ) {
              that.shipment.stops.push(st);
            }
          });
        });
      } catch (error) {
        //
      }
      // console.log(this.shipment.stops);
    },
    assignCustomerName() {
      var that = this;
      if (this.shipment.customer.type_of_customer == "residential") {
        this.shipment.customer_name =
          this.shipment.customer.customer_name ||
          this.shipment.customer.contact.first_name + " " + this.shipment.customer.contact.last_name;
      } else {
        var department = "";
        if (!that.shipment.department_id && that.shipment.customer.department?.length == 1) {
          that.shipment.department_id = that.shipment.customer.department[0]._id;
        }
        if (that.shipment?.customer.department && that.shipment.department_id) {
          department =
            that.shipment?.customer?.department?.find(d => d._id == that.shipment.department_id)?.department_name ?? "";
          if (department) {
            that.shipment.customer_name = that.shipment.customer.company + " -" + department;
          } else {
            that.shipment.customer_name = that.shipment.customer.company;
          }
        }
      }
    },
    createServiceStops(def, block, serviceStops) {
      var that = this;

      const shipmentStops = this.shipmentStops();
      // const isPickup = id === "pickup";

      const enrichedStops = serviceStops.map(stop => {
        // var matchedAddress = (this.shipment.customer.address || []).find(
        //   addr => stop.address_id && addr._id === stop.address_id
        // );
        // if (!matchedAddress) {
        var matchedAddress = (this.shipment.customer.address || []).find(
          addr =>
            addr.full_address &&
            stop.full_address &&
            addr.full_address.toString().toLowerCase() === stop.full_address.toString().toLowerCase() &&
            addr.location?.apt === stop.location?.apt
        );
        // }
        if (!matchedAddress) {
          matchedAddress = (this.shipment.customer.address || []).find(
            addr =>
              addr?.location?.address?.geo?.location?.address?.label?.replace(", United States", "") +
                " " +
                addr?.location?.address?.geo?.location?.address?.postalCode ===
              stop.full_address
          );
        }
        if (!matchedAddress) {
          matchedAddress = (that.allLocation || []).find(
            addr => addr.full_address === stop.full_address && addr.location?.apt === stop.location?.apt
          );
        }
        // this.allStops = enrichedStops;
        if (!matchedAddress) {
          var customerAddress = {
            _id: fun.guid(),
            full_address: stop.full_address,
            location: stop.location
          };
          this.shipment.customer.address.push(customerAddress);
          matchedAddress = customerAddress;
        }
        var loc = matchedAddress?.location || {};
        if (!loc.address) {
          loc.address = {};
        }
        loc.full_address = stop.full_address;
        loc.address.address = stop.full_address;
        loc.full_address = stop.full_address;
        let stopNumber = Number(stop.stop_number);
        if (!stopNumber && typeof stop.value === "string") {
          const match = stop.value.match(/_(\d+)$/);
          if (match) {
            stopNumber = Number(match[1]);
            stop.stop_number = stopNumber;
          }
        }
        var pos = loc?.address?.geo?.location?.position;

        var lat = null;
        var lng = null;
        if (pos) {
          lat = pos[0];
          lng = pos[1];
        }
        var curStop = {
          ...stop,
          location: loc,
          full_address: loc.full_address || stop.full_address || "",
          dwelling_type: loc.dwelling_type || stop.dwelling_type || null,
          elevator: loc.elevator ?? stop.elevator ?? null,
          flight_of_stairs: loc.flight_of_stairs || null,
          zone: loc.zone || stop.zone || null,
          link: "https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=" + lat + "," + lng
        };
        return curStop;
      });

      // var stops = (enrichedStops || []).filter(s =>
      //   s.value?.toLowerCase().includes(isPickup ? "pickup" : "dropoff")
      // );
      var stops = enrichedStops;
      stops.sort((a, b) => Number(a.stop_number || 0) - Number(b.stop_number || 0));
      // rowIdx = def.row - 1;

      // rows[rowIdx] = rows[rowIdx] || [];
      // this.allStops = stops;
      stops.forEach((st, index) => {
        def = st.value?.includes("pickup") ? this.config.components.pickup : this.config.components.dropoff;
        const title = fun.capitalize(st.value).toUpperCase();
        const addressTitle = `${title} : ${st.full_address} ${st.location?.apt ? " apt " + st.location.apt : ""}`;

        const stopBlock = {
          id: st.value,
          _id: st._id,
          title: fun.capitalize(st.value || `Stop ${index + 1}`),
          icon: def.icon,
          color: def.color || "#ccc",
          dark: def.dark,
          objectName: def.objectName,
          isStop: true,
          details: [
            {
              title: `#${st.stop_number}`,
              // title: "Address",
              icon: "mdi-map-marker-outline",
              color: st.full_address ? def.color : "orange" || "#ccc",
              main: true,
              value: addressTitle
            }
          ]
        };
        // Add dwelling type
        if (st.dwelling_type?.dwelling_type) {
          stopBlock.details.push({
            title: "Dwelling",
            value: st.dwelling_type.dwelling_type
            // icon: "mdi-home-city"
          });
        }

        // Add flight of stairs
        if (st.flight_of_stairs) {
          stopBlock.details.push({
            title: "Stairs",
            value: `${st.flight_of_stairs} flight(s)`
            // icon: "mdi-stairs"
          });
        }

        if (st.location?.comments) {
          stopBlock.details.push({
            title: "Comments",
            value: `${st.location.comments}`
            // icon: "mdi-comment-text-multiple"
          });
        }

        // Add elevator info
        if (st.elevator === true) {
          stopBlock.details.push({
            title: "Elevator",
            value: "Elevator"
            // icon: "mdi-elevator"
          });
        } else if (st.elevator === false || !st.elevator & st.flight_of_stairs) {
          stopBlock.details.push({
            title: "Elevator",
            value: "No Elevator"
            // icon: "mdi-elevator-passenger-off"
          });
        }

        stopBlock.details = this.getCustomProperties(stopBlock);
        block.push(stopBlock);
        // rows[rowIdx].push(stopBlock);
      });
    },
    // findZone(addr) {
    //   var that = this;
    //   var loc = {};
    //   var geo = fun.deepFind(addr, "geo");
    //   if (!geo && addr && addr.address) {
    //     geo = addr.address.geo;
    //   }
    //   if (!geo) {
    //     return "";
    //   }
    //   var location = geo.location.address || geo.location;
    //   var zone = this.additionalModel.zone;
    //   var elementInArray = function(array, el) {
    //     if (!el) return false;
    //     if (!Array.isArray(array)) {
    //       array = array.split(",");
    //     }
    //     const index = array.findIndex(element => {
    //       return !element || element.toString().toLowerCase() === el.toString().toLowerCase();
    //     });
    //     return index != -1;
    //   };
    //   var tariffZones = zone.filter(z => {
    //     return z.type == "tariff_zone";
    //   });

    //   var filteredZones = tariffZones.filter(z => !z.company || z.company.some(c => c._id === that.company._id));

    //   var myZones = filteredZones.filter(z => {
    //     if (z.states) {
    //       return elementInArray(z.states, location.stateCode);
    //     }
    //     if (z.locations) {
    //       return elementInArray(z.locations, location.stateCode);
    //     }
    //   });
    //   if (myZones.length) {
    //     myZones = myZones.filter(z => {
    //       return !z.counties || !z.counties.length || elementInArray(z.counties, location.county);
    //     });
    //   }
    //   if (myZones.length) {
    //     myZones = myZones.filter(z => {
    //       return !z.cities || !z.cities.length || elementInArray(z.cities, location.city);
    //     });
    //   }
    //   // console.log(myZones);
    //   if (myZones.length) {
    //     myZones.forEach(z => {
    //       if (z.type == "tariff_zone") {
    //         loc.zone = {
    //           zone_name: z.zone_name,
    //           zone_id: z._id
    //         };
    //       }
    //       if (z.type == "carrier_zone") {
    //         loc.carrier_zone = {
    //           zone_name: z.zone_name,
    //           zone_id: z._id
    //         };
    //       }
    //     });
    //     return loc;
    //     // if (addr.zone) {
    //     //   return addr.zone.zone_id;
    //     // }
    //   }
    // },
    getLetters(companyId) {
      var data = {
        object_name: "document",
        qry: {
          $and: [
            { $or: [{ company: companyId }, { company: null }] },
            {
              $or: [
                { move_type: { $exists: false } },
                { move_type: null },
                { move_type: [] },
                { move_type: this.shipment.shipment_detail.move_type }
              ]
            },
            { $or: [{ draft: { $exists: false } }, { draft: false }] }
          ]
        }
      };
      this.loading = true;
      axios
        .post(this.serverURL + "/get_data", data, {
          withCredentials: true
        })
        .then(response => {
          // console.log(response.data);
          this.totalLetters = response.data.model.length;

          this.populateLettersMenu(response.data.model);
        });
    },
    populateLettersMenu(l) {
      var that = this;
      this.letterList = [];

      l.forEach(d => {
        if (d.document_name && (!this.$root.roles.includes("foreman") || d.on_device)) {
          //           parseTemplate() {
          //   var url = this.serverURL + "/parse_template";
          //   var data = {
          //     body: fun.removeHtmlComments( d.email_subject),
          //     document_data: this.fixedModel
          //   };

          //   axios
          //     .post(url, data, {
          //       withCredentials: true
          //     })
          //     .then(response => {
          //       console.log(response.data);
          //       // this.letterBody = response.data;
          //     });
          // }fun.parseTemplate(d.email_subject, this.shipment),

          var subject = d.email_subject;
          try {
            subject = d.email_subject.replaceAll(
              "{{model.company.company_name}}",
              this.shipment.shipment_detail.company.company_name
            );
          } catch (error) {
            //
          }

          this.letterList.push({
            itemText: d.document_name,
            itemValue: d._id,
            subject: subject,
            category: d.category
          });
        }
      });
      fun.sortObjects(this.letterList, "itemText");
      this.totalLetters = this.letterList.length;
      this.letterMenuBtn = {
        title: this.$vuetify.breakpoint.lgAndUp ? "Letters and Documents" : "",
        menuItems: this.letterList,
        small: true,
        text: true,
        menuItemClick: this.letterContainer,
        sideModel: this.shipment,
        // color: "yellow",
        // color: "warning",
        icon: "mdi-email",
        closeMenuOnClick: true
      };
      this.$nextTick(() => {
        this.lettersReady = true;
        this.loading = false;
        this.fullscreen = true;
      });
    },
    showPanel(item) {
      this.mapReady = false;
      this.dialog = false;
      this.menuItem = item;
      this.modelReady = false;
      this.letterReady = false;
      this.panelHeader = item.text;
      this.dialogWidth = screen.width / 2;
      if (item.text == "Map") {
        this.loading = true;
        // this.calculateRoute(this.currentService, this.createMapData);
        // this.mapReady = true;
        // this.mapKey = !this.mapKey;
      } else {
        var obj = {
          obj: item.text.toLowerCase(),
          objectName: item.text.toLowerCase()
        };
        if (item.text == "Order Detail") {
          obj = {
            obj: "shipment_detail",
            objectName: "shipment_detail"
          };
        }

        this.currentModel = this.getModel(obj);

        this.currentSchema = this.getSchema(obj);
        this.formKey = !this.formKey;
        this.modelReady = true;
        console.log(this.currentModel);
      }
      this.dialog = true;
      this.panelIndex = -1;
    },
    getPath(object, previousPath) {
      var arrayControls = ["d-table", "v-charge", "v-labor", "d-iterator", "v-data-time-line", "v-collapsible"];
      for (var key in object) {
        let currentPath = previousPath ? `${previousPath}.${key}` : key;
        var v;
        if (object[key].type == "object") {
          v = this.fixedModel[currentPath];
          if (!v) {
            if (arrayControls.includes(object[key]["x-display"])) {
              this.fixedModel[currentPath] = [{}];
            } else {
              this.fixedModel[currentPath] = {};
            }
          }
        }
        if (object[key].properties) {
          this.getPath(object[key].properties, currentPath);
        }
      }
    },
    getAllAgents() {
      var agents = [];
      var agentTypes = ["agent", "freight_forwarder", "agent_at_destination"];
      agentTypes.forEach(t => {
        var agent = fun.getObjectsByKey(this.shipment, t);
        if (agent && agent.length) {
          agent.forEach(a => {
            agents.push(a);
          });
        }
      });

      return agents;
    },
    fixLetterModel(objName) {
      this.fixedModel = this.additionalModel.v_shipment_letter_fields[0];
      try {
        var path = this.getPath(this.schema.properties);
      } catch (error) {
        console.log(error);
      }

      // console.log(path);
      var objects = fun.getObjects(this.schema.properties, "type", "object");
      var objectNames = [];
      objects.forEach(o => {
        if (o.object_type) {
          objectNames.push(o.object_type);
        }
      });
      objectNames.forEach(n => {
        try {
          var v = fun.getObjectsByKey(this.fixedModel, n);
          if (!v || !v.length) {
            var p = fun.findPath(this.fixedModel, n, v);
            v = {};
          }
        } catch (error) {
          v = {};
          console.log(error);
        }
      });
      if (objName == "v_shipment_letter_fields") {
        this.fixedModel.total_estimate = this.shipment.total_estimate;
        if (this.shipment.shipment_detail.sales_person) {
          this.fixedModel.shipment_detail.sales_person = this.shipment.shipment_detail.sales_person._id;
        }

        this.fixedModel.balance = (this.fixedModel.total_estimate - this.shipment.total_payment).toFixed(2);
      }
      if (!this.fixedModel.company?.company_name) {
        const companyId = this.fixedModel.shipment_detail?.company?._id;
        if (companyId) {
          const company = this.additionalModel.company.find(c => {
            return c._id == companyId;
          });
          if (company) {
            this.fixedModel.company = company;
          }
        }
      }

      this.letterModel = this.fixedModel;
    },
    prepareChargeList(rec) {
      var that = this;
      rec = rec.filter(record => {
        // If no company array or it's empty, include the record
        if (!record.company || record.company.length === 0) {
          return true;
        }

        // Check if at least one company._id matches with an _id in mycompany
        return record.company.some(company => company._id === this.shipment.shipment_detail.company._id);
      });
      rec.forEach(r => {
        switch (r.charge_category) {
          case "labor":
            console.log(r);
            r.delete = r.crew_rate ? true : false;
            r.crew_rate?.forEach(c => {
              var rate = fun.clone(c.labor_rate);
              rate.forEach(r => {
                r.qty = 1;
                r.unit = "hour";
                r.rate_name = c.labor_rate_type;
                r;
                // console.log(r);
              });
              rec.push({
                charge_name: c.num_men + " Men " + c.num_truck + " Truck",
                charge_category: r.charge_category,
                rate: rate,
                _id: c._id
              });
            });
            // if (!r.crew_rate) {
            //   rec.push(r);
            // }

            break;
          case "material":
            r.charge_category = "packing";
            break;

          default:
            // console.log(r);
            break;
        }
      });

      return rec.filter(r => {
        return !r.delete;
      });
    },
    // menuItemClick(m, d, item) {
    //   var that = this;
    //   // console.log(m);
    //   // this.isClosing = false;
    //   // var obj = {};
    //   // if (m == "closing") {
    //   //   obj = {
    //   //     id: "shipment_service",
    //   //     title: "Job Closing",
    //   //     objectName: "shipment_service",
    //   //   };
    //   //   this.isClosing = true;
    //   //   if (this.dataTabs.length) {
    //   //     this.dataTabs.splice(0, this.dataTabs.length);
    //   //     this.menuItemClick("closing");
    //   //   }
    //   // }
    //   // if (m == "pickup" || m == "dropoff") {
    //   //   obj = this.addExtraStop(m, d);
    //   // }

    //   // if (m == "storage") {
    //   //   obj = { id: "storage" };
    //   // }
    //   // if (m.objectName && m.objectName == "service_type") {
    //   //   obj = this.addCoJob(m);
    //   // }
    //   if (m.id && m.id == "letters") {
    //     obj.isLetter = true;
    //     obj.title = m.item.text;
    //     obj.obj = m;
    //   }

    //   // this.addTab(obj);
    //   this.currentModel = this.getModel(obj);

    //   that.currentSchema = this.getSchema();
    // },
    letterContainer(obj, parent) {
      this.currentTab = 4;
      this.mapReady = false;
      if (!obj) {
        return;
      }
      var that = this;
      var d = obj.obj;
      this.dialogWidth = screen.width;
      this.currentTab = 4;
      // this.getTotalEstimate(this.model);
      let objName = "";
      let qry = {};
      switch (obj.item.category) {
        case "shipment":
          objName = "v_shipment_letter_fields";
          qry = {
            shipment_id: parseInt(this.shipmentId)
          };
          break;
        case "international_shipment":
          objName = "v_international_shipment_with_jobs";
          qry = { _id: that.shipment.shipment_info?.international_shipment };
          break;
        default:
          break;
      }

      var data = {
        object_name: "document",
        qry: {
          _id: obj.item.value
        },
        additional_data: [
          {
            obj_name: objName,

            qry: qry
          }
        ]
      };
      this.loading = true;
      axios
        .post(that.serverURL + "/get_data", data, {
          withCredentials: true
        })
        .then(response => {
          let model = response.data.model;
          if (!this.additionalModel) {
            this.additional_model = {};
          }
          that.additionalModel.v_shipment_letter_fields = response.data.additional_model[objName];
          try {
            if (!that.additionalModel.v_shipment_letter_fields[0].company) {
              that.additionalModel.v_shipment_letter_fields[0].company = that.additionalModel.company[0];
            }
          } catch (error) {
            //
          }

          that.fixLetterModel(objName);

          var decoded = fun.decodeHtml(model[0].body);
          var bodyTemplate = fun.replaceLetterFields(decoded);
          if (this.additionalModel.company.length > 1) {
            var company = this.additionalModel.company.filter(c => {
              return c._id == this.shipment.shipment_detail.company;
            })[0];
          }
          var introBody = model[0].intro_body ? fun.replaceLetterFields(model[0].intro_body) : "";
          var fixFields = function(b) {
            b = b
              .replaceAll("estimate['non-binding'].shipment_service[0]", "service")
              .replaceAll("estimate['non-binding'].shipment_service", "services");
            return b;
          };
          that.letterReady = false;
          let shipmentModel = fun.clone(this.shipment);
          shipmentModel.service = this.shipment.estimate["non-binding"].shipment_service[0];
          var emailAddresses = [];
          var emailAddress = shipmentModel.customer.contact.email;
          emailAddresses.push(emailAddress);

          if (shipmentModel.department_id) {
            try {
              var dep = shipmentModel.customer.department.find(d => {
                return d._id == shipmentModel.department_id;
              });
              emailAddress = dep.contact.email;
            } catch (error) {
              //
            }
          }
          var bcc = [emailAddress];
          if (model[0]) {
            bcc = [];
            emailAddresses = [];

            model[0].send_to.forEach(s => {
              switch (s) {
                case "customer":
                  bcc.push(emailAddress);
                  emailAddresses.push(emailAddress);
                  break;

                case "agent":
                  console.log("agent");
                  var agents = this.getAllAgents();

                  if (agents.length) {
                    const emailMap = {};
                    this.additionalModel.agent.forEach(a => {
                      if (a && a._id && a.contact && a.contact.email) {
                        emailMap[a._id] = a.contact.email;
                      }
                    });

                    // Merge email into agents
                    agents.forEach(agent => {
                      if (emailMap[agent._id]) {
                        agent.email = emailMap[agent._id];
                      }
                    });
                    // console.log(agents);
                    agents.forEach(a => {
                      bcc.push(a.email);
                      emailAddresses.push(a.email);
                    });
                    if (that.shipment.shipment_detail.move_type == "international") {
                      var shippingAgents = that.additionalModel.v_shipment_letter_fields[0]?.shipping_agent;
                      if (shippingAgents && shippingAgents.length) {
                        shippingAgents.forEach(a => {
                          var contactId = a.agent_contact?._id;
                          if (contactId && a.company.contact) {
                            let contact = a.company.contact.find(c => {
                              return c._id == contactId;
                            });
                            if (contact) {
                              // if (Array.isArray(contact)) {
                              //   contact.forEach(c => {
                              //     emailAddresses.push(c.email);
                              //   });
                              // } else {
                              emailAddresses.push(contact.email);
                              // }
                            }
                          }
                        });
                      }
                    }
                  }

                  break;
              }

              //
            });
            // } else {
            //   bcc.push(emailAddress);
            //   emailAddresses.push(emailAddress);
          }

          this.letterBind = {
            email: emailAddresses,
            bcc: bcc,
            companyId: shipmentModel.shipment_detail.company._id,
            documentId: obj.value,
            model: that.additionalModel.v_shipment_letter_fields[0],
            shipmentModel: shipmentModel,
            documentModel: model[0],
            bodyTemplate: "<div>" + fixFields(bodyTemplate) + "</div>",
            introBodyTemplate: "<div>" + fixFields(introBody) + "</div>"
          };
          // var myTab = that.dataTabs.filter((t) => {
          //   if (t.obj.obj && t.obj.obj.item) {
          //     return t.obj.obj.item.value == d.item.value;
          //   }
          // });
          // if (myTab.length) {
          //   myTab[0].letterBind = obj.letterBind;
          // }
          that.letterReady = true;
          that.loading = false;
          this.dialog = true;
          that.docKey = !that.docKey;
          if (!this.letterBind.documentModel.company) {
            this.letterBind.documentModel.company = this.letterBind.companyId;
          }
        })
        .catch(reason => {
          // errorsHandler(reason);
        });
    },
    populateLetter(obj) {
      var that = this;
      let objName = "";
      switch (obj.category) {
        case "shipment":
          objName = "v_shipment_letter_fields";
          break;
        case "international_shipment":
          objName = "v_international_shipment_with_jobs";
          break;
        default:
          break;
      }
      this.data = {
        object_name: "document",
        qry: {
          _id: obj.value
        },
        additional_data: [
          {
            obj_name: objName,

            qry: {
              shipment_id: parseInt(that.shipmentId)
            }
          }
        ]
      };

      axios
        .post(that.serverURL + "/get_data", this.data, {
          withCredentials: true
        })
        .then(response => {
          var bodyTemplate = "";
          let documentModel = response.data.model;
          // bodyTemplate = r;
          that.shipment.service_type = "";
          let model = fun.clone(this.shipment);
          model.service = that.shipment.estimate["non-binding"].shipment_service[0];
          model.company = that.shipment.shipment_detail.company;

          this.letterBind = {
            email: model.customer.contact.email,
            documentId: obj.value,
            eMailSubject: documentModel[0].email_subject,
            model: that.shipment,
            documentModel: documentModel[0],
            letterId: documentModel[0]._id,
            bodyTemplate: "<div>" + documentModel[0].body + "</div>"
          };
          this.letterReady = true;
          this.dialog = true;

          // this.$root.getObjectStructure(
          //   "translate/letter_fields.json",
          //   model[0].body,
          //   (r) => {

          //   }
          // );
        })
        .catch(reason => {
          // errorsHandler(reason);
        });
    },
    getCustomerAddresses(customerId, commit) {
      var data = {
        object_name: "customer",
        qry: {
          _id: customerId
        }
      };
      try {
        axios
          .post(this.serverURL + "/get_data", data, {
            withCredentials: true
          })
          .then(response => {
            // console.log(response.data);

            this.data = response.data.model[0].address;
            commit(response.data);
          });
      } catch (err) {
        this.error = err.response?.data?.message || "An error occurred";
      } finally {
        this.loading = false;
      }
    },
    assignEvents() {
      var that = this;
      if (this.eventAssigned) {
        return;
      }
      //schema_updated
      this.$root.$on("schema_updated", d => {
        // if (d && d == that.shipmentId) {
        that.dialog = false;
        that.refreshData();
      });

      this.$root.$on("fileUploaded", d => {
        console.log(d);
        if (d.obj.itemId) {
          if (d.obj.itemId.startsWith("international_shipment_task")) {
            var task = d.obj.itemId.split("international_shipment_task_")[1];
            that.shipment.shipment_info.tasks_completed = (that.shipment.shipment_info.tasks_completed || []).filter(
              v => typeof v === "string" && v.trim() !== ""
            );
            if (!that.shipment.shipment_info.tasks_completed.includes(task) && typeof task == "string") {
              that.shipment.shipment_info.tasks_completed.push(task);
            }

            that.submit(a => {
              that.moveDiagramData.rows.forEach(row => {
                var block = row.find(r => {
                  return r?.id == "shipment_info";
                });
                if (block) {
                  that.openBlock(block);
                }
              });
            });
          }
          var crmItem = that.shipment.crm.find(c => {
            return c._id == d.obj.itemId;
          });
          if (crmItem) {
            crmItem.completed = true;
          }
        }
      });
      this.$root.$on("fileDeleted", d => {
        console.log(d);
      });
      this.$root.$on("rowAdded", d => {
        if (that._uid != that.$root.shipmentUid) {
          return;
        }

        if (d.tbl.parentModel && d.tbl.parentModel.shipment_id != that.shipment.shipment_id) {
          return;
        }
        if (d.tbl.tableName == "Resources") {
          // that.expandPanel({ obj: "resources" });
          // that.panelChange();
          // that.panelChange(5);
        }
        if (d.tbl.tableName == "inventory" && fun.getParentByProperty(d.tbl, "newShipment")) {
          if (!d.rec.item.qty) {
            d.rec.item.qty = 1;
            d.row.qty = 1;
          }
          if (!d.rec.item.volume) {
            d.rec.item.volume = 1;
            // d.rec.total_volume = 1;
          }
          d.row.total_volume = d.row.volume * d.rec.item.qty;
          // that.shipment.inventory = d.tbl.originalRecords.length
          //   ? d.tbl.originalRecords
          //   : d.tbl.table;
          that.shipment.inventory = d.tbl.table;
          if (d.tbl.tableName == "inventory" && d.row && d.row.item) {
            var tableObject = d.tbl;
            that.inventoryTable = tableObject;
            that.inventoryTable.menuOpen = true;
            try {
              if (!d.row.room) {
                d.row.room = d.tbl.$refs.selectRoom[0].model;
              }
            } catch (error) {
              //
            }

            if (that.shipment.estimate["non-binding"].shipment_service.length == 1) {
              d.row.service_date = that.shipment.estimate["non-binding"].shipment_service[0].service_date;
            } else {
              d.row.service_date = that.currentServceDate?.value;
              //
            }
            // var shipmentStops = that.shipmentStops();

            var pickup = that.shipmentStops().find(s => {
              return s.value.includes("pickup");
            });

            if (pickup) {
              d.row.from = pickup.full_address;
            }
            var dropoff = that.shipmentStops().find(s => {
              return s.value.includes("dropoff");
            });
            if (dropoff) {
              d.row.to = dropoff.full_address;
            }
            if (that.shipment.has_storage) {
              d.row.to_storage = true;
            }

            if (fun.deepFind(d, "rec.item.rec.item_handling")) {
              if (this.currentItemHandlingId == d.row._id) {
                return;
              }
              this.currentItemHandlingId = d.row._id;
              var handling = d.rec.item.rec.item_handling;
              // that.inventoryTable.menuOpen = false;
              if (handling.prompt && !tableObject.edited) {
                // console.log(handling.prompt);
                that.handlingPrompt = handling.prompt;
                that.itemDialog = !that.itemDialog;
                this.currentItem = d.row;
                // that.currentItem = obj.formModel;
                that.currentHandling = handling;
              }
              // } else {
            }
            if (d.row.item && d.row.item.startsWith("(CP) ")) {
              d.row.isMaterial = true;
            }
            // that.submit(true, true);
            //
          }
        }

        // console.log(d);
        // that.openBlock(that.currentBlock, null, true)
      });
      this.$root.$on("materialAdded", d => {
        if (that._uid != that.$root.shipmentUid) {
          return;
        }

        this.addToMaterials(d, that.currentService.estimate_charges, true);
      });
      this.$root.$on("get_combo_items", function(combo) {
        if (that._uid != that.$root.shipmentUid) {
          return;
        }
        var par = fun.getParentByProperty(combo, "shipmentId");
        if (par.shipmentId != that.shipmentId) {
          return;
        }
        if (combo.k == "estimate_address") {
          if (!combo.comboItems) {
            combo.comboItems = [];
          }
          var addresses = that.shipmentStops();
          var customerAddresses = that.shipment.customer.address.filter(item1 => {
            return addresses.some(item2 => {
              return (
                item2.address_id === item1._id ||
                item2.full_address === item1.full_address ||
                that.cleanFullAddress(item2.full_address) == that.cleanFullAddress(item1.full_address)
              );
            });
          });

          customerAddresses.forEach(a => {
            var apt = "";
            if (!a.location) {
              a.location = {};
            }
            if (a.location.apt) {
              apt = " apt " + a.location.apt;
            }
            if (!a.location.address) {
              a.location.address = {};
            }
            var address = a.location.address.address + apt;
            if (address) {
              combo.comboItems.push(address);
            }
          });
        }

        // if (combo.k == "tariff") {
        //   var model = that.data_object.model;

        //   var curTariff = that.data_object.all_tariff.filter(function(t) {
        //     if (t && t.haul_type) {
        //       return t.haul_type.includes(model.shipment_detail.haul_type);
        //     }
        //   });
        //   curTariff.forEach((tar) => {
        //     Object.keys(model.estimate).forEach(function() {
        //       var t = {
        //         text: tar.tariff_name,
        //         value: tar._id,
        //       };
        //       combo.comboItems.push(t);
        //     });
        //   });
        // }

        // if (combo.k == "company") {
        //   combo.comboItems = that.shipmentObject.additionalModel.company;
        // }
      });
      //checkbox_checked
      this.$root.$on("checkbox_checked", function(obj) {
        if (obj.obj.objName == "international_shipment_task" && obj.obj.k == "tasks_completed") {
          if (obj.obj.model.includes(obj.item.value)) {
            that.openBlock({
              id: "attachments",
              title: obj.item.value,
              objName: "international_shipment_task"
            });
          }
        }
      });
      //tabAdded
      this.$root.$on("tabAdded", function(obj) {
        // if (that._uid != that.$root.shipmentUid) {
        //   return;
        // }
        if ((obj.shipment_id && that.shipmentId == obj.shipment_id) || (!obj.shipment_id && !that.shipmentId)) {
          that.init();
        }
      });
      //tableItemChanged
      this.$root.$on("tableItemChanged", function(obj) {
        if (that._uid != that.$root.shipmentUid) {
          return;
        }
        if (obj.itemName == "service_hours") {
          that.currentModel.crew_employee = obj.tbl.table;
        }
        console.log(obj);
      });

      this.$root.$on("comboTableUpdated", function(obj) {
        // console.log(obj);
        if (obj.obj?.vBind?.label == "Existing Groupage") {
          const parent = fun.getParentByProperty(obj.obj, "shipment_id");

          if (parent && parent.shipment_id == that.shipment.shipment_id) {
            that.shipment.shipment_info.groupage_id = obj.data;
            that.shipment.shipment_info.international_shipment = obj.data;
            that.formKey = !that.formKey;
          }
        }
      });
      this.$root.$on("comboUpdated", function(obj) {
        if (that._uid != that.$root.shipmentUid) {
          return;
        }
        const ignoreObjects = [
          "charge_category",
          "v_estimator",
          "v_employee",
          "v_role",
          "truck",
          "employee_role",
          "agent_role",
          "v_international_agent"
        ];
        if ((obj.objName && ignoreObjects.includes(obj.objName)) || obj.obj?.fromFormModel) {
          return;
        }
        // if (obj.objName && obj.objName == "v_estimator") {
        //   return;
        // }
        // if (obj.objName && obj.objName == "v_employee") {
        //   return;
        // }
        if ((obj.item == "hours" || obj.item == "volume") && that.lastCalculationBy != obj.item) {
          if (that.lastCalculationBy) {
            that.calculate();
          }

          that.lastCalculationBy = obj.item;

          return;
        }
        if (obj.objName == "room") {
          that.currentRoom = obj.model;
          return;
        }
        if (obj.objName == "list_items") {
          var item = obj.model;
          console.log(item);
          return;
        }
        if (obj.objName == "charge_list") {
          that.calculateCharge(obj.model?.item?.rec);
          console.log(obj.model?.item?.rec);
          //
        }
        if (!obj.obj.parentModel || obj.obj.parentModel.payment || obj.obj.parentModel.inventory) {
          return;
        }
        if (
          obj.obj.parentModel &&
          !obj.obj.parentModel.onsite_estimate &&
          obj.obj.parentModel.shipment_id != that.shipment.shipment_id
        ) {
          var service = that.shipment.estimate["non-binding"].shipment_service[that.serviceIndex];

          var curStop = obj.formModel;
          if (obj.item && obj.item.address_id) {
            curStop.address_id = obj.item.address_id;
            that.addShipmentStop("", "", obj.item.address_id, curStop);
          }

          that.panelIndex = -1;
          that.updateTitles();
        }

        console.log(obj);
      });
      this.$root.$on("itemsDeleted", obj => {
        if (obj.tableName == "shipments") {
          obj.selected.forEach(s => {
            if (s.shipment_id == that.shipmentId) {
              var index = that.$root.resentTabs.findIndex(t => t.shipment_id == that.shipmentId);
              that.$root.removeResentTab(index);
            }
          });
          return;
        }
        if (obj.data_object?.schema?.properties?.shipment_id) {
          obj.selected.forEach(s => {
            var data = {
              object_name: "shipment",
              qry: { shipment_id: s.shipment_id },
              update: { "shipment_info.international_shipment": null }
            };

            this.axios
              .post(this.serverURL + "/update_value", data, {
                withCredentials: true
              })
              .then(response => {});
          });
          return;
        }
        if (that._uid != that.$root.shipmentUid) {
          return;
        }
        // if (obj.localItems) {
        //   that.openBlock(that.currentBlock);
        //   return;
        // }
        var par = fun.getParentByProperty(obj, "shipmentId");
        if (!par || par.shipmentId != that.shipmentId) {
          return;
        }
        // console.log(obj.deletedItem);
        switch (obj.tableName) {
          case "charges":
            // that.deleteCharges(obj.deletedItem);
            console.log(obj.table);
            break;
          case "stops":
            that.deleteStop(obj.deletedItem);
            that.refreshWizard();
            break;
          case "inventory":
            // that.deleteCharges(obj.selected);
            var packingCharges = that.currentService.estimate_charges.filter(c => {
              return c.charge_category == "material";
            });

            obj.selected.forEach(s => {
              var packingCharge = packingCharges.find(p => {
                return p.charge.trim() == s.item.replace("(CP)", "").trim();
              });
              if (packingCharge) {
                that.currentService.estimate_charges = that.currentService.estimate_charges.filter(
                  c => String(c._id) !== String(packingCharge._id)
                );
              }
            });
            that.submit();
            break;
          case "shipmentService":
            that.shipment.estimate["non-binding"].shipment_service = that.shipment.estimate[
              "non-binding"
            ].shipment_service.filter(s => {
              return s._id != obj.deletedItem._id;
            });
            that.submit();

            break;
          default:
            that.updateTitles();
            break;
        }

        that.submit();
        that.dialog = false;
      });
      this.$root.$on("itemSelected", obj => {
        if (that._uid != that.$root.shipmentUid) {
          return;
        }
        that.serviceIndex = obj.index;
        that.updateTitles();
        // console.log(obj);
      });
      this.$root.$on("recordAdded", obj => {
        // var parentShipment = fun.getParentByProperty(obj.obj, "shipment_id");
        if (that.shipment_id != parseInt(that.$route.params.id)) {
          // if (that._uid != that.$root.shipmentUid) {
          return;
        }
        if (obj.obj.k == "address") {
          obj.rec.isNew = true;
          that.shipmentStops().push(obj.rec);
        }
        // console.log(obj.rec);
      });
      //appendClick
      //edited
      //tableSelectionChanged
      function selectCustomer(obj) {
        var address = fun.clone(that.defaultModel.customer.address);
        obj.selected[0].address = obj.selected[0].address.concat(address);
        that.shipment.customer = obj.selected[0];
        // that.fixAddresses();
        that.getAllLocations();
      }
      this.$root.$on("tableSelectionChanged", obj => {
        if (that._uid != that.$root.shipmentUid) {
          return;
        }
        if (
          obj.data_object &&
          (obj.data_object.object_name == "v_customer_search" || obj.data_object.object_name == "customer") &&
          obj.selected[0] &&
          obj.selected[0].address
        ) {
          // if (!obj.selected[0].address.length) {
          //   this.getCustomerAddresses(obj.selected[0]._id, (r) => {
          //     obj.selected[0].address = r;
          //     selectCustomer(obj);
          //   });
          // } else {
          //   selectCustomer(obj);
          // }
          var address = fun.clone(that.defaultModel.customer.address);
          obj.selected[0].address = obj.selected[0].address.concat(address);
          that.shipment.customer = obj.selected[0];
          // that.fixAddresses();
          that.getAllLocations();

          // if (!that.defaultModel.customer.address) {
          // that.shipment.customer.address = address;
          // }

          var customer = that.getWizardStep("customer");
          // that.submit(that.loadModel(customer));
          // that.submit();
          // this.panelIndex = 1;
        }
        if (obj.tableName == "department" && obj.selected.length && obj.selected[0]) {
          that.shipment.department_id = obj.selected[0]._id;
          that.shipment.customer_name = that.shipment.customer.company + " -" + obj.selected[0].department_name;
          var wObj = this.getWizardStep("customer");
          var department = that.shipment.customer.department.find(d => {
            return d._id == that.shipment.department_id;
          });
          wObj.additionalModel = {
            department: department
          };
          that.addControlKey = !that.addControlKey;

          // that.loadModel(wObj);
        }
        // that.shipmentWizardKey = !that.shipmentWizardKey;
        if (that.$refs.shipmentWizard && that.$refs.shipmentWizard.wizardStepIndex < 2) {
          that.$refs.shipmentWizard.nextWizardStep();
        }
      });
      this.$root.$on("tableMounted", obj => {
        if (obj && obj.parentModel && obj.parentModel.shipment_id != that.shipment.shipment_id) {
          return;
        }
        if (obj.tableName == "department") {
          console.log(obj);
          if (that.shipment.department_id) {
            obj.selected = [];
            obj.selected.push(
              obj.table.find(r => {
                return r._id == that.shipment.department_id;
              })
            );
          }
          // that.shipment.department_id = obj.selected[0]._id;
        }
        if (obj.tableName == "inventory") {
          that.shipment.inventory = obj.originalRecords;
        }
      });
      this.$root.$on("edited", obj => {
        if (that._uid != that.$root.shipmentUid) {
          return;
        }
        that.hideSubmit = obj.edited ? true : false;
      });
      //linkedObjectSelected
      this.$root.$on("linkedObjectSelected", obj => {
        if (that._uid != that.$root.shipmentUid) {
          return;
        }
        that.defaultModel.customer = obj.data;

        var customer = that.getWizardStep("customer");
        that.submit(that.loadModel(customer));

        // that.formKey = !that.formKey;
        // console.log(obj.data._id);
      });
      //sortingChanged
      this.$root.$on("sortingChanged", obj => {
        if (that._uid != that.$root.shipmentUid) {
          return;
        }
        console.log(obj);
        if (obj.label.startsWith("Stops")) {
          var hasOrderChanged = function(array1, array2) {
            const order1 = array1.map(item => item.stop_number);
            const order2 = array2.map(item => item.stop_number);

            // Compare the two orders
            if (order1.length !== order2.length) {
              return true; // If the lengths differ, the order has changed
            }

            for (let i = 0; i < order1.length; i++) {
              if (order1[i] !== order2[i]) {
                return true; // If any stop_number differs at the same position
              }
            }

            return false; // The order has not changed
          };
        }
        var array1 = that.currentService.shipment_stop;
        var array2 = obj.localItems;
        if (hasOrderChanged(array1, array2)) {
          that.calculateRoute(that.currentService, that.createMapData);
        }
      });

      this.$root.$on("customBtnClick", obj => {
        if (
          obj.tbl &&
          obj?.tbl?.parentModel?.shipment_id &&
          obj?.tbl?.parentModel?.shipment_id != that.shipment?.shipment_id
        ) {
          return;
        }

        if (obj.btn) {
          if (obj.btn == "add_record_to_combo_table") {
            that.addInternationalShipment("groupage");
          }
          if (obj.btn == "editContact") {
            that.readOnly = false;
            return;
          }
          if (obj.tbl) {
            this.lastBtnClick = {
              btn: obj.btn,
              id: obj.tbl._uid
            };
          }
          if (obj.btn == "bookAll") {
            that.bookAll();
          }
          if (obj.btn == "customerProfile") {
            console.log(obj.frm.model._id);
            var customerName =
              obj.frm.model.type_of_customer == "commercial"
                ? obj.frm.model.company
                : obj.frm.model.contact.first_name + " " + obj.frm.model.contact.last_name;

            var item = {
              icon: "mdi-account",
              text: "Customer " + customerName,

              link: "/customers/" + obj.frm.model._id,
              customer_id: obj.frm.model._id,

              permitted: true
            };
            this.$root.addResentTab(item);
          }
          if (obj.btn == "selectItem") {
            console.log("item");
          }
        }
        if (obj.btn == "onsite_estimate") {
          that.onsiteEstimate = obj.tbl.$refs.onsite_estimate[0].internalValue;
          // obj.tbl.$refs.visual_inventory[0].inputValue="AI Inventory"
        }

        if (that._uid == that.$root.shipmentUid && that.$parent.$children.length > 1) {
          var newComp = that.$parent.$children.filter(c => {
            return c._uid != that.$root.shipmentUid;
          });
          newComp.forEach(c => {
            if (c.shipmentObject) {
              c.shipmentObject.additionalModel.zone_rate = this.zoneRates;
              // this.updateZoneRates();

              c.zoneFrom = that.zoneFrom;
              c.zoneTo = that.zoneTo;
            }
          });
        }

        if (obj.id == "letters") {
          // that.menuItemClick(obj);
        } else if (obj.id == "status") {
          that.model.shipment_detail.status = obj.item.value;
          this.submit();
          var curStatus = fun.capitalize(that.model.shipment_detail ? that.model.shipment_detail.status : "");
          that.statusMenuBtn.color = that.getColor();
          that.statusMenuBtn.title = "Status: " + curStatus;
          that.sendToCallSystem(curStatus);
        } else if (obj.id == "addCojob") {
          obj = this.addCoJob(obj);

          this.addTab(obj);
          this.currentModel = this.getModel(obj);
          // this.currentSchema = this.getSchema();
          that.movePlanKey = !that.movePlanKey;
          //
        } else if (obj.btn == "assignStorage") {
          console.log("assignStorage");
          var assignStorageCmb = obj.tbl.toolBarControls.find(c => {
            return c.id == "storageList";
          });
          // assignStorageCmb.hidden = false;
          obj.tbl.toolBarKey = !obj.tbl.toolBarKey;
          obj.tbl.selected = [];
          obj.tbl.select = !obj.tbl.select;
          obj.tbl.closeMenuOnClick = !obj.tbl.closeMenuOnClick;
        } else if (obj.tbl) {
          switch (obj.tbl.tableName) {
            //menuItemClick
            case "payroll":
              //refresh_crew
              if (obj.btn == "refresh_crew") {
                // console.log("refresh crew");
                console.log(that.model);
                that.services = that.shipment.estimate?.["non-binding"]?.shipment_service || [];
                var itinerary = that.services[that.serviceIndex].itinerary;
                var payroll = that.services[that.serviceIndex].payroll;
                if (!payroll) {
                  payroll = [];
                }
                itinerary.forEach(i => {
                  if (i.foreman) {
                    var exist = payroll.some(p => {
                      return p.employee._id == i.foreman._id;
                    });
                    if (!exist) {
                      payroll.push({
                        _id: fun.guid(),
                        payroll_date: fun.formatDate(new Date()),
                        employee: {
                          _id: i.foreman._id,
                          full_name: i.foreman.full_name
                        },
                        employee_role: "foreman"
                      });
                    }

                    if (i.foreman.crew && i.foreman.crew.crew_employee) {
                      i.foreman.crew.crew_employee.forEach(e => {
                        exist = payroll.some(p => {
                          return p.employee._id == e.employee._id;
                        });
                        if (!exist) {
                          payroll.push({
                            _id: fun.guid(),
                            payroll_date: fun.formatDate(new Date()),
                            employee: {
                              _id: e.employee._id,
                              full_name: e.employee.full_name
                            },
                            employee_role: e.employee_role
                          });
                        }
                      });
                    }
                  }
                });
              }
              if (obj.btn == "calc_payroll") {
                console.log("calculate payroll");
                that.calculatePayroll({ payroll: obj.tbl.table }, true);
              }

              break;

            case "charges":
              if (obj.btn == "calc_charges") {
                this.calculate();
              }
              break;
            case "inventory":
              if (obj.btn == "visual_inventory" && that.$parent.$router.currentRoute.params.id == that.shipmentId) {
                that.showVisualInventory = true; //!that.showVisualInventory;
              }

              if (obj.btn == "existing_inventory") {
                console.log(obj);
              }

              break;

            default:
              break;
          }
        }
      });
      this.$root.$on("tableChanged", (tbl, keys) => {
        if (tbl.parentModel && tbl.parentModel.shipment_id != that.shipment.shipment_id) {
          return;
        }
        // console.log(tbl);

        if (tbl.tableName == "inventory") {
          that.shipment.inventory = tbl.table;
          that.shipment.inventory.forEach(s => {
            const name = s.item.replace("(CP)", "").trim();

            const charge = that.currentService.estimate_charges.find(p => p.charge && p.charge.trim() === name);

            if (charge) {
              charge.estimate_rate[0].qty = s.qty;
              charge.subtotal = charge.estimate_rate[0].rate * charge.estimate_rate[0].qty;
            }
          });
          if (that.shipment.inventory.length > 1 || (that.shipment.inventory[0] && that.shipment.inventory[0].volume)) {
            // if (!tbl.edited && !tbl.edited == 0) {
            that.submit();
            // }
          }
        }
        // switch (tbl.tableName) {
        //   case "inventory":
        //     that.calculateInventoryVolume();
        //     that.shipment.inventory = tbl.originalRecords;
        //     var totalVolume = that.shipment.volume ? that.shipment.volume : 0;
        //     tbl.tableHeader = "Tot. Volume: " + totalVolume;

        //     break;
        //   case "payment":
        //     that.shipment.payment = tbl.originalRecords;

        //     break;
        //   case "crm":
        //     that.shipment.crm = tbl.originalRecords;

        //     break;
        //   case "charges":
        //     that.currentModel.estimate_charges = tbl.originalRecords;

        //     that.calculateTotal(that.currentModel);

        //     break;
        //   default:
        //     break;
        // }
      });

      this.$root.$on("radioListPopulated", r => {
        // console.log(r.items);
        var par = fun.getParentByProperty(r, "shipmentId");
        if (par?.shipment?.shipmentId != that.shipment.shipmentId) {
          return;
        }
        // console.log(r);
        if (r.objName == "company") {
          if (r.items.length > 1 && !this.$root.customerId) {
            that.multiCompany = true;
            that.companySelected = false;
            if (that.selectedCompany.shipment_detail) {
              that.shipment.shipment_detail = that.selectedCompany.shipment_detail;
            }
          } else {
            that.multiCompany = false;

            if (!that.shipment.shipment_detail) {
              that.shipment.shipment_detail = {
                company: {}
              };
            }
            that.shipment.shipment_detail.company = r.items[0];
            that.companySelected = true;
            if (that.companySchema?.shipment_detail?.properties?.company) {
              that.companySchema.shipment_detail.properties.company.hidden = true;
              r.isHidden = true;
            }

            // that.lettersReady = true;
            if (that.shipment.shipment_detail.company) {
              that.getLetters(that.shipment.shipment_detail.company._id);
            }
          }

          that.addDefaultShipmentDetail();
        }
        if (r.k == "move_type") {
          r.model = that.defaultTypeOfMove;
          that.currentService.service_type = that.getDefaultServiceType(r.model)?.service_type;
        }
      });

      this.$root.$on("labelBtnChanged", r => {
        var par = fun.getParentByProperty(obj, "shipmentId");
        if (that._uid != that.$root.shipmentUid) {
          return;
        }
        if (that.currentObject == "shipment_service") {
          var serviceType = r.itemValue;
          var services = that.shipment.estimate["non-binding"].shipment_service;
          var newService = {
            _id: fun.guid(),
            service_type: serviceType,
            apply: true,
            estimate_charges: []
          };
          services.push(newService);
          // that.shipment.additional_services.push(newService);
          var obj = that.getWizardStep("job");
          that.loadModel(obj);
        }
        if (that.currentStopType) {
          that.currentModel = that.getModel({ obj: that.currentStopType });
          console.log(that.currentModel);
          // that.submit();
          // const customerAddresses = that.shipment.customer.address; // Array of customer addresses
          // const formModel = r.obj.formModel; // Array of form models

          // // Filter objects from formModel where the _id does not match any _id in customerAddresses
          // const newAddress = formModel.address.filter(
          //   (formItem) =>
          //     !customerAddresses.some(
          //       (address) =>
          //         formItem.address_id && address._id != formItem.address_id
          //     )
          // );
          // if (newAddress.length) {
          //   delete newAddress[0].undefined;
          //   that.shipment.customer.address.push(newAddress[0]);
          // }
        }

        // console.log(r.obj.formModel.length);
        // var stopLength = 2;
        // this.addShipmentStop(r.itemValue);
      });
      this.$root.$on("valueChanged", function(r) {
        if (that._uid != that.$root.shipmentUid) {
          return;
        }
        if (r.key == "booked") {
          console.log(r.model);
          that.bookService(r);
        }

        //
      });
      this.$root.$on("addressChanged", function(addr, obj, oldAddress) {
        var par = fun.getParentByProperty(obj, "shipmentId");
        if (obj.parentModel.shipment_id != parseInt(this.$route.params.id)) {
          return;
        }

        obj.parModel.full_address = addr.address;

        that.addShipmentStop(
          that.currentStopType,
          addr,
          obj.parModel.existing_address && obj.parModel.existing_address.address_id
            ? fun.guid()
            : obj.parModel.address_id,
          obj.parModel,
          true
        );
        console.log(addr);
        // that.getModel({obj:"pickup"})

        //
      });
    },
    getDefaultValuesForInternationalShipment() {
      // var abbr = type == "groupage" ? "GRP" : type;
      var that = this;
      // if (!type) {
      //   type = that.shipment.shipment_info.type_of_shipment;
      // }

      const ship_id = fun.guid();
      if (!that.shipment.shipment_info.international_shipment) {
        that.shipment.shipment_info.international_shipment = ship_id;
        // if (type == "groupage") {
        //   that.shipment.shipment_info.groupage_id = ship_id;
        // }
        // var shipName = "";
        // if (
        //   that.shipment.shipment_info.origin_closest_port?.code &&
        //   that.shipment.shipment_info.destination_closest_port?.code
        // ) {
        //   shipName = `${abbr}-${that.shipment.shipment_info.origin_closest_port?.code}-${that.shipment.shipment_info.destination_closest_port?.code}-${that.shipment?.shipment_id}`;
        // }

        this.onDemandComponentDefaultValues = {
          _id: ship_id,
          // type_of_shipment: type,
          // shipment_name: shipName,
          port_of_loading: that.shipment.shipment_info.origin_closest_port,
          port_of_discharge: that.shipment.shipment_info.destination_closest_port,
          measurement_cf: that.shipment.volume,
          measurement_cm: (that.shipment.volume * 0.0283168466).toFixed(2),
          num_of_items: that.shipment.num_items,
          status: "pending"
        };
        this.onDemandComponentDefaultValuesChanged = true;
        this.formKey = !this.formKey;
      }
    },
    addInternationalShipment(type) {
      this.onDemandComponentDefaultValuesChanged = false;
      if (!type) {
        type = this.shipment.shipment_info.shipment_type;
      }
      this.getDefaultValuesForInternationalShipment(type);

      // this.$refs.formComponent.mainTab = 1;

      // that.$root.$on("iFrameReady", t => {
      //   that.sendMessageToObject("DEFAULT_VALUES", JSON.stringify(defaultValues));
      // });
    },
    init() {
      this.$root.shipmentUid = this._uid;
      this.shipmentId = this.$route.params.id ? parseInt(this.$route.params.id) : "";

      if (!this.shipmentId) {
        //
        this.mapReady = false;
        this.shipment = fun.clone(this.defaultModelClone) || this.defaultModel;

        this.currentModel = null;
        this.currentService = null;
        // try {
        //   this.updateTitles();
        // } catch (error) {
        //   //
        // }
        if (!this.$root.customerId) {
          this.panelIndex = 0;
        } else {
          this.panelIndex = 1;
        }

        if (this.defaultModelClone) {
          this.addDefaultShipmentDetail();
          try {
            this.shipment.shipment_detail.company = this.defaultModel.shipment_detail.company;
          } catch (error) {
            //
          }

          this.currentModel = { customer: this.defaultModelClone.customer };
          this.formKey = !this.formKey;
          // this.currentSchema = this.customerSchema;
        }

        //

        var pickupId = fun.guid();
        var dropoffId = fun.guid();
        this.loadWizard();
        // this.shipment.customer.address[0]._id = pickupId;
        // this.shipment.customer.address[1]._id = dropoffId;

        if (!this.shipmentId) {
          var service = this.shipment.estimate["non-binding"].shipment_service[this.serviceIndex];
          service.shipment_stop = [
            {
              // full_address: this.shipment.customer.address[0].full_address,
              value: "pickup",
              text: "pickup",
              title: "pickup",
              use_existing: false,
              stop_number: 1
              // address_id: this.shipment.customer.address[0]._id,
            },
            {
              // full_address: this.shipment.customer.address[1].full_address,
              value: "dropoff",
              text: "dropoff",
              title: "dropoff",
              use_existing: false,
              stop_number: 2
              // address_id: this.shipment.customer.address[1]._id,
            }
          ];
          if (this.defaultModelClone) {
            this.updateTitles();
          }

          // this.shipment.stops = service.shipment_stop;
        }
      }
      if (!this.shipment.expense) {
        this.shipment.expense = [];
      }
    },
    bookAll() {
      var isBooked = this.shipment.estimate["non-binding"].shipment_service[0].booked;

      this.shipment.estimate["non-binding"].shipment_service.forEach(s => {
        s.booked = !isBooked;
        this.bookService({ model: s });
      });
      this.formKey = !this.formKey;
    },
    refreshWizard() {
      const curIndex = this.panelIndex;
      this.panelIndex = -1;
      // this.panelIndex = curIndex;
    },
    selectCompany() {
      this.companySelected = true;
      this.selectedMoveType = true;
      this.shipment.shipment_detail = this.shipmentDetail.shipment_detail;
      this.wizardStarted = true;
      // this.lettersReady = true;
      this.getLetters(this.shipment.shipment_detail.company._id);
      try {
        this.currentService.service_type = this.getDefaultServiceType(
          this.shipment.shipment_detail.move_type
        )?.service_type;
      } catch (error) {
        //
      }
    },
    getEstimateKey(m) {
      var key = "";
      if (!this.shipment) {
        return "non-binding";
      }
      Object.keys(this.shipment.estimate).forEach(k => {
        if (m && fun.getObjects(this.shipment.estimate[k], "_id", m._id).length) {
          key = k;
        }
      });
      return key || "non-binding";
    },
    cleanFullAddress(fullAddress) {
      try {
        return fullAddress.replace(/\([^)]*\)/g, "").trim();
      } catch {
        return fullAddress;
      }
    },
    scheduleOnsite() {
      this.openBlock({ id: "onsite_estimate", objectName: "onsite_estimate" });

      this.formKey++;
    },
    showMap() {
      // console.log("map");
      this.calculateRoute(this.currentService, this.createMapData);
      this.showPanel({ text: "Map" });
    },
    addNote(note) {
      this.shipment.crm.push({
        type: "note",
        description: note,
        user: this.currentUser,
        time_stamp: fun.formatDate(new Date(), false, true)
      });
      this.submit();
    },
    addExtraStop(obj) {
      var newRec = {};
      var stops = this.shipmentStops();
      var stopType = obj.id.split("_").pop();
      this.currentStopType = stopType;
      var stopIndex =
        stops.filter(s => {
          return s.value?.includes(stopType);
        }).length + 1;
      var objectName = "address";
      var schema = this.getSchema({ objectName: objectName });
      try {
        newRec = fun.clone(schema[objectName]["v-bind"].newRecordModel) || {};
      } catch (error) {
        newRec = {};
      }
      var props = schema[objectName].properties || schema[objectName].table_properties.schema.properties;
      Object.keys(props).forEach(p => {
        if (props[p]["object_type"]) {
          newRec[p] = {};
        }
      });
      // if (r) {
      //   newRec[this.nameKey] = r;
      // }

      newRec._id = fun.guid();
      newRec.isNew = true;
      newRec.value = stopType + "_" + stopIndex;
      if (stopType == "dropoff") {
        newRec.stop_number = stopIndex + 1;
      }

      stops.push(newRec);
      this.openBlock({ objectName: objectName, id: stopType, _id: newRec._id }, null, obj.onClickFunction);
      return newRec;
    },
    addCoJob(r) {
      // var that = this;
      // var serviceType = r.itemValue;
      var services = this.shipment.estimate["non-binding"].shipment_service;
      var newService = {
        _id: fun.guid(),
        // service_type: serviceType,
        apply: true,
        estimate_charges: []
      };
      services.push(newService);
      this.currentService = newService;
      // that.shipment.additional_services.push(newService);
      var obj = this.getWizardStep("job");
      obj._id = newService._id;
      obj.index = services.length - 1;
      this.loadModel(obj);
      if (!this.newShipment) {
        this.dialog = true;
      }
    },

    calculateRoute(model, fn) {
      const uniqueAddresses = fun.getUnique(this.combineAddresses(), "full_address");

      model.address = uniqueAddresses.filter(item1 => {
        if (model.shipment_stop) {
          return model.shipment_stop.some(item2 => {
            return (
              item2.address_id === item1._id ||
              item2.full_address === item1.full_address ||
              this.cleanFullAddress(item2.full_address) == this.cleanFullAddress(item1.full_address)
            );
          });
        }
      });
      if (!model.address || (model.address && model.address.length < 2)) {
        this.loading = false;
        this.mapReady = true;
        return;
      }
      model.address.forEach(a => {
        const m = model.shipment_stop.find(s => {
          return s.address_id == a._id || s.full_address == a.full_address;
        });
        if (m) {
          a.stop_number = m.stop_number;
        }
      });
      model.address = fun.getUnique(model.address, "full_address");
      model.address.sort((a, b) => a.stop_number - b.stop_number);
      model.shipment_id = this.shipment.shipment_id;
      model.service_index = this.serviceIndex;
      model.estimate_key = this.getEstimateKey(model);

      var company = this.additionalModel.company.find(c => {
        return c._id == this.shipment.shipment_detail?.company?._id;
      });

      // if (company?.address) {
      //   model.address.unshift({ full_address: company.address.address, location: company.address });
      // }
      model.company = company;

      axios
        .post(this.serverURL + "/get_route", model, {
          withCredentials: true
        })
        .then(response => {
          var route = response.data;
          var distance = 0;
          var travelTime = 0;
          var travelDistance = 0;
          var drivingTime = 0;
          var travelDistanceBack = 0;
          var travelTimeBack = 0;

          if (route && route.sections) {
            route.sections.forEach((l, i) => {
              if (i === 0) {
                //travel time from DEP
                travelDistance = l.summary.length;
                travelTime = l.summary.baseDuration;
              } else if (i == route.sections.length - 1) {
                travelDistanceBack += l.summary.length;
                travelTimeBack += l.summary.baseDuration;
              } else {
                distance += l.summary.length;
                drivingTime += l.summary.baseDuration;
              }
            });
            model.route = route;
            model.distance = distance;
            model.mileage = (distance / 1.6 / 1000).toFixed(0);
            model.driving_time = (drivingTime / 3600).toFixed(2);
            model.travel_time = (travelTime / 3600).toFixed(2);
            model.travel_distance = (travelDistance / 1.6 / 1000).toFixed(0);
            model.travel_time_back = (travelTimeBack / 3600).toFixed(2);
            model.travel_distance_back = (travelDistanceBack / 1.6 / 1000).toFixed(2);

            this.submit();

            if (fn) {
              fn();
            } else {
              if (route && route.sections) {
                this.submit();
              }
            }
          }

          // console.log(response)
        })
        .catch(reason => {
          console.log(reason);
        });
    },
    applyHandling() {
      this.itemDialog = false;
      this.currentItem.handling = this.currentHandling;

      // this.tableKey = !this.tableKey;
      // this.updateHandling(true);
      this.applyInventoryHandling(this.currentItem, true);
      this.currentItemHandlingId = null;
      this.inventoryTable.table = this.shipment.inventory;
      this.submit();
      this.inventoryTable.scrollToEdited(this.currentItem);
      this.$root.$emit("keepMenu", "add_row");
      // this.inventoryTable.tableKey = !this.inventoryTable.tableKey;

      // this.inventoryTable.menuOpen = true;
    },
    addToMaterials(p, charges, noInventory) {
      var that = this;
      var material = null;
      try {
        material = that.additionalModel.material_list.find(m => {
          return m.material_name === p.item_name || m._id === p.material_id;
        });
      } catch (error) {
        console.log(error);
      }

      if (material && !noInventory) {
        var materialExists = this.shipment.inventory.find(c => {
          return c.inventoryId == p._id && c.packingId == p.packingId;
        });
        if (materialExists) {
          if (p.qty) {
            materialExists.qty = p.qty;
          } else {
            materialExists.qty += 1;
          }
        } else {
          this.shipment.inventory.push({
            _id: fun.guid(),
            item: material.material_name,
            qty: p.qty || 1,
            inventoryId: p._id,
            packingId: p.packingId,

            room: p.room,
            volume: material.cu_ft
          });
        }
      }
      if (material && charges) {
        var materialCharge = charges.find(item => item.charge === material.material_name && item.inventoryId == p._id);
        var calcSubtotal = function() {
          var subtotal = 0;
          materialCharge.estimate_rate.forEach(m => {
            subtotal += m.rate * m.qty || 0;
          });
          return subtotal.toFixed(2);
        };
        var addToCharges = function() {
          var chargeExists = charges.find(c => {
            return c.inventoryId == p._id && c.packingId == p.packingId;
          });
          if (!chargeExists) {
            charges.push({
              _id: fun.guid(),
              charge_category: "material",
              estimate_rate: materialCharge.estimate_rate,
              charge: material.material_name,
              inventoryId: p._id,
              packingId: p.packingId,
              qty: p.qty,

              // description: i.item,
              subtotal: calcSubtotal(),
              actual: calcSubtotal()
            });
          } else {
            chargeExists.qty = p.qty;
            chargeExists.subtotal = calcSubtotal();
            chargeExists.actual = calcSubtotal();
          }
        };
        if (materialCharge) {
          var cont = materialCharge.estimate_rate.find(item => item.rate_name === "cont");
          var pack = materialCharge.estimate_rate.find(item => item.rate_name === "pack");
          if (cont) {
            cont.qty += parseInt(p.qty || 1);
            // pack.qty = parseInt(p.qty || 0);
            materialCharge.subtotal = calcSubtotal();
          } else {
            addToCharges();
          }
        } else {
          materialCharge = {
            estimate_rate: [
              {
                rate_name: "cont",
                rate: material.container_price || 0,
                qty: p.qty || 1
              },
              {
                rate_name: "pack",
                rate: material.packing_price || 0,
                qty: p.qty || 0
              },
              {
                rate_name: "unpack",
                rate: material.unpacking_price || 0,
                qty: 0
              }
            ]
          };
        }
        addToCharges();
      }
    },
    applyInventoryHandling(i, addBoxToInventory) {
      var services = this.shipment.estimate[this.getEstimateKey()].shipment_service;
      if (i.handling) {
        services.forEach(s => {
          if (!s.estimate_charges) {
            s.estimate_charges = [];
          }
          // var charges = s.estimate_charges;
          Object.keys(i.handling).forEach(key => {
            if (key == "packing") {
              i.handling.packing.forEach(p => {
                this.addToMaterials(
                  {
                    _id: i._id,
                    material_name: p.material_name,
                    packingId: p._id,
                    qty: i.qty * p.qty,
                    room: i.room
                  },
                  s.estimate_charges,

                  addBoxToInventory
                );
              });
            } else if (key != "prompt") {
              var chargeName = fun.capitalize(key) + " - " + i.item;
              var charge = s.estimate_charges.find(item => item.charge === chargeName);

              if (charge) {
                charge.qty = parseInt(i.qty || 0);
                charge.subtotal = i.handling[key] * charge.qty;
              } else {
                s.estimate_charges.push({
                  qty: parseInt(i.qty || 0),
                  subtotal: i.handling[key] * i.qty,
                  estimate_rate: [
                    {
                      rate_name: key,
                      rate: i.handling[key] || 0,
                      qty: i.qty
                    }
                  ],

                  charge: chargeName,
                  charge_category: "accessorials"
                });
              }
            }
          });
        });
      }
    },

    applyItemMaterials() {
      var service = this.model.estimate[this.getEstimateKey()].shipment_service[0];
      if (!service.estimate_charges) {
        service.estimate_charges = [];
      }
      this.model.inventory.forEach(i => {
        try {
          if (i.item.startsWith("(CP) ")) {
            this.addToMaterials(
              {
                material_name: i.item.replace("(CP) ", ""),
                qty: i.qty,
                _id: i._id
              },
              service.estimate_charges,
              {},
              true
            );
          }
          if (i.handling && i.handling.packing) {
            i.handling.packing.forEach(p => {
              this.addToMaterials(
                {
                  material_name: p.material_name,
                  qty: p.qty * i.qty,
                  packingId: p._id,
                  _id: i._id,
                  room: i.room
                },
                service.estimate_charges
              );
            });
          }
        } catch (error) {
          //
        }

        // });
      });
    },
    hasInventory(serviceType) {
      return this.additionalModel.service_type.find(t => {
        return t.service_type == serviceType;
      }).has_inventory;
    },
    getDefaultServiceType(moveType) {
      if (!moveType) {
        return;
      }
      var defaultType = this.additionalModel.service_type.find(t => {
        return t.default_type_of_move == moveType;
      });
      if (defaultType) {
        return defaultType;
      }

      switch (moveType) {
        case "local":
          return this.additionalModel.service_type.find(t => {
            return t.service_type.toLowerCase().includes("local");
          });

        case "interstate":
          return this.additionalModel.service_type.find(t => {
            return t.service_type.toLowerCase().includes("long");
          });

        case "short_haul":
          return this.additionalModel.service_type.find(t => {
            return t.service_type.toLowerCase().includes("short");
          });

        case "international":
          return this.additionalModel.service_type.find(t => {
            return t.service_type.toLowerCase().includes("international");
          });

        default:
          return "";
      }
    },
    canUpdateAddress(address_id) {
      // if (this.moreData) {
      //   const allStops = this.moreData.shipment.flatMap(item => item.stops);
      //   if (
      //     allStops.filter(s => {
      //       return s.address_id == address_id;
      //     }).length > 1
      //   ) {
      //     return false;
      //   }
      // }

      // const otherCustomerShipments = this.moreData.shipment.filter((s) => {
      //   return s.shipment_id != this.shipmentId;
      // });
      // otherCustomerShipments.forEach((shipment) => {
      //   if (
      //     shipment.stops.some((s) => {
      //       return s.address_id == address_id;
      //     })
      //   ) {
      //     return false;
      //   }
      // });
      return false;
    },
    deleteStop(deletedItem) {
      this.shipment.estimate["non-binding"].shipment_service[
        this.serviceIndex
      ].shipment_stop = this.shipmentStops().filter(s => {
        return s._id != deletedItem._id;
      });
      var canDelete = this.canUpdateAddress(deletedItem.address_id);

      if (canDelete) {
        this.shipment.customer.address = this.shipment.customer.address.filter(a => {
          return a._id != deletedItem.address_id;
        });
      }
      // this.loadModel({obj:deletedItem.value})
      this.currentModel = this.getModel({ obj: deletedItem.value });
    },
    deleteCharges(charges) {
      console.log(charges);
    },
    compareModel() {
      this.lastModified = fun.formatDate(new Date(), false, true);
      var history = "crm";
      this.compareObjects({
        exclude: history
      });
      try {
        this.originalModel = fun.clone(this.shipment);
        if (!this.shipment[history] || !this.shipment[history].length) {
          this.shipment[history] = [];
        }
        if (!this.shipment.crm) {
          this.shipment.crm = [];
        }

        this.shipment[history] = this.shipment[history].concat(this.modifiedRecords);
        this.shipment[history] = this.shipment[history].filter(
          (obj, index, self) =>
            index === self.findIndex(t => obj && t.description === obj.description && t.time_stamp === obj.time_stamp)
        );
      } catch (error) {
        //
      }
    },
    compareObjects(par) {
      var lastTimeStamp = fun.formatDate(new Date(), false, true);
      var newObj = par.newObj || this.shipment;
      var oldObj = par.oldObj || this.originalModel;
      var exclude = par.exclude;
      var that = this;
      var arrayKey = par.arrayKey;
      var topObject = null;
      var parKey = "";
      var keys = [];
      if (!par.keys) {
        keys = [];
      } else {
        keys = keys.concat(par.keys);
      }
      var removeWrongKeys = function(v, obj) {
        var cloneKeys = fun.clone(keys);
        cloneKeys.forEach(k => {
          if (obj && obj[k]) {
            try {
              if (JSON.stringify(obj[k]).indexOf(v) == -1) {
                keys.splice(keys.indexOf(k), 1);
              }
              removeWrongKeys(v, obj[k]);
            } catch (error) {
              //
            }
          }
        });
      };
      var getPath = function(myKey, v, obj) {
        removeWrongKeys(v, obj);
        if (!Array.isArray(obj)) {
          Object.keys(obj).forEach(k => {
            if (k != exclude && k != "undefined") {
              if (obj[k] && typeof obj[k] == "object") {
                if (JSON.stringify(obj[k]).indexOf(v) != -1) {
                  keys.push(k);
                  getPath(k, v, obj[k]);
                }
              } else if (obj[k]) {
                if (obj[k] == v[k]) {
                  keys.push(k);
                }
              }
            }
          });
        }

        return keys;
      };

      var addtoModified = function(k, type, newValue, oldValue) {
        var v = "";
        if (!newValue) {
          newValue = "";
        }
        if (!oldValue) {
          oldValue = "";
        }
        var newData = newValue.toString().trim();
        var oldData = oldValue.toString().trim();
        var objToSeach = newObj;
        if (oldValue) {
          v = '"' + k + '"' + ":" + '"' + newValue + '"';
          newData = newValue;
        } else {
          v = JSON.stringify(newValue);
          if (type == "value removed") {
            oldData = JSON.stringify(newValue[k]);
            objToSeach = that.originalModel;
          }
        }

        if (type == "record deleted") {
          oldData = JSON.stringify(newValue);
        }
        var dateModified = new Date();

        var fullPath = "";

        if (!arrayKey) {
          fullPath = getPath(k, v, objToSeach);
        } else {
          fullPath = arrayKey;
        }
        if (type == "value added" || type == "record added") {
          newData = "";
        }
        var myPath = fun.clone(fullPath);
        if (arrayKey) {
          myPath = fun.clone(arrayKey);
        }
        if (!myPath) {
          myPath = [];
        }
        myPath.push(k);
        // var changedField = "";
        if (myPath.length > 2) {
          myPath = myPath.splice(myPath.length - 2);
        }
        var flds = [];
        myPath.forEach(p => {
          // flds.push(fun.capitalize(p));
          flds.push(p);
        });
        try {
          if (k == "company") {
            oldData = that.additionalModel.company.filter(c => {
              return c._id == oldData;
            })[0].company_name;
            newData = that.additionalModel.company.filter(c => {
              return c._id == newData;
            })[0].company_name;
          }
        } catch (error) {
          //
        }
        try {
          if (k == "address" && flds.length == 2) {
            var stopType = that.activeTab.obj.obj;

            flds[0] = stopType;
          }
        } catch (error) {
          //
        }
        var capFilds = [];
        flds.forEach(f => {
          capFilds.push(fun.capitalize(f));
        });

        var description = `${capFilds.join(" ")} changed from ${oldData || "none"} to ${newData || "none"}`;
        var isObject = false;
        try {
          JSON.parse(oldData);
          isObject = true;
        } catch (error) {
          //
        }
        try {
          JSON.parse(newData);
          isObject = true;
        } catch (error) {
          //
        }
        isObject = typeof oldData === "object" && oldData !== null;
        var defaultData = ["origin_address", "destination_address"];
        if (oldData && !isObject && !defaultData.includes(oldData)) {
          var color = that.crmTypes.filter(s => {
            return s.value == "history";
          })[0].color;
          var modRec = {
            type: k == "status" ? "status" : "history",
            description: description,
            new_data: newData,

            time_stamp: lastTimeStamp,
            user: that.currentUser,
            color: color
          };
          var exists = that.modifiedRecords.some(r => {
            return r.description == modRec.description && r.time_stamp == modRec.time_stamp;
          });

          if (!exists) {
            // if (lastTimeStamp == that.lastModified) {
            var curRec = that.modifiedRecords.find(m => {
              return m.time_stamp == that.lastModified && m.type == modRec.type;
            });
            if (curRec) {
              if (!curRec.description.includes(description)) {
                curRec.description += "<br>" + description;
              }
            } else {
              that.modifiedRecords.push(modRec);
            }
          }
        }
      };

      var compareArrays = function(a, b, deleted) {
        if (a && b && Array.isArray(a) && Array.isArray(b)) {
          var status = "record added";
          if (deleted) {
            status = "record deleted";
          }
          var arrSchema = fun.getObjectByKey(that.schema.properties, parKey);
          if (arrSchema) {
            var nameKey = arrSchema.name_key;
          }
          if (!arrayKey) {
            arrayKey = [];
          }
          if (a.length == b.length) {
            status = "record changed";
            a.forEach((r, i) => {
              if (JSON.stringify(r) != JSON.stringify(b[i])) {
                arrayKey = getPath(parKey, JSON.stringify(r), newObj);

                if (nameKey) {
                  arrayKey.push(r[nameKey]);
                }
                try {
                  that.compareObjects({
                    newObj: r,
                    oldObj: b[i],
                    arrayKey: arrayKey,
                    keys: keys
                  });
                } catch (error) {
                  //
                }
              }
            });
          } else {
            a.forEach(r => {
              if (
                !b.filter(n => {
                  return n._id == r._id;
                }).length
              ) {
                arrayKey = getPath(parKey, JSON.stringify(r), newObj);
                if (nameKey) {
                  arrayKey.push(r[nameKey]);
                }
                addtoModified("", status, r);
              }
            });
          }
        }
      };
      var comp = function(a, b) {
        if (Array.isArray(a)) {
          if (a.length >= b.length) {
            compareArrays(a, b);
          } else {
            compareArrays(b, a, true);
          }
        } else {
          if (a && b && Array.isArray(a) == Array.isArray(b)) {
            if (!topObject) {
              topObject = a;
            }
            try {
              var strA = JSON.stringify(a);
              var strTop = JSON.stringify(topObject);
              if (strA != strTop) {
                // object is not top object

                if (strTop.indexOf(strA) == -1) {
                  //object is not child of top object
                  topObject = a;
                }
              }
            } catch (error) {
              //
            }

            var checkingObj = a;
            var comparableObj = b;
            var isKeyRemoved = Object.keys(b).length > Object.keys(a).length;
            if (isKeyRemoved) {
              checkingObj = b;
              comparableObj = a;
            }

            Object.keys(checkingObj).forEach(k => {
              try {
                if (k != exclude && k != "_id" && (!checkingObj.geo || k == "address")) {
                  if (JSON.stringify(checkingObj[k]) != JSON.stringify(comparableObj[k])) {
                    parKey = k;
                    // changedKey.push(k);
                    if (typeof checkingObj[k] == "object") {
                      if (comparableObj[k]) {
                        comp(checkingObj[k], comparableObj[k]);
                      } else {
                        var action = "value added";
                        if (isKeyRemoved) {
                          action = "value removed";
                        }

                        addtoModified(k, action, checkingObj);
                      }
                    } else if (Array.isArray(checkingObj[k])) {
                      if (checkingObj[k].length >= comparableObj[k].length) {
                        //new obj added row or row modified
                        checkingObj[k].forEach((r, i) => {
                          if (comparableObj[k][i]) {
                            comp(r, comparableObj[k][i]);
                          } else {
                            addtoModified(k, "record added", r);
                          }
                        });
                      } else {
                        //new obj deleted row
                        comparableObj[k].forEach((r, i) => {
                          if (!checkingObj[k][i]) {
                            comp(r, comparableObj[k][i]);
                          } else {
                            addtoModified(parKey, "record deleted", r);
                          }
                        });
                      }
                    } else {
                      addtoModified(k, "value changed", checkingObj[k], comparableObj[k]);
                    }
                  }
                }
              } catch (error) {
                //
              }
            });
          }
        }
      };

      comp(newObj, oldObj);
    },

    addDefaultShipmentDetail() {
      if (!this.shipment.shipment_detail) {
        this.shipment.shipment_detail = {};
      }
      //
      this.shipment.shipment_detail.sales_person = this.$root.user_id;

      this.shipment.shipment_detail.status = "new";
      this.shipment.shipment_detail.order_date_time = fun.formatDate(new Date(), false, true, true);

      this.addDefaultCRM();
    },
    addTab() {
      var that = this;
      this.$root.resentTabs.filter(t => {});
      var resentTab = this.$root.resentTabs.find(obj => obj["text"] === "New Shipment");
      if (resentTab) {
        var customerName =
          that.shipment.customer.customer_name != undefined
            ? that.shipment.customer.customer_name
            : that.shipment.customer.contact.first_name + " " + that.shipment.customer.contact.last_name;
      }

      if (resentTab) {
        const index = that.$root.resentTabs.findIndex(obj => obj.link === resentTab.link);
        // const newIndex= that.$root.resentTabs.length
        that.$root.removeResentTab(index);
        // }
      }

      that.$root.addResentTab({
        customer_name: customerName,

        shipment_id: that.shipmentId
      });
    },
    addDefaultCRM() {
      var crm = {
        type: "status",
        description: "New Estimate Created",
        status: "new",
        user: this.$root.user_email,
        time_stamp: fun.formatDate(new Date(), false, true)
      };
      this.shipment.crm = [crm];
    },
    calculateTotal() {
      try {
        var total = 0;
        this.shipment.estimate["non-binding"].shipment_service.forEach(s => {
          if (s.is_flat_rate) {
            total += parseFloat(s.flat_rate);
            s.estimate_charges.forEach(c => {
              if (!c.included_in_flat) {
                total += parseFloat(c.subtotal);
              }
            });
          } else {
            s.estimate_charges.forEach(c => {
              total += parseFloat(c.subtotal || 0);
            });
          }
        });

        this.shipment.total_estimate = total.toFixed(2);
      } catch (error) {
        // console.log(error);
      }
    },
    calculateInventoryVolume() {
      this.groupPacking();
      var materialVolume = 0;
      try {
        var packingItems = this.currentService.estimate_charges?.filter(p => {
          return p.charge_category == "packing";
        });
        const materialMap = Object.fromEntries(
          this.additionalModel.material_list.map(m => [m.material_name.toLowerCase(), m])
        );

        const inventoryBoxes = packingItems
          .map(p => {
            const material = materialMap[p.charge?.toLowerCase()];
            if (!material) return null;

            const cuFt = Number(material.cu_ft);
            if (!Number.isFinite(cuFt) || cuFt <= 0) return null;

            const containerRate = p.estimate_rate?.find(r => r.rate_name === "container");
            if (!containerRate || !Number.isFinite(Number(containerRate.qty))) return null;

            return {
              cu_ft: cuFt,
              qty: Number(containerRate.qty)
            };
          })
          .filter(Boolean);

        console.log(inventoryBoxes);
        const room = "CP Boxes";
        this.shipment.inventory = this.shipment.inventory.filter(it => {
          return it.room != room;
        });
        packingItems.forEach(p => {
          try {
            const material = materialMap[p.charge?.toLowerCase()];
            if (material && material.cu_ft) {
              var inInventory = this.shipment.inventory.find(it => {
                return it.item == p.charge && it.room == room;
              });
              if (!inInventory) {
                this.shipment.inventory.push({
                  room: room,
                  item: p.charge,
                  volume: material.cu_ft,
                  qty: p.estimate_rate[0].qty
                });
              }
              // else {
              //   inInventory.qty = p.estimate_rate[0].qty;
              // }
            }
          } catch (error) {
            //
          }
        });
        // this.submit();

        materialVolume = inventoryBoxes.reduce((sum, item) => sum + item.cu_ft * item.qty, 0);
        this.shipment.material_volume = materialVolume;
      } catch (error) {
        //
      }
      var inventory_volume = fun.calculateInventoryVolume(this.shipment.inventory) || 0;
      this.shipment.num_items = 0;
      this.shipment.num_items = this.shipment.inventory.reduce((sum, i) => sum + Number(i.qty || 0), 0);
      this.shipment.volume = inventory_volume.toFixed(1);
      this.shipment.material_volume = isNaN(materialVolume) ? 0 : materialVolume;
      this.shipment.weight = (inventory_volume * 7).toFixed(1);
    },
    sendMessageToObject(type, messageData) {
      const objectsOnDemand = fun.getObjects(this.currentSchema, "x-display", "object-on-demand");
      objectsOnDemand.forEach(d => {
        const data = fun.getObjectsByKey(this.currentModel, d.object_name_to_update);
        if (data) {
          fun.sendMessageToIframe(`${d.object_name_to_update}-${data[0]}`, type, messageData);
        }
      });
    },

    submit(feedback, collapsePanels, form) {
      this.saving = true;

      // this.$root.$emit("parentSaving", this);
      // const objectsOnDemand = fun.getObjects(this.currentSchema, "x-display", "object-on-demand");
      // objectsOnDemand.forEach(d => {
      //   const data = fun.getObjectsByKey(this.currentModel, d.object_name);
      //   if (data) {
      //     fun.sendMessageToIframe(`${d.object_name}-${data[0]}`, "PARENT_SAVING");
      //   }
      // });
      //
      // this.sendMessageToObject("PARENT_SAVING");
      var that = this;
      var fromWizard = false;
      if (form) {
        fromWizard = true;
      }
      // if (this.currentModel && this.currentModel.order_date_time) {
      //   this.shipment.shipment_detail = this.currentModel;
      // }

      try {
        if (!form) {
          form = this.$refs.form;
        }
        if (form && !form.validate()) {
          return;
        }
      } catch (error) {
        //
      }

      var status = this.additionalModel.lead_status.find(s => {
        return s.status == this.shipment.shipment_detail.status;
      });
      var company = this.additionalModel.company[0];
      try {
        company = this.additionalModel.company.find(c => {
          return c._id == this.shipment.shipment_detail.company._id;
        });
      } catch (error) {
        //
      }
      if (!company) {
        company = this.additionalModel.company[0];
      }
      var apiCall = "";
      var apiData = null;
      if (status) {
        apiCall = status.api_call;
        apiData = {
          s_id: this.shipment._id
        };
        apiData = {
          ...apiData,
          ...status,
          ...company
        };
      }
      this.populateDefaultAddresses();

      this.shipmentStops().forEach(s => {
        // delete s.location;
        if (!s.use_existing) {
          delete s.existing_address;
        }
        // delete s.use_existing;
        //
      });
      if (collapsePanels) {
        this.panelIndex = -1;

        this.mapCols = null;
      }
      delete this.shipment.shipment_service;
      try {
        if (this.shipment.payment.payment) {
          this.shipment.payment = this.shipment.payment.payment;
        }
      } catch (error) {
        //
      }

      this.shipment.customer.address = this.shipment.customer.address.filter(a => {
        return !a.existing_address;
      });

      try {
        if (!this.shipment.shipment_detail.status) {
          this.shipment.shipment_detail.status = "new";
        }
        this.shipment.customer.address.forEach(a => {
          if (a.location && a.location.address && a.location.address.address) {
            a.full_address = a.location.address.address;
            a.location.address.full_address = a.location.address.address;
          }
          delete a.value;
          delete a.use_existing;
        });
      } catch (error) {
        //
      }
      // this.compareModel();
      this.createStops();
      // if (!this.shipmentId) {
      this.createTasks();
      this.calculateInventoryVolume();
      // }
      // if (this.currentModel?.itinerary) {
      //   // this.mainService.itinerary = this.currentModel.itinerary;
      //   this.shipment.estimate[
      //     "non-binding"
      //   ].shipment_service[0].itinerary = this.currentModel.itinerary;
      // }
      var data = {
        metadata: {
          object_name: "shipment",
          current_user: this.$root.user_email,
          excluded_keys: [
            "history",
            "geo",
            "allLocation",
            "text",
            "title",
            "value",
            "shape",
            "route",
            "address",
            "waypoints",
            "location",
            "warehouse"
          ],
          history_key: "crm",
          update_history: true,
          api_call: apiCall,
          api_data: apiData,
          portal_id: this.$root.portal_id
        },
        model: this.shipment
      };
      if (this.$root.customerId) {
        this.shipment.submitted_by_customer = true;
      }
      if (!navigator.onLine) {
        fun.queueOffline(data);
        this.noConnection = "No internet connection. Data saved locally and will be sent when connection is restored.";
        that.dialog = false;
        return;
      }

      this.axios
        .post(this.serverURL + "/add_data", data, {
          withCredentials: true
        })
        .then(response => {
          // console.log(response);
          // this.$nextTick(() => {
          that.modifiedRecords = [];
          this.loadWizard();
          if (!that.shipmentId) {
            that.shipment._id = response.data._id;
            that.shipment.shipment_id = response.data.shipment_id;
            that.shipmentId = response.data.shipment_id;
            that.shipment.customer._id = response.data.customer_id;

            window.location.hash = `#shipment/${that.shipmentId}`;

            var link = "/shipment/" + that.shipmentId;

            that.addTab();
            if (fromWizard) {
              return this.shipmentId;
            }
          } else {
            // this.$router.push({ path: "/shipment/" + that.shipmentId });
          }
          var service = this.shipment.estimate["non-binding"].shipment_service[this.serviceIndex];
          this.assignCustomerName();
          try {
            if (service.shipment_stop[0].full_address && service.shipment_stop[1].full_address) {
              if (!service.service_type || this.$root.customerId) {
                service.service_type = response.data.service_type;
              }

              that.serviceType = fun.capitalize(response.data.service_type);
              if (response.data.service) {
                that.mileage = response.data.service.mileage;
              }
            }
          } catch (error) {
            //
          }

          that.updateTitles();
          if (collapsePanels) {
            that.dialog = false;
          }
          // if (!fromWizard) {

          that.buildDiagramFromShipmentFromConfig();
          // }
          that.saving = false;
          if (feedback) {
            feedback();
          }
        });
    },
    expandPanel(obj, noValidate) {
      if (obj) {
        this.mapCols = 12;
        this.modelReady = false;
        this.dialog = false;
        this.currentObject = obj.objectName;
        if (obj.obj == "pickup" || obj.obj == "dropoff") {
          this.currentStopType = obj.obj;
        } else {
          this.currentStopType = "";
        }
        // that.addTab(obj);
        if (obj.obj == "estimate" && this.newShipment) {
          // this.calculate();
          this.loadModel(obj);
          //
        } else {
          this.loadModel(obj);
        }
      } else {
        this.mapCols = null;
      }
      this.updateTitles();
    },
    getTotalPayment() {
      this.totalPayment = 0;
      if (this.shipment.payment && Array.isArray(this.shipment.payment)) {
        this.shipment.payment.forEach(p => {
          this.totalPayment += parseFloat(p.amount);
        });
      }
      this.totalPayment = this.totalPayment.toFixed(2);
    },
    getTotalEstimate(model) {
      // var estimateKey = model.estimate
      //   ? Object.keys(model.estimate)[0]
      //   : "non-binding";
      var services = this.shipment.estimate["non-binding"].shipment_service;

      this.totalEstimate = 0;
      var getTotal = function(s) {
        var total = 0;
        total += parseFloat(s.flat_rate);
        s.estimate_charges.forEach(c => {
          if (!c.included_in_flat) {
            total += parseFloat(c.subtotal);
          }
        });
        return total;
      };
      services.forEach(s => {
        if (s.estimate_charges) {
          s.total_estimate = s.is_flat_rate
            ? getTotal(s)
            : s.estimate_charges.reduce((sum, item) => sum + parseFloat(item.subtotal), 0).toFixed(2);
          if (s.total_estimate && !isNaN(s.total_estimate)) {
            this.totalEstimate += parseFloat(s.total_estimate);
          }
          s.estimate_charges.forEach(c => {
            if (!c.actual) {
              c.actual = c.subtotal;
            }
          });
          s.total_actual = s.estimate_charges.reduce((sum, item) => sum + parseFloat(item.actual), 0).toFixed(2);
        }
      });
      const totalPayment = (this.shipment.payment || []).reduce((sum, p) => sum + (parseFloat(p.amount) || 0), 0);
      this.balance = this.totalEstimate - totalPayment;
      this.balance = this.balance.toFixed(2);
      this.shipment.balance = this.balance;
      this.totalEstimate = parseFloat(this.totalEstimate).toFixed(2);
      if (!this.currentService) {
        this.currentService = this.shipment.estimate["non-binding"].shipment_service[this.serviceIndex || 0];
      }

      this.currentService.total_estimate = this.totalEstimate;
      return this.totalEstimate;
      // }
    },
    calculate(feedback) {
      var that = this;
      if (this.$root.customerId) {
        that.currentService = that.shipment.estimate["non-binding"].shipment_service[this.serviceIndex || 0];
        that.currentService["estimate_charges"] = [];
      }
      this.loadingCalculation = true;
      this.submit(s => {
        var data = { shipment_id: this.shipmentId, charges_only: true };
        this.axios
          .post(this.serverURL + "/calculate_shipment", data, {
            withCredentials: true
          })
          .then(response => {
            console.log(response);
            this.loadingCalculation = false;
            var obj = this.getWizardStep("estimate");
            var estimate = this.getModel(obj);
            // this.currentModel = this.getModel(obj);
            var calculatedCharges = this.fixJson(response.data);
            // if (!that.currentService) {
            that.currentService = that.shipment.estimate["non-binding"].shipment_service[this.serviceIndex || 0];
            // }
            that.currentService["estimate_charges"] = calculatedCharges.charges;
            if (calculatedCharges.unit_rate && !that.currentService.rate) {
              that.currentService.rate = calculatedCharges.unit_rate;
            }
            that.currentService.job_hrs = calculatedCharges.crew?.job_hrs;
            that.currentService.t_time = calculatedCharges.crew?.t_time;
            that.currentService.num_men = calculatedCharges.crew?.num_men;
            if (calculatedCharges.resources) {
              that.currentService.resources = calculatedCharges.resources;
            }

            this.getTotalEstimate();
            // that.currentModel = response.data;
            // this.currentModel = {
            //   estimate_charges: this.fixJson(response.data),
            // };

            that.loadModel(obj);
            if (feedback) {
              feedback();
            }
            that.$root.$emit("charges_calculated", that.shipmentId);
            // that.refreshData(
            //   that.openBlock({ id: "estimate", title: "Calculated Charges" })
            // );
          });
      });
    },
    getIconColor(item) {
      return item.info && item.info != "Not Booked" && item.info != "0.00" ? "info" : "grey";
    },
    loadModel(obj) {
      this.readOnly = false;
      if ((obj.foremanReadOnly && this.foreman) || this.allReadOnly) {
        this.readOnly = true;
      }
      this.currentModel = this.getModel(obj);

      if (obj.objectName == "customer" && !this.shipmentId) {
        var contact = {
          // first_name: "Test",
          // last_name: "Customer",
          // email: "test@customer.com",
        };
        this.currentModel.customer.contact = {
          ...this.currentModel.customer.contact,
          ...contact
        };
      }

      this.currentSchema = this.getSchema(obj);
      switch (obj.obj) {
        case "additional_services":
          obj.model = [];
          this.additionalModel.service_type
            .filter(s => {
              return s.default_cojob;
            })
            .forEach((j, i) => {
              obj.model[i] = {
                _id: fun.guid(),
                service_type: fun.capitalize(j.service_type)
              };
            });
          this.shipment.additional_services = obj.model;
          break;

        case "job":
        case "booking":
          var id = obj.id;
          var index = 0;
          if (id) {
            index = id.split("_")[1];
          }
          if (obj.index) {
            index = obj.index;
          }
          obj.additionalModel = {};
          obj.additionalControl = {
            add_option_object: {
              objName: "service_type",
              itemText: "service_type",
              itemValue: "service_type",
              capitalizeText: true
            },

            add_btn_title: "Add Co-Job",
            properties: {},
            add_service: {
              "x-display": "v-label-button",

              "v-bind": {
                noCustomItem: true,
                color: "green",
                addBtn: true,
                noCustomer: true,
                text: true,
                icon: "mdi-shape-square-plus",
                "input-value": "Add Co-Job",
                class: "special-button"
                // add_btn_title: "Additional Service",
              }
            }
          };
          // if (index && Array.isArray(this.currentService)) {
          //   this.currentService = this.currentService[index];
          // }
          if (!this.currentService?.shipment_stop || !this.currentService?.shipment_stop.length) {
            this.currentService.shipment_stop = fun.clone(this.shipment.currentStops);
          }
          this.currentModel.shipment_service = Array.isArray(this.currentService)
            ? this.currentService
            : [this.currentService];
          break;
        case "customer_":
          console.log(this.shipment);
          if (this.shipment.department_id && this.shipment.customer.department) {
            var department = this.shipment.customer.department.find(d => {
              return d._id == this.shipment.department_id;
            });
            obj.additionalModel = {
              department: department
            };
            obj.additionalControl = {
              department: fun.clone(this.currentSchema.customer.properties.department)
            };
            var dep = obj.additionalControl.department;
            dep["v-if-parameter"] = "";
            dep["x-display"] = "";
            dep["title"] = "";
            // .customer.properties.contact.properties;
            dep.properties.company = {};
            department.company = this.shipment.customer.company;
            dep.properties.department_name["v-bind"] = { readonly: true };
            dep.properties.company["v-bind"] = { readonly: true };
            Object.keys(dep.properties.contact.properties).forEach(k => {
              if (!dep.properties.contact.properties[k]["v-bind"]) {
                dep.properties.contact.properties[k]["v-bind"] = {};
              }
              dep.properties.contact.properties[k]["v-bind"].readonly = true;
            });
            this.readOnly = true;
            dep.properties.contact.properties["password"].hidden = true;
            dep.properties.edit = {
              type: "object",
              "x-display": "v-btn",
              id: "editContact",
              hideTitle: true,
              "v-bind": {
                "input-value": "Edit Contact",
                icon: "mdi-pencil",
                item: "customer_id",
                text: true
              }

              //             "tab": 0,
            };
            this.addControlKey = !this.addControlKey;
          } else {
            this.readOnly = false;
          }
          break;
        case "letters":
          console.log("letters");
          break;
        case "estimate":
          this.currentSchema.shipment_service["v-bind"].noAdd = true;
          if (this.$root.customerId) {
            this.currentSchema.shipment_service.properties = {
              estimate_charges: this.currentSchema.shipment_service.properties.estimate_charges
            };
            // this.currentSchema.shipment_service.properties = {};
            // this.calculate();
            this.customerEstimate = true;
          }
          // if (this.currentModel.shipment_service[0].estimated_charges) {
          //   this.currentModel[0].estimated_charges = this.currentModel.estimated_charges;
          // }
          break;
        case "payment":
          if (this.$root.customerId) {
            this.currentSchema.payment["v-bind"].noDelete = true;
            var keysToDelete = ["ach", "comments", "payment_type", "payment_date"];
            Object.keys(this.currentSchema.payment.table_properties.schema.properties).forEach(k => {
              if (keysToDelete.includes(k)) {
                this.currentSchema.payment.table_properties.schema.properties[k].hidden = true;
              }
            });

            this.currentSchema.payment.table_properties.schema.properties.payment_type.default = "credit_card";

            this.customerPayment = true;
          }
          break;
        case "crm":
          if (obj.recordId) {
            this.currentSchema.crm["x-display"] = null;
            this.currentModel.crm = this.currentModel.crm.find(r => {
              return r._id == obj.recordId;
            });
          }
          break;

        case "shipment_info":
          this.getDefaultValuesForInternationalShipment();
          break;
        default:
          if (this.currentService) {
            this.getTotalEstimate();
            this.getTotalPayment();
          }

          break;
      }

      this.modelReady = true;
      this.formKey = !this.formKey;
    },
    getWizardStep(obj) {
      return (
        this.wizardSteps.find(w => {
          return w.obj == obj;
        }) || {}
      );
    },
    getLocation(stopType) {
      var stops = this.shipment.estimate[this.getEstimateKey()].shipment_service[0].shipment_stop;
      var st = stops.filter(s => {
        return s.value == stopType || s.stop_type == stopType;
      })[0];
      var location = this.shipment.customer.address.filter(a => {
        return st && a.full_address == st.full_address;
      })[0];
      // console.log(location);
      if (!location) {
        location = this.getLocationFromWarehouse(st);
      }

      return location;
    },
    getLocationFromWarehouse(st) {
      var location = {};
      var warehouse = this.additionalModel.warehouse.find(a => {
        return a.address && a.address.address == st.full_address;
      });
      if (warehouse) {
        var whsAddr = warehouse.address ? warehouse.address.address : "";
        if (warehouse.address) {
          var geo = warehouse.address.geo || warehouse.geo;
          if (geo) {
            location = {
              full_address: whsAddr,
              location: {
                full_address: whsAddr,
                dwelling_type: {
                  dwelling_type: "storage"
                },
                warehouse_id: warehouse._id,
                is_warehouse: true,
                address: {
                  address: whsAddr,

                  geo: {
                    location: {
                      address: geo.location.address || geo.location,
                      position: geo.location.position || geo.position
                    }
                  }
                }
              }
            };
          }
        }
      }
      return location;
    },
    fixJson(invalidJson) {
      try {
        let validJson = invalidJson
          .replace(/\bTrue\b/g, "true")
          .replace(/\bFalse\b/g, "false")
          .replace(/\bNone\b/g, "null")
          .replace(/'/g, '"') // Replace all single quotes with double quotes.
          .replace(/(\w+):/g, '"$1":'); // Add quotes around keys without quotes.
        // Parse the corrected JSON string.
        let parsed = JSON.parse(validJson);
        return parsed;
      } catch (e) {
        // console.error("Invalid JSON format", e);
      }
    },
    createItinerary(m) {
      if (!m.itinerary || !m.itinerary.length) {
        var itinerary = [];
        var origin = this.getLocation("pickup");
        var destination = this.getLocation("dropoff");
        var warehouseOrig = this.getWarehouse(origin.location);
        var warehouseDest = this.getWarehouse(destination.location);
        var sType = this.additionalModel.service_type.filter(t => {
          return t.service_type == m.service_type;
        })[0];
        var defaultItinerary = null;
        if (sType && sType.default_itinerary && sType.default_itinerary.length) {
          defaultItinerary = {};
          defaultItinerary.default_itinerary = sType.default_itinerary;
        }

        if (!defaultItinerary) {
          defaultItinerary = { default_itinerary: ["d2d"] };
        }
        if (defaultItinerary) {
          defaultItinerary.default_itinerary.forEach(i => {
            var itineraryStep = {
              _id: fun.guid(),
              step: i
            };
            var addProperties = {};

            switch (i) {
              case "d2d":
                addProperties = {
                  etd: m.service_date,
                  pickup_status: m.booked ? "booked" : "pending",
                  delivery_status: m.booked ? "booked" : "pending",
                  haul_type: "internal",
                  agent: {
                    _id: this.shipment.shipment_detail.company
                  },
                  crew: {},
                  origin: origin.full_address,
                  destination: destination
                };
                break;
              case "d2w":
                addProperties = {
                  etd: m.service_date,
                  haul_type: "internal",
                  pickup_status: m.booked ? "booked" : "pending",
                  delivery_status: "pending",

                  agent: this.getAgent(origin.location),
                  crew: {},
                  origin: origin.full_address
                };
                if (warehouseOrig) {
                  addProperties.warehouse = {
                    _id: warehouseOrig._id,
                    warehouse_name: warehouseOrig.warehouse_name
                  };
                }
                break;
              case "w2w":
                addProperties = {
                  // haul_type: "internal",
                  pickup_status: m.booked ? "booked" : "pending",
                  delivery_status: "pending",

                  crew: {}
                };
                if (warehouseDest) {
                  addProperties.warehouse = {
                    _id: warehouseDest._id,
                    warehouse_name: warehouseDest.warehouse_name
                  };
                }
                break;
              case "w2d":
                addProperties = {
                  // haul_type: "internal",
                  pickup_status: m.booked ? "booked" : "pending",
                  delivery_status: "pending",
                  destination: destination.full_address,

                  crew: {}
                };
                if (warehouseOrig) {
                  addProperties.warehouse = {
                    _id: warehouseOrig._id,
                    warehouse_name: warehouseOrig.warehouse_name
                  };
                }

                break;
            }

            itinerary.push({ ...itineraryStep, ...addProperties });
          });
        }

        m.itinerary = itinerary;
      }
    },
    getAgent(location) {
      var agent = this.additionalModel.agent;

      var curAgent = agent.find(
        item =>
          item.zones &&
          item.zones.some(zone => location && location.carrier_zone && zone._id === location.carrier_zone.zone_id)
      );
      return curAgent;
    },
    getWarehouse(location) {
      if (location && location.zone) {
        var warehouse = this.additionalModel.warehouse;
        if (!location.carrier_zone) {
          location.carrier_zone = location.zone;
        }
        var zones = this.additionalModel.zone;
        var curZone = zones.filter(z => {
          return z._id == location.carrier_zone.zone_id;
        })[0];
        var curWhs;
        if (curZone) {
          if (curZone.default_sit) {
            curWhs = warehouse.filter(w => {
              return w._id == curZone.default_sit._id;
            })[0];
          } else {
            // curWhs = this.getClosestWhs(location, warehouse);
            curWhs = warehouse.find(
              item => item.zones && item.zones.some(zone => zone._id === location.carrier_zone.zone_id)
            );
          }
        }

        return curWhs;
      }
    },
    getClosestWhs(location, warehouse) {
      var pos = fun.deepFind(location, "address.geo.location.position");
      if (pos) {
        var mileage = 100000;
        var closestWhs = null;
        warehouse.forEach(w => {
          var whsPos = fun.deepFind(w, "geo.position");
          if (whsPos) {
            var m = fun.mileage(pos[0], pos[1], whsPos[0], whsPos[1]);
            if (parseFloat(m) && parseFloat(m) < mileage) {
              mileage = parseFloat(m);
              closestWhs = w;
            }
          }
        });
      }
      return closestWhs;

      //
    },
    capitalize(s) {
      return fun.capitalize(s);
    },
    updateTitles() {
      var allServices = this.shipment.estimate["non-binding"].shipment_service;
      var services = [this.currentService];
      if (
        this.getWizardStep("itinerary") &&
        // !this.getWizardStep("itinerary").hideIfForeman &&
        !this.foreman &&
        !this.$root.customerId
      ) {
        this.getWizardStep("itinerary").hidden = false;
      }

      // var services = this.shipment.estimate["non-binding"].shipment_service;
      if (this.additionalModel && this.additionalModel.service_type) {
        services.forEach(s => {
          try {
            var serviceType = this.additionalModel.service_type.find(t => {
              if (t.service_type) {
                return t.service_type.replace("_", " ").toLowerCase() == s.service_type.replace("_", " ").toLowerCase();
              } else {
                return "";
              }
            });
          } catch (error) {
            //
          }

          if (this.getWizardStep("itinerary") && serviceType && serviceType.has_itinerary && !this.$root.customerId) {
            this.getWizardStep("itinerary").hidden = false;
          }
          if (serviceType && !serviceType.has_itinerary) {
            this.getWizardStep("itinerary").hidden = true;
          }
        });
      }
      if (this.shipmentId) {
        this.calculateTotal();
      }
      var customerName = this.shipment.customer_name;
      if (!customerName) {
        if (this.shipment.customer?.type_of_customer == "commercial") {
          customerName = this.shipment.customer?.company;
          this.shipment.customer_name = customerName;
        } else {
          customerName = this.shipment.customer?.contact?.first_name + " " + this.shipment.customer?.contact?.last_name;
        }
      }

      this.getWizardStep("customer").info = customerName;

      var addresses = [];
      // var shipmentStops = this.shipment.estimate["non-binding"]
      //   .shipment_service[this.serviceIndex].shipment_stop;
      // if (!this.shipment.stops) {
      //   this.shipment.stops = shipmentStops;
      // }
      var myStops = this.shipmentStops();
      myStops.forEach(s => {
        if (s.existing_address) {
          s.address_id = s.existing_address.address_id;
        }
      });
      // try {
      //   addresses = fun.innerJoin(
      //     this.combineAddresses(),
      //     myStops,
      //     "_id",
      //     "address_id"
      //   );
      // } catch (error) {
      //   //
      // }
      // if (!addresses.length) {
      //   addresses = fun.innerJoin(
      //     this.combineAddresses(),
      //     myStops,
      //     "_id",
      //     "address_id"
      //   );
      //   // addresses.forEach((a) => {
      //   //   console.log(a);
      //   //   this.shipment.stops
      //   //     .filter((s) => {
      //   //       return s.full_address == a.full_address;
      //   //     })
      //   //     .forEach((b) => {
      //   //       b.address_id = a._id;
      //   //     });
      //   //   shipmentStops = this.shipment.stops;
      //   // });
      // }
      // console.log(addresses);
      const pickups = myStops.filter(a => {
        return a.value && a.value.includes("pickup");
      });
      const dropoffs = myStops.filter(a => {
        return a.value && a.value.includes("dropoff");
      });

      var pickupAddresses = [];
      var dropoffAddresses = [];

      pickups.forEach(a => {
        var c = "";
        if (a.existing_address) {
          pickupAddresses.push(a.existing_address.text);
        } else if (a.full_address) {
          pickupAddresses.push(c + a.full_address);
        }
      });

      dropoffs.forEach(a => {
        var c = "";
        if (a.warehouse_name) {
          c = a.warehouse_name + " ";
        }
        if (a.existing_address) {
          dropoffAddresses.push(a.existing_address.text);
        } else if (a.full_address) {
          dropoffAddresses.push(c + a.full_address);
        }
      });

      this.getWizardStep("pickup").info =
        // "Pickup: " +
        pickupAddresses.join(", ") || "(not set)";
      if (pickups.length > 1) {
        pickupAddresses = "(" + pickups.length + ") " + pickupAddresses;
        this.getWizardStep("pickup").info = pickupAddresses;
      }

      this.getWizardStep("dropoff").info = dropoffAddresses.join(", ") || "(not set)";
      if (dropoffs.length > 1) {
        dropoffAddresses = "(" + dropoffs.length + ") " + dropoffAddresses;
        this.getWizardStep("dropoff").info = dropoffAddresses;
      }

      var totalPayment = 0;
      if (this.shipment.payment && this.shipment.payment.length) {
        this.shipment.payment.forEach(p => {
          totalPayment += parseFloat(p.amount);
        });
      }
      // this.getWizardStep("order_detail").info =
      //   // "PO Number: " +
      //   this.shipment.shipment_number;
      this.getWizardStep("payment").info =
        // "Payment: " +
        totalPayment.toFixed(2);

      var serviceLabels = [];
      var bookingLabels = "";
      var resourceInfo = [];
      var jobDetail = [];
      if (allServices.length > 3) {
        serviceLabels.push(allServices.length + " Jobs ");
      }
      if (services.length == 1) {
        bookingLabels = services[0] && services[0].booked ? "Booked" : "Not Booked";
      } else {
        var bookedJobs = services.filter(s => {
          return s.booked;
        }).length;
        if (bookedJobs) {
          if (bookedJobs == services.length) {
            bookingLabels = "All Booked";
          } else {
            bookingLabels = "Booked " + bookedJobs + " out of " + services.length;
          }
        } else {
          bookingLabels = "Not Booked";
        }
      }
      if (services[0]) {
        var instr = services[0].special_instructions || "";
        var status = "not scheduled";
        if (services[0].status) {
          status = services[0].status;
        }
        jobDetail.push(
          fun.capitalize(
            // services[0].service_type + ": " +
            "Status: " + status + " " + instr
          )
        );
      }

      allServices.forEach((s, i) => {
        var serviceDate = s.service_date;
        if (i <= 3) {
          if (s.service_date) {
            serviceLabels.push(fun.capitalize(s.service_type) + " " + fun.convertDateFormat(serviceDate));
          }

          var instr = "";
          if (s.special_instructions) {
            instr = " (check instructions)";
          }
          var status = s.status || "";

          if (s.resources && s.resources.length) {
            // this.getWizardStep("itinerary").info = "";
            var res = [];

            s.resources.forEach(r => {
              if (r.qty) {
                var p = "";
                if (r.qty > 1) {
                  p = "s";
                }
                res.push(r.qty + " " + r.resource_type + p);
              }
            });
            // resourceInfo.push(res.join(", "));
          }
        }
      });
      if (services.length > 3) {
        serviceLabels.push("...");
        resourceInfo.push("...");
        jobDetail.push("...");
      }
      if (services) {
        this.getWizardStep("job").info =
          // "Services: " +
          serviceLabels.join(", ");

        this.getWizardStep("estimate").info = this.getTotalEstimate();

        this.getWizardStep("booking").info = bookingLabels;

        // services.forEach((s) => {

        // });
        this.getWizardStep("resources").info = resourceInfo.join(", ");
        this.getWizardStep("details").info = jobDetail.join(", ");
        if (services[0]) {
          var itinerary = services[0].itinerary;
          try {
            if (itinerary && itinerary.length) {
              var itineraryInfo = [];
              this.getWizardStep("itinerary").info = "";
              itinerary.forEach(i => {
                var iInfo = fun.clone(i.step);
                var type = iInfo.split("2");

                var icon = fun.getItineraryIcon(type[0]);
                var icon2 = fun.getItineraryIcon(type[1]);
                iInfo =
                  '<span class="icon"><i class="mdi mdi-' +
                  icon +
                  '"></i><i class="mdi mdi-arrow-right-thin"></i><i class="mdi mdi-' +
                  icon2 +
                  '"></i></span>';
                if (i.day_crew && i.day_crew.crew_name) {
                  iInfo += "</br> crew: " + i.day_crew.crew_name;
                  if (i.day_crew.resources) {
                    iInfo += "<br>";
                    i.day_crew.resources.forEach(r => {
                      if (r.qty && r.qty != "0") {
                        iInfo += " " + r.qty + " " + r.resource_type;
                      }
                    });
                  }
                }
                if (i.agent && i.agent.contact) {
                  iInfo += " agent: " + i.agent.contact.company;
                }
                if (i.trip && i.trip.trip_name) {
                  iInfo += " on trip: " + i.trip.trip_name;
                }

                itineraryInfo.push(iInfo);
              });
              this.getWizardStep("itinerary").info = itineraryInfo.join(", ");
            }
          } catch (error) {
            //
          }
        }
      }
      if (this.shipment.onsite_estimate && this.shipment.onsite_estimate.length) {
        this.getWizardStep("onsite_estimate").info =
          "Onsite Estimate scheduled for " + this.shipment.onsite_estimate[0].date_time;
      }

      this.calculateInventoryVolume();
      if (this.shipment.inventory.length) {
        this.getWizardStep("inventory").info =
          // "Inventory: " +
          this.shipment.num_items +
          " items" +
          " Total Volume: " +
          this.shipment.volume +
          " Weight: " +
          this.shipment.weight +
          " Material Volume: " +
          this.shipment.material_volume;
      } else {
        this.getWizardStep("inventory").info = "(not set)";
      }
    },
    panelDisabled(i) {
      return this.allReadOnly;
      // return !this.enabledPanels.includes(i);
    },
    onAddressChange(addr, obj) {
      var that = this;
      obj.parModel.full_address = addr.address;

      var addToStop = function() {
        that.addShipmentStop(
          that.currentStopType,
          addr,
          obj.parModel.existing_address && obj.parModel.existing_address.address_id
            ? fun.guid()
            : obj.parModel.address_id,
          obj.parModel,
          true
        );
      };

      if (this.shipment.shipment_detail?.move_type == "international") {
        this.findClosestPort(addr, obj.parModel?.value, addToStop);
      } else {
        addToStop();
      }
      this.calculateRoute(this.currentService);
    },
    findClosestPort(addr, type, f) {
      var that = this;
      axios
        .post(this.serverURL + "/find_closest_port", addr, {
          withCredentials: true
        })
        .then(response => {
          var port = response.data;
          var locType = "";
          if (type == "pickup") {
            locType = "origin";
          }
          if (type == "dropoff") {
            locType = "destination";
          }
          if (locType) {
            that.shipment.shipment_info[locType + "_closest_port"] = port;
          }
          if (f) {
            f();
          }
        });
    },
    getSchema(obj) {
      this.formControls = [];
      var that = this;
      var properties = null;

      var schema = {};
      var key = obj.objectName || obj.obj;

      if (key != "shipment") {
        properties = fun.getObjectByKey(this.schema.properties, key);
      } else {
        properties = fun.clone(this.schema.properties);
      }
      // if (key == "storage") {
      //   properties = this.additionalStructure.storage;
      //   this.formControls = [
      //     {
      //       id: "assignStorage",
      //       icon: "mdi-key-plus",
      //       value: "Add Storage",

      //       color: "info",
      //       text: true
      //     }
      //   ];
      // }

      var prop = fun.clone(properties);
      schema[key] = prop;
      var finalSchema = schema[key].properties;
      try {
        Object.keys(finalSchema).forEach(key => {
          if (!obj.obj && obj.objectName == "shipment_service") {
            obj.obj = "job";
          }
          if (finalSchema[key] && finalSchema[key].showOn && finalSchema[key].showOn != obj.obj) {
            delete finalSchema[key];
          }
        });
      } catch (error) {
        //
      }

      this.formContainer.readOnly = false;
      switch (key) {
        case "onsite_estimate":
          // case "address":
          finalSchema = schema;
          finalSchema.onsite_estimate["v-bind"].filterTabsFn = null;
          //filterTabsFn
          break;
        case "inventory":
          // case "address":
          finalSchema = schema;

          finalSchema.inventory["v-bind"].hasSearch = false;
          finalSchema.inventory["v-bind"].itemsPerPage = 50;
          //
          if (this.$root.customerId) {
            finalSchema.inventory["v-bind"].editRow = false;
          }

          // finalSchema.inventory["v-bind"].toolBarControls.shift();

          break;
        case "address":
          finalSchema = schema;
          finalSchema.address.hidden = false;
          // finalSchema.address.elevation = 0;
          finalSchema.address.add_btn_title = "Add " + obj.obj;
          finalSchema.address["x-display"] = "d-iterator";

          finalSchema.address["v-bind"].tableName = "stops";
          finalSchema.address["v-bind"].cols = "6";
          finalSchema.address["v-bind"].noAdd = true;
          if (this.currentModel?.address) {
            if (this.shipment.currentStops[this.shipment.currentStops?.length - 1].isNew) {
              finalSchema.address["v-bind"].noDelete = true;
            } else {
              finalSchema.address["v-bind"].deleteTitle = "Delete Current Stop";
            }
          }

          //
          if (this.isMobile) {
            finalSchema.address["v-bind"].itemAsHeader = ["value"];
          }
          //
          // finalSchema.address["v-bind"].onAddressChange = this.onAddressChange;

          finalSchema.address.newValue = obj.obj;

          break;
        case "customer":
          // finalSchema = schema;
          // finalSchema.customer.linked_object = null;
          var props = fun.clone(schema.customer.properties.contact.properties);
          // delete props.phones;

          finalSchema = {
            customer: {
              linked_object: schema.customer.linked_object,
              properties: {
                type_of_customer: schema.customer.properties.type_of_customer,
                company: schema.customer.properties.company,
                contact: {
                  properties: props
                },
                source: schema.customer.properties.source,
                link: schema.customer.properties.link
              }
            }
          };

          // var activeKeys = [
          //   "type_of_customer",
          //   "contact",
          //   "source",
          //   "link",
          //   "company",
          //   "department",
          // ];
          // var contactKeys = ["first_name", "last_name", "email", "phones"];
          // Object.keys(finalSchema.customer.properties).forEach((k) => {
          //   if (k == "contact") {
          //     Object.keys(
          //       finalSchema.customer.properties.contact.properties
          //     ).forEach((c) => {
          //       if (!contactKeys.includes(c)) {
          //         delete finalSchema.customer.properties.contact.properties[c];
          //       }
          //     });
          //   }
          //   if (!activeKeys.includes(k)) {
          //     delete finalSchema.customer.properties[k];
          //   }
          // });

          break;
        case "payment":
          finalSchema = schema;

          break;
        case "expense":
          finalSchema = schema;

          break;

        case "itinerary":
          finalSchema = fun.clone(schema);
          // var dayCrewProperties = finalSchema.itinerary.properties.day_crew;
          // delete dayCrewProperties.color;
          // delete dayCrewProperties.crew_employee;
          // delete dayCrewProperties.crew_truck;
          delete finalSchema.itinerary.properties.day_crew;
          vBind = finalSchema.itinerary["v-bind"];
          if (!obj.isWizard) {
            vBind.noAdd = true;
          }

          break;
        case "crm":
          finalSchema = schema;
          finalSchema.crm["v-bind"].parentModel = this.shipment;

          break;
        case "shipment_info":
          if (!this.shipment.shipment_info) {
            this.shipment.shipment_info = {};
          }
          finalSchema = schema;
          // finalSchema.shipment_info.properties.groupage_id["v-bind"].dataTitle = this.groupageName;
          // var internationalShipmentSchema = fun.getObjectByKey(this.schema, "international_shipment");
          // if (internationalShipmentSchema) {
          //   internationalShipmentSchema.mainTabs = this.additionalStructure.international_shipment["v-bind"].mainTabs;
          // }
          //  this.schema.properties.properties.shipment_info.properties.international_shipment
          //
          // restrictItems
          finalSchema.shipment_info.properties.tasks_completed["v-bind"].restrictItems = function(list) {
            console.log(list.disabled);
            list.disabled = that.currentModel.shipment_info.tasks_required;
          };
          finalSchema.mainTabs = this.additionalStructure.shipment_info["v-bind"].mainTabs;
          finalSchema.noCache = true;
          // finalSchema.shipment_info.properties.international_shipment.mainTabs = this.additionalStructure.international_shipment[
          //   "v-bind"
          // ].mainTabs;
          // var filterTabsFn = schema.shipment_info.properties.shipment_name?.["v-bind"].filterTabsFn;
          // console.log(filterTabsFn);
          var origClosestPort = this.shipment.shipment_info?.origin_closest_port?.code;
          var destClosestPort = this.shipment.shipment_info?.destination_closest_port?.code;
          var p = [];
          var valueFn = `r.port_of_loading=='${origClosestPort}' && r.port_of_discharge == '${destClosestPort}'`;
          p.push({
            caption: "All Shipments",
            name: "port_of_loading"
          });

          p.push({
            caption: "Matching Shipments",
            name: "port_of_loading",
            valueFn: valueFn
          });
          // if (this.shipment.shipment_info?.type_of_shipment) {
          // const type = this.shipment.shipment_info.type_of_shipment;
          // this.getDefaultValuesForInternationalShipment();
          // }

          break;
        case "attachments":
          finalSchema = schema;
          finalSchema.attachments.title = obj.title || "Attachments";
          finalSchema.attachments["v-bind"]._id = this.shipment._id;
          finalSchema.attachments["v-bind"].itemId = this.currentCRMItemId;
          if (obj.objName == "international_shipment_task") {
            finalSchema.attachments["v-bind"].itemId =
              "international_shipment_task" + "_" + obj.title.replaceAll(" ", "_").toLowerCase();
          }
          //currentCRMItemId
          break;
        case "shipment_detail":
          finalSchema = schema;

          break;
        case "day_crew":
          finalSchema = fun.clone(schema);
          var dayCrewProperties = finalSchema.day_crew.properties;
          var displayPropertes = ["crew_employee"];
          Object.keys(dayCrewProperties).forEach(k => {
            if (!displayPropertes.includes(k)) {
              delete dayCrewProperties[k];
            }
          });

          break;

        case "crew_employee":
          finalSchema = fun.clone(schema);
          //    "addBtnTitle": "Add Hours",
          // finalSchema.crew_employee.properties.service_hours.add_btn_title =
          //   "Add Hours";
          // finalSchema.crew_employee["x-display"] = "d-iterator";
          // console.log(finalSchema);
          break;
        case "payroll":
          finalSchema = fun.clone(schema);
          var hiddenProperties = ["shipment_id"];
          var payrollProperties = finalSchema.payroll.properties; //table_properties.schema.properties;
          Object.keys(payrollProperties).forEach(k => {
            if (hiddenProperties.includes(k)) {
              delete payrollProperties[k];
            }
          });
          payrollProperties = finalSchema.payroll.table_properties.schema.properties;
          Object.keys(payrollProperties).forEach(k => {
            if (hiddenProperties.includes(k)) {
              delete payrollProperties[k];
            }
          });

          finalSchema.payroll.table_properties.headers = finalSchema.payroll.table_properties.headers.filter(h => {
            return !hiddenProperties.includes(h.value);
          });

          break;
        case "shipment_service":
        case "details":
        case "resources":
          finalSchema = fun.clone(schema);
          var vBind = finalSchema.shipment_service["v-bind"];
          finalSchema.shipment_service.properties.shipment_stop["v-bind"].viewAllLabel = "All Stops";
          //viewAllFn
          var services = this.shipment.estimate["non-binding"].shipment_service;

          var allStops = [];
          var seen = new Set();

          services.forEach(service => {
            (service.shipment_stop || []).forEach(stop => {
              var addr = stop.full_address;
              if (addr && !seen.has(addr)) {
                seen.add(addr);
                allStops.push(stop);
              }
            });
          });

          finalSchema.shipment_service.properties.shipment_stop["v-bind"].allItems = allStops;

          vBind.itemAsHeader = null;
          vBind.tableName = "shipmentService";
          if (key == "shipment_service" && obj.id != "estimate") {
            vBind.defaultIndex = this.serviceIndex;
            vBind.noAdd = true;
            if (!this.currentModel?.shipment_service?.length) {
              vBind.noDelete = true;
            } else {
              vBind.noDelete = false;
              vBind.deleteTitle = "Delete Current job";
            }
          } else {
            vBind.itemAsHeader = null;
          }
          var property = finalSchema.shipment_service.properties;
          switch (obj.obj) {
            case "job":
              vBind.collapsible = false;
              // vBind.noDelete = false;
              vBind.toolBarControls = [];
              // property.booked.readonly = true;
              break;
            case "booking":
              vBind.collapsible = false;
              vBind.noDelete = true;

              // property.service_type["x-display"] = "v-text-field";
              property.service_date["x-display"] = "v-text-field";
              // property.service_type.readonly = true;
              property.service_date.readonly = true;

              // property.service_date.cols = 4;
              property.service_date.cols = 6;
              property.booked.cols = 6;
              // property.service_type["v-bind"].readonly = true;
              break;

            default:
              vBind.collapsible = true;
              vBind.toolBarControls = [];
              vBind.expandedIndex = [0];
              vBind.noDelete = true;
              break;
          }

          Object.keys(finalSchema.shipment_service.properties).forEach(k => {
            var skip = false;
            if (
              finalSchema.shipment_service.properties[k] &&
              finalSchema.shipment_service.properties[k].portal_id == that.$root.portal_id
            ) {
              if (
                // obj.tab != undefined &&
                obj.tab == finalSchema.shipment_service.properties[k].tab ||
                !finalSchema.shipment_service.properties[k].tab
              ) {
                skip = true;
              }
            }
            obj.onlyFields?.forEach(f => {
              if (!obj.onlyFields.includes(k) && finalSchema.shipment_service.properties[k] && !skip) {
                delete finalSchema.shipment_service.properties[k];
                delete finalSchema.shipment_service.table_properties?.schema.properties[k];
              }
            });
          });

          // console.log("services");
          break;

        default:
          if (obj.onlyFields) {
            Object.keys(finalSchema).forEach(k => {
              // if (!finalSchema[k]["x-display"]) {
              //   finalSchema[k]["x-display"] = "v-text-field";
              // }
              var skip = false;
              if (finalSchema[k] && finalSchema[k].portal_id == this.$root.portal_id) {
                if (
                  // obj.tab != undefined &&
                  obj.tab == finalSchema[k].tab
                ) {
                  skip = true;
                }
              }
              obj.onlyFields.forEach(f => {
                if (!obj.onlyFields.includes(k) && !skip) {
                  delete finalSchema[k];
                }
              });
            });
          } else {
            finalSchema = fun.mergeObjects(schema[key].properties, obj.schema || {});
          }

          break;
      }
      if (this.readOnly) {
        try {
          this.formContainer.readOnly = true;
          finalSchema[obj.objectName]["v-bind"].readonly = true;
          finalSchema[obj.objectName]["v-bind"].editRow = false;
        } catch (error) {
          //
        }

        var schemaProperties = fun.getObjectsByKey(finalSchema, "properties");
        schemaProperties.forEach(schema => {
          Object.keys(schema).forEach(k => {
            if (!schema[k]["v-bind"]) {
              schema[k]["v-bind"] = {};
            }
            schema[k]["v-bind"].readonly = true;
          });
        });
      }
      // console.log(obj.objectName,fun.getObjectSize(finalSchema))
      this.schemaProperties = fun.extractSchemaPropertiesNested(finalSchema);
      return finalSchema;
    },
    groupPacking() {
      const charges = this.currentService.estimate_charges || [];

      // group packing
      let groupedPacking = Object.values(
        charges
          .filter(p => p.charge_category === "packing")
          .reduce((acc, item) => {
            const key = item.item?.toLowerCase().trim();
            const qty = Number(item.estimate_rate?.[0]?.qty) || 0;

            if (!acc[key]) {
              acc[key] = {
                ...item,
                estimate_rate: [
                  {
                    ...item.estimate_rate?.[0],
                    qty: qty
                  }
                ]
              };
            } else {
              acc[key].estimate_rate[0].qty += qty;
            }

            return acc;
          }, {})
      );

      // keep non-packing
      const nonPacking = charges.filter(p => p.charge_category !== "packing");

      // update original
      this.currentService.estimate_charges = [...nonPacking, ...groupedPacking];
    },
    createTasks() {
      var that = this;
      if (this.additionalModel.task) {
        var tasks = this.additionalModel.task.filter(t => {
          return (
            t.lead_status?.toString().toLowerCase() ==
              (that.shipment.shipment_detail?.status.toString().toLowerCase() || "new") &&
            t.move_type &&
            t.move_type.includes(that.shipment.shipment_detail.move_type) &&
            (t.progress_status == that.shipment.shipment_detail.progress_status || !t.progress_status) &&
            !that.shipment.crm?.some(c => c.task_id === t._id)
          );
        });
        if (tasks.length) {
          tasks.forEach(t => {
            var dateTime = null;
            switch (t.date_type) {
              case "service_date":
                if (that.mainService.service_date) {
                  dateTime = new Date(that.mainService.service_date);
                }

                break;
              case "booked_date":
                if (that.mainService.booked_date) {
                  dateTime = new Date(that.mainService.booked_date);
                }

                break;
              case "estimate_date":
                if (that.shipment.onsite_estimate.length) {
                  dateTime = new Date(
                    this.shipment.onsite_estimate[this.shipment.onsite_estimate.length - 1].date_time
                  );
                }

                break;
              case "order_date_time":
              case "date_created":
                if (!this.shipment.shipment_detail.order_date_time) {
                  this.shipment.shipment_detail.order_date_time = fun.formatDate(new Date());
                }
                dateTime = new Date(this.shipment.shipment_detail.order_date_time);
                break;
              case "status_date_changed":
                if (that.shipment.shipment_detail.status_date_changed) {
                  dateTime = new Date(this.shipment.shipment_detail.status_date_changed);
                }

                break;
              default:
                break;
            }
            if (dateTime) {
              dateTime.addDays(parseInt(t.num_days));
            }

            if (t.action.includes("reminder") && dateTime) {
              this.shipment.crm.push({
                _id: fun.guid(),
                type: "reminder",
                upload: t.action.includes("upload_file"),
                action_date_time: fun.formatDate(dateTime, false, true),
                addressed_to: t.coordinator,
                user: this.currentUser,
                name: t.task_name,
                description: t.task_name + "\n " + t.task_description,
                time_stamp: fun.formatDate(new Date(), false, true),
                task_id: t._id
              });
            }

            //
          });
        }
      }
    },
    calculateCharge(r) {
      try {
        if (r.charge_calculation) {
          if (r.charge_calculation.percent_of) {
            const percOf = r.charge_calculation.percent_of;
            const perc = parseFloat(r.charge_calculation.percentage) / 100;
            var serv = this.currentService[0];
            if (!r.rates) {
              r.rates = [];
            }
            if (!r.rates[0]) {
              r.rates[0] = {
                rate_name: "rate",
                qty: 1
              };
            }
            serv.estimate_charges.forEach(c => {
              if (c.charge == percOf) {
                r.rates[0].rate = parseFloat(c.subtotal * perc);
              }
            });
            if (serv[percOf]) {
              r.rates[0].rate = parseFloat(serv[percOf] * perc);
            }
            var currectCharge = serv.estimate_charges.find(c => {
              return c.charge == r.charge_name;
            });
            currectCharge.estimate_rate = r.rates;
            currectCharge.subtotal = r.rates[0].rate;
          }
        }
      } catch (error) {
        //
      }
    },
    bookService(r) {
      this.errorMessage = "";
      var that = this;
      var data = {};

      var msgTitle = "";
      var msg = "";

      // }
      var m = r.model;
      if (m.booked) {
        if (
          !m.service_date ||
          m.service_date.trim().split(" ").length == 1
          // &&
          // !m.service_type.includes("international")
        ) {
          m.booked = false;
          this.shipment.shipment_detail.status = "estimate";

          if (!m.service_date) {
            msgTitle = "Date and Time required";
            msg = "Please enter scheduled service date and time";
          } else if (m.service_date.trim().split(" ").length == 1) {
            msgTitle = "Time required";
            msg = "Please enter scheduled service time";
          }

          this.$root.alertDialog(msgTitle, msg);
          return false;
        }
        m.status = "scheduled";
        // if (!m.model.route) {
        if (m.service_type != "international_moving") {
          this.calculateRoute(m);
        }

        // }
        // this.mainService.status = "scheduled";
        this.shipment.booked_estimate = this.getEstimateKey();
        this.shipment.shipment_detail.status = "booked";
        this.mainService.booked = true;
        m.booked_date = fun.formatDate(new Date(), false, true);
        m.booked_by = {
          full_name: this.currentUser.full_name,
          _id: this.currentUser._id
        };
        this.shipment.shipment_detail.status_date_changed = m.booked_date;

        var serviceType = this.additionalModel.service_type.find(t => {
          return t.service_type == m.service_type;
        });
        // if (serviceType && serviceType.has_itinerary) {
        this.createItinerary(m);
        // }
        m.itinerary ||
          [].forEach(i => {
            i.pickup_status = "booked";
          });

        // this.createTasks();
        // if (!f) {
        var crm = {
          type: "status",
          description: "Job Booked",
          status: "booked",
          user: this.$root.user_email,
          time_stamp: fun.formatDate(new Date(), false, true)
        };
        this.shipment.crm.push(crm);
        this.submit();
        // }

        try {
          // this.refreshModel(this.dataTabs[this.activeTabIndex - 1].obj);
        } catch (error) {
          //
        }
      } else {
        var service_id = m._id;
        // m.model.booked = true;
        m.itinerary = [];
        m.status = "";
        m.book_date = null;
        m.booked_by = "";
        this.shipment.shipment_detail.status = "pending";
        this.shipment.shipment_detail.status_date_changed = fun.formatDate(new Date(), false, true);

        // if (!f) {
        this.submit();
      }
    },
    createMapData() {
      var that = this;
      var r = this.currentService;
      that.mapData = [];
      var addMapData = function() {
        that.mapReady = false;
        that.mapData.push({
          shortLabel: "DEP",
          label: r.service_date,
          mapLine: {
            service: {
              route: {
                shape: r.route.shape,

                // waypoint: [r.origin.position, r.destination.position],
                waypoint: r.route.waypoint
                // waypoint: r.route_waypoint,
              }
            }
          }
        });
        that.mapReady = true;
        that.loading = false;
        // that.mapKey = !that.mapKey;
      };
      if (r.route && r.route.leg) {
        addMapData();
      } else {
        this.calculateRoute(r, addMapData);
      }
    },
    addDefaultStops() {
      this.mainService = this.shipment.estimate["non-binding"].shipment_service[0];
      if (this.shipment.estimate["non-binding"].shipment_service.length > 1) {
        this.shipment.estimate["non-binding"].shipment_service.forEach(s => {
          if (!s.shipment_stop || s.shipment_stop.length == 0) {
            s.shipment_stop = [];
            var curService = this.additionalModel.service_type.find(t => {
              return t.service_type == s.service_type;
            });
            if (curService && curService.stop_type) {
              curService.stop_type.forEach(st => {
                if (st == "origin") {
                  const pickup = this.mainService.shipment_stop.find(p => {
                    return p.value == "pickup";
                  });
                  s.shipment_stop.push({
                    address_id: pickup.adress_id,
                    full_address: pickup.full_address,
                    existing_address: {
                      address_id: pickup.address_id,
                      text: pickup.full_address,
                      value: pickup.full_address
                    },
                    value: "pickup",
                    use_existing: true
                  });
                  //
                }
                if (st == "destination") {
                  const dropoff = this.mainService.shipment_stop.find(p => {
                    return p.value == "pickup";
                  });
                  s.shipment_stop.push({
                    address_id: dropoff.adress_id,
                    full_address: dropoff.full_address,
                    existing_address: {
                      address_id: dropoff.address_id,
                      text: dropoff.full_address,
                      value: dropoff.full_address
                    },
                    value: "dropoff",
                    use_existing: true
                  });
                }
              });
            }
            //
          }
        });
      }
    },
    shipmentStops() {
      var that = this;
      this.addDefaultStops();
      this.currentService = this.shipment.estimate["non-binding"].shipment_service[this.serviceIndex];
      if (this.currentService) {
        var currentStops = this.currentService.shipment_stop;

        this.currentService.shipment_stop.forEach(s => {
          // s.full_address = this.cleanFullAddress(s.full_address);
          if (s.existing_address) {
            s.full_address;
            s.full_address = s.existing_address.value;
          }
          const addr = this.combineAddresses().find(c => {
            return (
              (c.full_address &&
                s.full_address &&
                c.full_address.toLowerCase().trim() == s.full_address.toLowerCase().trim() &&
                c.location?.apt === s.location?.apt) ||
              (s.address_id && c._id == s.address_id)
            );
          });
          if (s.full_address && (!s.address_id || !isNaN(s.address_id))) {
            if (addr) {
              s.address_id = addr._id;

              if (!fun.deepFind(addr, "location.address.geo")) {
                this.unparsedAddresses.push({
                  address_id: addr._id,
                  full_address: s.full_address
                });
              }
            } else {
              const addr = that.combineAddresses().find(c => {
                return c.full_address && s.full_address && c.full_address.trim() == s.full_address.trim();
              });
              // if (addr) {
              //   s.address_id = addr._id;
              // } else {
              //   const url = "parse_address";

              this.currentStops = this.currentService.shipment_stop;
              if (!this.shipment.stops) {
                this.shipment.stops = [];
              }
              this.currentStops.forEach(c => {
                if (
                  this.shipment.stops.some(s => {
                    return c.address_id != s.address_id;
                  })
                ) {
                  this.shipment.stops.push(c);
                }
              });

              return currentStops;
            }
          }
        });

        currentStops = this.currentService.shipment_stop;
        this.shipment.currentStops = currentStops;

        currentStops.forEach(c => {
          if (
            this.shipment.stops &&
            this.shipment.stops.some(s => {
              return c.address_id != s.address_id;
            })
          ) {
            this.shipment.stops.push(c);
          }
        });
        // if ((this.serviceIndex == 0 && !this.mapData) || !this.mapData.length) {
        //   this.createMapData();
        // }
      } else {
        this.currentService.shipment_stop = [];
      }
      if (this.unparsedAddresses.length) {
        // this.fixAddresses();
      }
      return currentStops;
    },

    fixAddresses() {
      var that = this;
      if (this.unparsedAddresses.length) {
        this.unparsedAddresses.forEach(s => {
          axios
            .post(this.serverURL + "/parse_address", {
              address: s.full_address,
              address_id: s.address_id
            })
            .then(response => {
              console.log(response.data);

              const address = response.data.location;
              const position = response.data.position;
              // s.full_address = address.label;
              let addr = this.shipment.customer.address.find(a => {
                return a._id == s.address_id;
              });
              addr.full_address = s.full_address;
              addr.location = {
                full_address: address.label,
                address: {
                  address: address.label,
                  full_address: address.label,
                  geo: {
                    location: {
                      address: address,
                      position: position
                    }
                  }
                }
              };
              let curStop = this.currentService.shipment_stop.find(c => {
                return c.address_id == s.address_id;
              });
              if (curStop) {
                curStop.full_address = s.full_address;
              }
            });
        });
        this.unparsedAddresses = [];
        this.submit();
      }
    },
    addShipmentStop(type, address, addressId, sStop, noSubmit) {
      // if (!this.shipment.stops) {
      //   this.shipment.stops = [];
      // }

      // var stopLength = this.shipment.stops.length;
      var zones = {};
      if (address) {
        try {
          zones = this.$root.findZone(address, this.additionalModel.zone, this.shipment.shipment_detail.company) || {};
          // sStop.location.zone = zones.zone;
        } catch (error) {
          //
        }
      }
      var title = "";
      //     var shipmentStops = this.shipment.estimate["non-binding"]
      // .shipment_service[this.serviceIndex].shipment_stop;
      var isNewStop = false;
      var isExistingAddress = false;
      if (address) {
        isExistingAddress = this.combineAddresses().some(a => {
          return a.full_address?.trim().toLowerCase() == address.address?.trim().toLowerCase();
        });
      } else {
        isExistingAddress = this.combineAddresses().some(a => {
          return a._id == addressId;
        });
      }
      if (isExistingAddress && address) {
        addressId = this.combineAddresses().find(a => {
          return a.full_address?.trim().toLowerCase() == address.address?.trim().toLowerCase();
        })._id;
      }

      // if (!address) {
      //   isExistingAddress = true;
      // }
      // if (!sStop) {
      // var curTypes = this.shipmentStops().filter((s) => {
      //   return s.value == sStop.value;
      // });
      // // if (curTypes.length > 1) {
      isNewStop =
        sStop.isNew ||
        !this.shipmentStops().some(s => {
          return s._id == sStop._id;
        });

      var stopNumber = 0;
      // var hasType = this.shipmentStops().filter((s) => {
      //   return s.value == sStop.value;
      // });
      // var stN = "";
      if (!addressId) {
        addressId = fun.guid();
      }
      if (!isNewStop) {
        title = type;
        stopNumber = type == "pickup" ? 1 : 2;
        if (!address) {
          //from existing address
          address = this.combineAddresses().find(a => {
            return a._id == addressId;
          });
        }
        if (!sStop.stop_number) {
          sStop.stop_number = stopNumber;
        }
        if (sStop && (!sStop.existing_address || (address && address._id != sStop.existing_address.address_id)))
          if (address) {
            sStop.full_address = address.full_address || address.address;
          }

        // if (type && title) {
        //   sStop.title = title;
        // }
      } else {
        // stN = hasType.length + 1;
        // title = type + "_" + stN;

        title = sStop.value;
        if (title && title.includes("pickup")) {
          stopNumber = this.shipmentStops().filter(s => {
            return s.value && s.value.includes("pickup");
          }).length;
          // stopNumber += 1;
          sStop.stop_number = stopNumber;
          this.shipmentStops()
            .filter(s => {
              return s.value && s.value.includes("dropoff");
            })
            .forEach(d => {
              d.stop_number += 1;
            });
        } else {
          stopNumber = this.shipmentStops().length;
          // stopNumber += 1;
        }

        if (!sStop.stop_number) {
          sStop.stop_number = stopNumber;
        }
        sStop.address_id = addressId;
        sStop.stop_number = stopNumber;
        if (!sStop.isNew) {
          this.shipmentStops().push(sStop);
        }

        delete sStop.isNew;
      }

      var customerAddress = null;
      if (!isExistingAddress) {
        // addressId = fun.guid();
        sStop.address_id = addressId;
        if (address) {
          sStop.full_address = address.address;
        }

        delete sStop.existing_address;
        var shipmentStop = this.shipmentStops().find(s => {
          return s._id == sStop._id;
        });
        if (shipmentStop) {
          shipmentStop.full_address = sStop.full_address;
        }
      } else {
        customerAddress = this.shipment.customer.address.find(a => {
          return a._id == addressId;
        });
      }

      // address.full_address = address.address;

      if (address && !customerAddress && !isExistingAddress) {
        this.shipment.customer.address.push({
          _id: addressId,
          location: {
            full_address: address.address,
            address: address,
            zone: zones.zone,
            carrier_zone: zones.carrier_zone
          }
        });
      } else if (!isExistingAddress && address) {
        customerAddress.location = {
          full_address: address.address,
          address: address,
          zone: zones.zone,
          carrier_zone: zones.carrier_zone
        };
      } else if (customerAddress) {
        if (this.canUpdateAddress(addressId) || isExistingAddress) {
          var custAddress = this.shipment.customer.address.find(a => {
            return a._id == addressId;
          });
          if (custAddress.full_address != address.address) {
            //not used address selected, no need to update
            custAddress.full_address = address.address;
            custAddress.location = {
              full_address: address.address,
              address: address,
              zone: zones.zone,
              carrier_zone: zones.carrier_zone
            };
          }
        } else {
          addressId = fun.guid();
          sStop.address_id = addressId;
          this.shipment.customer.address.push({
            _id: addressId,
            location: {
              full_address: address.address,
              address: address,
              zone: zones.zone,
              carrier_zone: zones.carrier_zone
            }
          });
        }
      }
      // if (this.currentService.booked) {
      // ;
      var that = this;
      // if (!noSubmit) {
      this.submit(f => {
        that.currentModel = that.getModel({ obj: sStop.value, _id: sStop._id });
        console.log(that.currentModel);
      });
      // }

      // this.calculateRoute(this.currentService, this.createMapData);
    },
    getStatusColor() {
      if (this.additionalModel && this.additionalModel.lead_status) {
        try {
          var status = this.additionalModel.lead_status.find(s => {
            return (
              this.shipment.shipment_detail &&
              s.status.toLowerCase() == this.shipment.shipment_detail.status.toLowerCase()
            );
          });
          if (status) {
            return status.color || fun.randomColor();
          }
        } catch (error) {
          //
        }
      }
      return "fff";
    },
    getServiceColor() {
      if (this.additionalModel && this.additionalModel.service_type) {
        try {
          var service_type = this.additionalModel.service_type.find(s => {
            return s.service_type.toLowerCase() == this.currentService.service_type.toLowerCase();
          });
          if (service_type) {
            return service_type.color || fun.randomColor();
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    getStopNumber(stops, st) {
      var t = st.value.includes("pickup") ? "pickup" : "dropoff";
      var stN = 0;
      stops.forEach(s => {
        if (s.value.includes(t)) {
          s.stop_number = parseInt(s.stop_number);
          if (parseInt(s.stop_number) > stN) {
            stN = parseInt(s.stop_number);
          }
        }
      });
      st.stop_number = stN + 1;
    },
    panelChange(newPanelIndex) {
      if (!newPanelIndex) {
        this.mapCols = null;
      }
      if (!this.wizardSteps[newPanelIndex]) {
        return false;
      }
      var wizardStep = this.wizardSteps[newPanelIndex].id;
      // console.log(wizardStep);
      if (!this.$refs.form[0].validate()) {
        // Form is not valid, do not change the panel

        this.$nextTick(() => {
          this.panelIndex = newPanelIndex || 0; // Revert to the current panel index
        });

        return false;
      } else {
        // Form is valid, update active panel
        if (!newPanelIndex) {
          this.updateTitles();
        }
        this.panelIndex = newPanelIndex;
        var obj = this.shownSteps[this.panelIndex];
        if (!this.shipment._id) {
          this.submit();
        }
        //
        this.expandPanel(obj);
      }
    },
    combineAddresses() {
      var customerAddresses = this.shipment.customer.address;

      customerAddresses?.forEach(c => {
        try {
          if (c.full_address) {
            c.full_address = c.full_address.trim();
          }

          if (c.location && c.location.full_address) {
            c.location.full_address = c.location.full_address.trim();
          } else if (!c.location) {
            c.location = {};
          }
        } catch (e) {
          console.log(c);
          console.log(e);
        }

        if (c.existing_address) {
          var isWhs = this.warehouseAddresses.find(w => {
            return w._id == c.existing_address.address_id;
          });
          if (isWhs) {
            if (!c.location) {
              c.location = {};
            }
            c.location.address = isWhs.address;
          }
        }
      });
      var customerWarehouses = customerAddresses?.filter(c => {
        return (
          !c.existing_address ||
          !this.warehouseAddresses.filter(w => {
            return w._id == c.existing_address.address_id;
          }).length
        );
      });
      customerAddresses = customerWarehouses.concat(this.warehouseAddresses);
      return customerAddresses;
    },
    getMoveTypeIcon(moveType) {
      if (!moveType) {
        moveType = this.shipment?.shipment_detail?.move_type || "local";
      }

      switch (moveType) {
        case "local":
          return "mdi-truck";

        case "interstate":
          return "mdi-highway";

        case "short_haul":
          return "mdi-truck-outline";

        case "international":
          return "mdi-ferry";
        case "commercial":
          return "mdi-truck-cargo-container";
        default:
          return "mdi-truck";
      }
    },
    getLocations(stopType, _id) {
      // const shipmentServices = this.shipment.estimate["non-binding"]
      //   .shipment_service;
      // var customerAddresses = this.shipment.customer.address;
      // var warehouseAddresses = fun.clone(this.additionalModel.warehouse);
      // warehouseAddresses.forEach((w) => {
      //   console.log(w);
      //   w.full_address = w.address.address;
      //   w.location = { address: w.address };
      // });
      // customerAddresses = customerAddresses.concat(warehouseAddresses);
      var customerAddresses = this.combineAddresses();
      // var shipmentStops = this.shipment.estimate["non-binding"]
      //   .shipment_service[this.serviceIndex].shipment_stop
      var stops = [];
      if (!_id) {
        stops = this.shipmentStops().filter(stop => {
          if (!stop.value) {
            stop.value = stop.text;
          }
          return stop.value && stop.value.includes(stopType);
        });
      } else {
        stops = [
          this.shipmentStops().find(stop => {
            return stop._id == _id;
          })
        ];
      }

      // const addresses = customerAddresses.filter((customerAd)dress) => {
      //   return this.shipment.stops.some(
      //     (stop) => stop.value.includes(stopType)
      //     // ||
      //     // (!stop.value && stop.address_id === customerAddress._id)
      //   );
      // });

      stops.forEach(s => {
        if (s) {
          if (!s.existing_address) {
            s.use_existing = false;
          }
          var addr = customerAddresses.find(a => {
            return (
              (s.address_id && a._id == s.address_id) ||
              (s.full_address && s.full_address == a.full_address && s.location?.apt == a.location?.apt)
            );
          });
          if (addr && !s.existing_address) {
            s.location = addr.location;
          }
          if (!s.location) {
            s.location = {};
          }
          if (!s.location.address && s.full_address) {
            s.location.address = s.full_address;
          }
        }
      });

      var filteredAddresses = customerAddresses.filter(item1 => {
        return stops.some(
          item2 => item1._id === item2?.address_id
          // ||
          // (item1.full_address && item1.full_address === item2.full_address ||  item1.full_address === item2.full_address)
        );
      });
      // if (!filteredAddresses.length) {
      //   filteredAddresses = [{}];
      // }

      return stops;
      // if (!filteredAddresses.length) {
      //   return stops;
      // } else {
      //   var addresses = [];
      //   filteredAddresses.forEach((a) => {
      //     if (a.existing_address) {
      //       a.use_existing = true;
      //     }
      //     var st = stops.find((s) => {
      //       return s.address_id == a._id;
      //     });
      //     if (st) {
      //       a = { ...a, ...st };
      //     }
      //     delete a.warehouse_name;
      //     delete a.zones;
      //     delete a.location;
      //     addresses.push(a);
      //   });
      //   return addresses;
      // }
      // filteredAddresses.forEach((a) => {
      //   if (a.existing_address) {
      //     a.use_existing = true;
      //   }
      //   var st=stops.find(s=>{ return s.address_id==a._id})
      //   if(st){

      //   }
      //   delete a.warehouse_name;
      //   delete a.zones;
      //   delete a.location;
      // });
      // return filteredAddresses;
    },
    getAllLocations() {
      // if (!this.allLocation || !this.allLocation.length) {
      this.allLocation = [];
      this.shipment?.customer.address?.forEach(a => {
        this.allLocation.push({
          address_id: a._id,
          full_address: a.full_address,
          value: "customer_address",
          title: "customer_address",
          text: "customer_address"
        });
      });
      this.warehouseAddresses.forEach(w => {
        this.allLocation.push({
          full_address: w.full_address,
          value: w.saved_location ? "saved location" : "warehouse",
          title: w.warehouse_name,
          text: w.warehouse_name,
          address_id: w._id,
          geo: w.geo
        });
      });
      // if (this.additionalModel && this.additionalModel.warehouse) {
      //   this.additionalModel.warehouse.forEach((w) => {
      //     if (w.address) {
      //       this.allLocation.push({
      //         full_address: w.address.address,
      //         value: w.warehouse_name,
      //         title: w.warehouse_name,
      //         text: w.warehouse_name,
      //         address_id: w._id,
      //         geo: w.geo,
      //       });
      //     }
      //   });
      // }
      // try {
      //   var company = this.additionalModel.company.find((c) => {
      //     return c._id == this.shipment.shipment_detail.company._id;
      //   });
      //   this.allLocation.push({
      //     full_address: company.address.address.address,
      //     title: company.company_name,
      //     value: company.company_name,
      //     text: company.company_name,
      //     address_id: company._id,
      //     geo: company.address.address.geo,
      //   });
      // } catch (error) {
      //   //
      // }
      if (this.shipment) {
        fun.sortObjects(this.allLocation, "title");
        this.shipment.allLocation = this.allLocation;
      }

      // }
    },
    getRatesFromEmployee(e) {
      var rates = e.employee_pay_rate;
      var that = this;
      var currentRates = rates.filter(r => {
        return (
          (!r.employee_role?.length || r.employee_role?.includes(e.employee_role)) &&
          (!r.move_type?.length || r.move_type?.includes(that.shipment.shipment_detail?.move_type)) &&
          (!r.service_type?.length || r.service_type?.includes(that.currentService[0]?.service_type))
        );
      });

      return currentRates;
      //
    },
    getEmployeeRates(dayCrewModel, r) {
      var employeeIds = [];
      dayCrewModel.crew_employee.forEach(e => {
        employeeIds.push(e.employee._id);
      });
      const data = {
        object_name: "employee",
        qry: { _id: { $in: employeeIds } }
      };
      const url = "get_data";
      axios
        .post(this.serverURL + "/" + url, data, {
          withCredentials: true
        })
        .then(response => {
          // console.log(response.data.model);
          r(response.data.model);
        });
    },
    calculatePayroll(model, recalc) {
      var that = this;
      var dayCrewModel = that.currentService[0].itinerary[0]?.day_crew;
      var getRate = function(rate, e) {
        var cRate = {
          employee_rate: rate.rate,
          unit: rate.unit
        };

        switch (rate.unit) {
          case "hour":
            var total = e.service_hours?.reduce((sum, item) => sum + parseFloat(item.total_hours || 0), 0);
            cRate.rate_description = `${rate.rate} x ${total} hours`;
            cRate.qty = total;

            break;

          case "percent":
            if (rate.commissionable_item?.startsWith("total_")) {
              var tot = rate.commissionable_item?.split("_")[1];
              console.log(that.currentService[0].estimate_charges);
              var charges = that.currentService[0].estimate_charges.filter(c => {
                return c.charge_category == tot;
              });
              var totalCom = charges.reduce((sum, p) => sum + parseFloat(p.subtotal || 0), 0);

              cRate.rate_description = `${rate.rate} percent of ${fun.capitalize(rate.commissionable_item)}`;
              cRate.qty = rate.rate / 100;
              cRate.employee_rate = totalCom;
            }
            //rate.commissionable_item?.split("_")[1]
            // switch (rate.commissionable_item) {
            //   case "total_material":
            //     break;
            //   case "total_labor":
            //     break;
            //   case "total_transportation":
            //     break;
            //   case "total_accessorials":
            //     break;
            //   case "total_storage":
            //     break;
            //   default:
            //     break;
            // }
            break;

          default:
            break;
        }
        cRate.subtotal = cRate.employee_rate || 0 * cRate.qty || 0;
        return cRate;
      };
      var addPayroll = function(model, e, rate) {
        if (!rate.subtotal) {
          rate.subtotal = 0;
        }
        model.payroll.push({
          _id: fun.guid(),
          payroll_date: fun.formatDate(that.currentService[0]?.service_date),
          employee_role: e.employee_role,
          employee: {
            _id: e.employee._id,
            full_name: e.employee.full_name
          },
          ...rate
        });
        // console.log(model.payroll);
        that.currentService[0].payroll = model.payroll;
      };
      var applyEmployees = function(r) {
        if ((dayCrewModel && !model?.payroll?.length) || recalc) {
          dayCrewModel.crew_employee?.forEach(e => {
            var payrollId = model.payroll.find(p => {
              return p.employee?._id == e.employee._id;
            })?._id;
            if (recalc || !payrollId) {
              var rate = {
                unit: "",
                employee_rate: 0
              };
              var qty = 1;
              var multiple = false;
              if (r) {
                var emp = r.find(a => {
                  return a._id == e.employee?._id;
                });
                if (emp) {
                  emp.employee_role = e.employee_role;
                  emp.currentRates = that.getRatesFromEmployee(emp);
                  if (emp.currentRates.length > 1) {
                    multiple = true;
                    model.payroll = model.payroll.filter(m => {
                      return m.employee?._id != e.employee?._id;
                    });
                    emp.currentRates.forEach(rt => {
                      rate = getRate(rt, e);
                      // rate = rt?.rate;
                      addPayroll(model, e, rate);
                    });
                    // that.formKey = !that.formKey;
                  } else {
                    rate = getRate(emp.currentRates[0], e);
                    // rate = emp.currentRates[0]?.rate;
                    // addPayroll(model, e, rate, qty);
                  }
                }
              }

              if (!payrollId) {
                addPayroll(model, e, rate);
                // that.formKey = !that.formKey;
              } else if (recalc && rate && !multiple) {
                var item = model.payroll.find(m => m._id.toString() === payrollId.toString());

                if (item) {
                  Object.assign(item, rate);
                }
              }
            }
          });
        }
      };
      if (recalc) {
        this.$root.$confirm
          .open(
            "Overriding Payroll",
            "This will override your payroll with calculated data and delete all manually entered employees."
          )
          .then(confirm => {
            if (confirm) {
              this.getEmployeeRates(dayCrewModel, r => {
                applyEmployees(r);
                that.refreshBlock();
              });
            }
          });
      } else {
        applyEmployees();
      }
    },
    getModel(t) {
      var model = {};
      var index = 0;

      if (!t.obj) {
        t.obj = t.id;
      }
      const that = this;
      var getCurrentService = function(job) {
        if (job) {
          var id = job.parent ? job.parent.id : job.id;
          index = id.split("_").pop() || 0;
          if (id.split("_").length == 1) {
            index = 0;
          }
        }

        if (!job || !job._id) {
          that.currentService = [that.shipment.estimate["non-binding"].shipment_service[index]];
          // if (!job?._id) {
          //   that.currentService =
          //     that.shipment.estimate["non-binding"].shipment_service;
          //   model = {
          //     shipment_service: that.currentService,
          //   };
          //   return;
          // }
        } else {
          that.currentService = that.shipment.estimate["non-binding"].shipment_service.find(s => {
            return s._id == job._id;
          });
        }
        // that.currentService =
        //   that.shipment.estimate["non-binding"].shipment_service;
        if (that.currentService[0]?.service_date) {
          try {
            const pickupTime = that.currentService[0]?.service_date.split(" ")[1];

            const timeWindow = that.additionalModel.company[0]?.default_settings?.default_pickup_window || 2;

            that.currentService[0].latest_pickup_time = fun.addHoursToTime(pickupTime, timeWindow);
          } catch (error) {
            //
          }
        }
        model = {
          shipment_service: that.currentService
        };
        // that.currentService = model;
      };
      switch (t.obj) {
        case "customer":
          model = { customer: this.shipment.customer };
          // delete model.customer.address
          break;

        case "inventory":
          model = { inventory: this.shipment.inventory };

          break;
        case "shipment_info":
          // if (!this.shipment.shipment_info.international_shipment) {
          //   this.shipment.shipment_info.international_shipment = {};
          // }
          // if (!this.shipment.shipment_info.type_of_shipment) {
          //   this.shipment.shipment_info.type_of_shipment = "FCL";
          // }

          model = { shipment_info: this.shipment.shipment_info };

          break;
        case "onsite_estimate":
          model = { onsite_estimate: this.shipment.onsite_estimate };

          break;
        case "itinerary":
          // model = { inventory: this.shipment.itinerary };
          model = {
            itinerary: this.shipment.estimate["non-binding"].shipment_service[0].itinerary
          };
          index = t.id.split("_").pop();
          if (!isNaN(index)) {
            if (!model.itinerary[index] && t.add) {
              model.itinerary.push({});
            }
            model.itinerary = [model.itinerary[index]];
          }

          break;
        case "payment":
          model = { payment: this.shipment.payment };

          break;
        case "expense":
          if (!this.shipment.expense) {
            this.shipment.expense = [];
          }
          model = { expense: this.shipment.expense };

          break;

        case "crm":
          model = { crm: this.shipment.crm };

          break;
        // case "attachments":
        //   model = { attachments: this.shipment.attachments };

        // break;
        // case "order_detail":
        case "shipment_detail":
          model = { shipment_detail: this.shipment.shipment_detail };

          break;
        case "job":
          getCurrentService(t);

          break;
        case "day_crew":
          getCurrentService(t);
          var itinerary = this.currentService[0].itinerary;
          if (itinerary && itinerary.length) {
            model = { day_crew: itinerary[0].day_crew };
            if (!model.day_crew?.payroll?.length && model.day_crew?.crew_employee) {
              // model.day_crew?.crew_employee.forEach((e) => {
              //   model.day_crew.payroll.push({
              //     payroll_date: that.currentService[0]?.service_date,
              //     employee_role: e.employee_role,
              //     employee: {
              //       _id: e.employee._id,
              //       full_name: e.employee.full_name,
              //     },
              //   });
              // });
            }
          } else {
            model = { day_crew: {} };
          }

          break;
        case "payroll":
          getCurrentService(t);

          if (!this.currentService[0].payroll) {
            this.currentService[0].payroll = [];
          }
          var payroll = this.currentService[0].payroll;
          model = { payroll: payroll };
          this.calculatePayroll(model);

          break;
        case "details":
        case "estimate":
        case "resources":
        case "booking":
          getCurrentService(t.parent);

          model = { shipment_service: this.currentService };
          if (t.obj == "resources") {
            model.shipment_service.forEach(s => {
              if (!s.resources || !s.resources.length) {
                s.resources = [];
                // this.additionalModel.vehicle_type
                //   .filter(t => {
                //     return t.default;
                //   })
                //   .forEach(t => {
                //     s.resources.push({
                //       resource_type: t.vehicle_type,
                //       resource_category: "vehicle"
                //     });
                //   });
                // this.additionalModel.employee_role
                //   .filter(t => {
                //     return t.default;
                //   })
                //   .forEach(t => {
                //     s.resources.push({
                //       resource_type: t.employee_role,
                //       resource_category: "labor"
                //     });
                //   });
                // this.additionalModel.material_list
                //   .filter(t => {
                //     return t.default;
                //   })
                //   .forEach(t => {
                //     s.resources.push({
                //       resource_type: t.material_name,
                //       resource_category: "materials"
                //     });
                //   });
                that.additionalModel.resource_type
                  .filter(t => {
                    return t.default;
                  })
                  .forEach(t => {
                    s.resources.push({
                      resource_type: t.resource_type,
                      resource_category: t.resource_category
                    });
                  });
              }
            });
          }
          // if (t.obj == "estimate") {
          //   model = { estimated_charges: this.currentService[0]};
          // }
          break;
        case "additional_services":
          model = { additional_services: this.shipment.additional_services };

          break;
        case "attachments":
          model = { attachments: [] };

          break;
        // case "estimate":
        //   // model = {
        //   //   estimate_charges: this.shipment.estimate["non-binding"]
        //   //     .shipment_service[0].estimate_charges,
        //   // };
        //   model = this.shipment.estimate["non-binding"].shipment_service[0];

        //   break;
        case "crew_employee":
          if (this.currentService.itinerary[0] && this.currentService.itinerary[0].day_crew) {
            model = {
              crew_employee: this.currentService.itinerary[0].day_crew.crew_employee
            };
          }

          break;
        default:
          if (t.obj) {
            if (t.obj.includes("pickup")) {
              model = { address: this.getLocations("pickup", t._id) };
            } else if (t.obj.includes("dropoff")) {
              model = { address: this.getLocations("dropoff", t._id) };
            } else {
              model = fun.getObjectByKey(this.defaultModel, t.objectName) || {};
            }
          }

          break;
      }

      return model;
    }
    // changeShipmentType(newType, oldType) {
    //   // if (oldType == "groupage") {
    //   this.addInternationalShipment(newType);
    //   // }
    // }
  },
  computed: {
    internationalShipmentTab() {
      return this.$refs.formComponent?.mainTab;
    },
    // shipmentType() {
    //   return this.shipment?.shipment_info?.type_of_shipment || "none";
    // },
    assistantLink() {
      const assistantId = "aa0880488d514760b5753429";
      if (
        !this.shipment?.shipment_detail?.company?._id ||
        (this.$root.portal_id != "85" && this.$root.portal_id != "359")
      ) {
        return "";
      }

      const link = `${window.location.origin}/#/aichat/${assistantId}-${this.$root.portal_id}-${this.shipment?.shipment_detail?.company?._id}-${this.shipment._id}`;

      return link;
    },
    getBorderStyle() {
      const selected = this.sortedStatuses.find(item => item.status === this.selectedStatus);
      return {
        borderColor: selected?.color || "#ccc",
        borderWidth: "2px",
        borderStyle: "solid"
      };
    },
    sortedStatuses() {
      const list = this.additionalModel?.lead_status || [];
      const uniqueByStatus = Object.values(
        list.reduce((acc, item) => {
          acc[item.status] = item; // last one wins
          return acc;
        }, {})
      );
      return uniqueByStatus.sort((a, b) => a.status.localeCompare(b.status));
    },
    serviceDate() {
      if (this.currentService) {
        var serviceDate = this.currentService.service_date || "Missing";
        return serviceDate;
      } else {
        return "";
      }
    },
    iconSize() {
      const size = this.$vuetify.breakpoint.lgAndUp ? "44px" : "32px";
      return {
        width: size,
        height: size
      };
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  },
  watch: {
    "$route.params.id": {
      immediate: true, // triggers immediately on component creation
      handler(newId, oldId) {
        // if (parseInt(newId)) {
        //   this.shipmentId = parseInt(newId);
        //   this.refreshData();
        // }
        // if (newId == 0) {
        //   this.mount();
        // }
      }
    },

    // shipmentType: {
    //   handler(newVal, oldVal) {
    //     this.changeShipmentType(newVal, oldVal);
    //   }
    // },
    // internationalShipmentTab: {
    //   handler(newVal, oldVal) {
    //     this.addInternationalShipment();
    //   }
    // },
    calculateRoute_(model, fn) {
      const uniqueAddresses = fun.getUnique(this.combineAddresses(), "full_address");

      model.address = uniqueAddresses.filter(item1 => {
        if (model.shipment_stop) {
          return model.shipment_stop.some(item2 => {
            return (
              item2.address_id === item1._id ||
              item2.full_address === item1.full_address ||
              this.cleanFullAddress(item2.full_address) == this.cleanFullAddress(item1.full_address)
            );
          });
        }
      });
      if (!model.address || (model.address && model.address.length < 2)) {
        this.loading = false;
        this.mapReady = true;
        return;
      }
      model.address.forEach(a => {
        const m = model.shipment_stop.find(s => {
          return s.address_id == a._id || s.full_address == a.full_address;
        });
        if (m) {
          a.stop_number = m.stop_number;
        }
      });
      model.address = fun.getUnique(model.address, "full_address");
      model.address.sort((a, b) => a.stop_number - b.stop_number);
      var company = this.additionalModel.company.find(c => {
        return c._id == this.shipment.shipment_detail?.company?._id;
      });

      if (company?.address) {
        model.address.unshift({ full_address: company.address.address, location: company.address });
      }

      model.shipment_id = this.shipment.shipment_id;
      model.service_index = this.serviceIndex;
      model.estimate_key = this.getEstimateKey(model);
      var waypoints = [];
      model.address.forEach(a => {
        var pos = fun.getObjectByKey(a, "position");
        waypoints.push({
          lat: pos[0],
          lng: pos[1]
        });
      });
      axios
        .post(
          this.serverURL + "/get_route",
          { waypoints: waypoints, service: this.currentService },
          {
            withCredentials: true
          }
        )
        .then(response => {
          var route = response.data;
          var distance = 0;
          var travelTime = 0;
          if (route && route.sections) {
            route.sections.forEach(l => {
              distance += l.summary.length;
              travelTime += l.summary.baseDuration;
            });
            model.route = route;
            model.distance = distance;
            model.mileage = (distance / 1.6 / 1000).toFixed(0);
            model.driving_time = (travelTime / 3600).toFixed(2);

            this.submit();

            if (fn) {
              fn();
            } else {
              if (route && route.sections) {
                this.submit();
              }
            }
          }

          // console.log(response)
        })
        .catch(reason => {
          console.log(reason);
        });
    },
    currentModel: {
      handler: function(newValue, oldValue) {
        console.log(this.currentModel);
      },
      deep: true
      //this.$root.$emit("recalculateFields", this);
    },
    selectedCompany() {
      console.log(this.selectedCompany);
    },
    // shipment: {
    //   handler: function(newValue, oldValue) {
    //     console.log(newValue);
    //   },
    //   deep: true
    // },
    dialog() {
      // console.log(this.currentModel);
    },
    showVisualInventory() {
      if (!this.showVisualInventory) {
        this.currentModel.inventory = this.shipment.inventory;
        if (this.$root.customerId || this.onsiteEstimate) {
          this.formKey = !this.formKey;
          this.panelIndex = 3;
          // this.showPanel({ text: "inventory" });
        }
        // this.formKey = !this.formKey;
      }

      // else {
      //   if (this.$root.customerId || this.onsiteEstimate) {
      //     this.panelIndex = -1;
      //     this.formKey = !this.formKey;
      //     this.panelIndex = 3;
      //   }
      // }
    },
    panelIndex() {
      // this.submit();
      this.updateTitles();

      if (this.panelIndex == undefined && this.$vuetify.breakpoint.lgAndUp && !this.$root.customerId) {
        this.showPanel(this.defaultDialog);
      }
    }
  }
};
</script>

<style lang="css" scoped>
.main-panel {
  overflow-y: auto;
  overflow-x: hidden;
}

.panel {
  /* height: 65vh; */
  overflow-y: auto;
  background: #ffffff;
  box-shadow: -4px 0 8px rgba(0, 0, 0, 0.1);
  /* position: absolute; */
  /* top: 0;
  right: 0;*/
}

.service-type {
  text-transform: uppercase;
  background-color: yellow;
  font-size: small;
}

.panel-form {
  /* height: 100%; */
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
}

.close-btn {
  /* position: absolute;
  right: 0;
  top: 0; */
}

/*
.slide-panel-enter-active,
.slide-panel-leave-active {
  transition: transform 0.3s ease;
}

.slide-panel-enter {
  transform: translateX(100%);
}

.slide-panel-leave-to {
  transform: translateX(100%);
}
  */
/* .fade-transition-enter-active,
.fade-transition-leave-active {
  transition: opacity 0.3s ease !important;
}

.fade-transition-enter,
.fade-transition-leave-to {
  opacity: 0 !important;
  transform: none !important;
} */

.blurred {
  filter: blur(4px);
  /* Apply blur effect */
  pointer-events: none;
  /* Prevent interactions with blurred content */
  position: relative;
  /* Ensure the child pseudo-element is positioned correctly */
}

.blurred::after {
  content: "LOADING";
  /* Add the large LOADING text */
  position: absolute;
  /* Position the text over the blurred content */
  top: 50%;
  /* Center vertically */
  left: 50%;
  /* Center horizontally */
  transform: translate(-50%, -50%);
  /* Center the text */
  font-size: 48px;
  /* Set a large font size */
  font-weight: bold;
  /* Make it bold */
  color: rgba(255, 255, 255, 0.8);
  /* White with slight transparency */
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  /* Add a shadow for better visibility */
  z-index: 100;
  /* Ensure it appears above the content */
  pointer-events: none;
  /* Prevent interactions with the text */
}

.spinner {
  position: absolute;
  /* Overlay spinner on top of content */
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: 6px solid rgba(0, 0, 0, 0.1);
  /* Spinner border */
  border-top: 6px solid #3498db;
  /* Spinner highlight */
  border-radius: 50%;
  /* Make it circular */
  width: 40px;
  /* Spinner size */
  height: 40px;
  animation: spin 1s linear infinite;
  /* Spinning animation */
}

.highlight {
  font-weight: bold;
  font-size: larger;

  /* color: blue; */
}

/* .v-item--active .v-btn__content {
  color: cornflowerblue !important;
} */

.v-expansion-panel-header {
  min-height: inherit !important;
  height: 60px !important;
}

.v-expansion-panel-header .col {
  /* color: cornflowerblue; */
  /* text-decoration: underline; */
}

.v-expansion-panel-header .col-1 {
  /* color: cornflowerblue; */
  /* text-decoration: underline; */
  /* width: 10px !important;
  overflow: hidden; */
}

/* .v-expansion-panel-header .v-btn__content {
  color: cornflowerblue;
} */
.v-expansion-panel-content {
  padding: 16px !important;
}

.info-label {
  text-transform: none !important;
  font-weight: normal !important;
  color: #616161;

  /* font-size: smaller; */
}

.mobile-title {
  text-transform: uppercase;
  font-weight: bold;
  text-align: center;
}

.item-title {
  /* text-transform: none !important; */
  /* font-size: larger; */
  color: black;
}

.info-icon {
  height: 50px;
}

.info-title {
  /*
font-size: larger;
  font-weight: normal !important; */
}

.shipment-actions {
  /* background-color: #ffffff; */
  /* width: 100%; */
  position: fixed;
  bottom: 40px;
  z-index: 1000;
  /* right:0 */
}

.dialog {
  background: white;
  height: 100vw;
  /* width: 100vh; */
  overflow-y: auto;
  overflow-x: hidden;
}

.toolbar-dialog {
  /* position: fixed;
  top: 10px;
  right: 10px;
  background-color: transparent; */
}

.custom-round-button {
  width: 60px;
  /* Custom width */
  height: 60px;
  /* Custom height */
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.truncate {
  width: 400px;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  /* Ensures long words break to fit the container */
  text-align: left;
}

/* @media only screen and (min-width: 900px) { */
.bottom-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}

.float-container {
  margin-left: 56px;
  /* display: block;
    float: left; */
  /* max-width: 40vw; */
  /* Apply max-width here */
}

.shipment-title {
  white-space: nowrap;
  text-transform: uppercase;
  /* font-size: 12px !important; */
}

.shipment-title span {
  font-size: 12px !important;
}

@media only screen and (max-width: 450px) {
  .v-expansion-panel {
  }
  .main-panel {
    width: 100vh;
    overflow-x: hidden;
  }

  .item-title {
    margin-top: -8px;
    margin-left: 6px;
    font-size: 16px;
    /* width: 30vw; */
    /* word-wrap: break-word; */
    white-space: normal;
    float: left;
    text-align: left;
  }

  .float-container {
    margin-left: 24px;
    margin-top: -8px;
    /* display: block; */
    /* float: left; */
    /* max-width: 40vw; */
    /* Apply max-width here */
  }

  .info-label {
    word-wrap: break-word;
    /* Break long words onto the next line */
    white-space: normal;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    /* Limits text to 3 lines */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-align: left;
    font-size: smaller;
    text-overflow: ellipsis;
    /* Add this line */
  }

  /* .shipment-actions {

  bottom: 20px;

} */
  .avatar {
    width: 40px !important;
    /* default v-avatar size */
    height: 40px !important;
  }

  .dense-tabs .v-tab {
    padding: 0 8px !important;
    /* smaller horizontal padding */
    height: 32px !important;
    /* smaller height */
    min-width: 0 !important;
    /* removes minimum width */
    font-size: 12px !important;
    /* smaller text */
  }

  .truncate {
    max-width: 140px;
    overflow: visible;
    /* Let the content expand without truncating or scrolling */
    word-wrap: break-word;
    /* Break long words onto the next line */
    white-space: normal;
    /* Allow text to wrap naturally */
    text-align: left;
    /* Align text to the left */
  }

  .video-dialog {
    height: 100vh;
    background-color: white;
    z-index: 100;
  }
}
</style>
